webpackJsonp([1],{

/***/ "+FQu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+Gld":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Utilities',
	data: function data() {
		return {};
	}
});

/***/ }),

/***/ "+vjp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_my_dropdown_vue__ = __webpack_require__("ZISC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_75ed0f25_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_vue_my_dropdown_vue__ = __webpack_require__("0i1y");
function injectStyle (ssrContext) {
  __webpack_require__("BW7l")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_my_dropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_75ed0f25_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_vue_my_dropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/hJO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Calculator',
  data: function data() {
    return {
      formula: "",
      result: 0
    };
  },


  methods: {
    operate: function operate(element) {
      console.log("operate..");
      this.formula += element;
      // console.log("this.formula:");
      // console.log(this.formula);
    },
    equal: function equal() {
      console.log("equal..");
      this.result = eval(this.formula);
      // console.log("this.formula:");
      // console.log(this.formula);
    },
    cleanResult: function cleanResult() {
      console.log("cleanResult..");
      this.result = 0;
    },
    cleanAll: function cleanAll() {
      console.log("cleanAll..");
      this.formula = "";
      this.result = 0;
    },
    drop: function drop() {
      console.log("drop..");
      this.formula = this.formula.slice(0, -1);
    },
    square: function square() {
      console.log("square..");
      console.log(eval(this.formula));
      eval(this.formula) < 0 ? this.formula = "Cannot square the negative value" : this.result = Math.sqrt(eval(this.formula));
    },
    devided: function devided() {

      this.formula === "" || this.formula.endsWith("+" || "-" || "*" || "/" || "%") ? {} : this.formula = "1/(" + this.formula + ")";this.equal();
    },
    toggle: function toggle() {
      console.log("toggle..");

      this.formula === "" || this.formula.endsWith("+" || "-" || "*" || "/" || "%") ? {} : this.formula.startsWith("-") ? this.formula = Math.abs(eval(this.formula)).toString() : this.formula = "-(" + this.formula + ")";
      this.equal();
    }
  }
});

/***/ }),

/***/ "0DkH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PackageView_vue__ = __webpack_require__("b+Dw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_143005d5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PackageView_vue__ = __webpack_require__("JKmw");
function injectStyle (ssrContext) {
  __webpack_require__("O0lw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-143005d5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PackageView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_143005d5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PackageView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0i1y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',[_vm._t("default")],2),_vm._v(" "),_c('transition',{attrs:{"name":_vm.animation}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"my-dropdown-dd",style:(_vm.ddStyle)},[_vm._t("dropdown")],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "10qD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CalculatorComponent_vue__ = __webpack_require__("/hJO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38935b06_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CalculatorComponent_vue__ = __webpack_require__("4Vb8");
function injectStyle (ssrContext) {
  __webpack_require__("UVF8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-38935b06"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CalculatorComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38935b06_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CalculatorComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1UYJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?[_c('Loader')]:[(_vm.is_counselling_accessible)?[_c('div',{staticClass:"nav"},[_c('div',{on:{"click":function($event){return _vm.setActiveTab(0)}}},[_c('h5',{class:{active:(_vm.active_tab == 0 || _vm.completed_tabs.indexOf(0) != -1)}},[_vm._v("Background "+_vm._s(_vm.completed_tabs.indexOf(0) == -1 ? '' : '✓'))])]),_vm._v(" "),_c('div',{on:{"click":function($event){return _vm.setActiveTab(1)}}},[_c('h5',{class:{active:(_vm.active_tab == 1 || _vm.completed_tabs.indexOf(1) != -1)}},[_vm._v("Academics "+_vm._s(_vm.completed_tabs.indexOf(1) == -1 ? '' : '✓'))])]),_vm._v(" "),_c('div',{on:{"click":function($event){return _vm.setActiveTab(2)}}},[_c('h5',{class:{active:(_vm.active_tab == 2 || _vm.completed_tabs.indexOf(2) != -1)}},[_vm._v("Work Experience "+_vm._s(_vm.completed_tabs.indexOf(2) == -1 ? '' : '✓'))])]),_vm._v(" "),_c('div',{on:{"click":function($event){return _vm.setActiveTab(3)}}},[_c('h5',{class:{active:(_vm.active_tab == 3 || _vm.completed_tabs.indexOf(3) != -1)}},[_vm._v("Activities/Interests "+_vm._s(_vm.completed_tabs.indexOf(3) == -1 ? '' : '✓'))])]),_vm._v(" "),_c('div',{on:{"click":function($event){return _vm.setActiveTab(4)}}},[_c('h5',{class:{active:(_vm.active_tab == 4 || _vm.completed_tabs.indexOf(4) != -1)}},[_vm._v("Guidance "+_vm._s(_vm.completed_tabs.indexOf(4) == -1 ? '' : '✓'))])])]),_vm._v(" "),_c('div',{staticClass:"content"},[(_vm.active_tab==0)?[_c('div',[_c('h4',{staticClass:"content-title"},[_vm._v(_vm._s(_vm.tabs[0]))]),_vm._v(" "),_c('div',{staticClass:"info_wrapper"},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticClass:"mobile-no-padding",attrs:{"sm":"12","lg":"3"}},[_c('div',{staticClass:"input-wrapper"},[_c('label',[_vm._v("Full Name")]),_vm._v(" "),_c('b-form-input',{attrs:{"id":"exampleInput1","type":"text","disabled":"","placeholder":"Your Full Name"},model:{value:(_vm.user_info.full_name),callback:function ($$v) {_vm.$set(_vm.user_info, "full_name", $$v)},expression:"user_info.full_name"}})],1)])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mobile-no-padding",attrs:{"sm":"12","lg":"3"}},[_c('div',{staticClass:"input-wrapper"},[_c('label',[_vm._v("Gender")]),_vm._v(" "),_c('b-form-input',{attrs:{"disabled":""},model:{value:(_vm.user_info.gender),callback:function ($$v) {_vm.$set(_vm.user_info, "gender", $$v)},expression:"user_info.gender"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"sm":"12","lg":"3"}},[_c('div',{staticClass:"input-wrapper"},[_c('label',[_vm._v("Your Birthday")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date","disabled":"","value":_vm.user_birth_date}})],1)])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mobile-no-padding",attrs:{"sm":"12","lg":"7"}},[_c('div',{staticClass:"input-wrapper"},[_c('label',[_vm._v("Father's Name")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text"},model:{value:(_vm.form.background.fathers_name),callback:function ($$v) {_vm.$set(_vm.form.background, "fathers_name", $$v)},expression:"form.background.fathers_name"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"sm":"12","lg":"5"}},[_c('div',{staticClass:"input-wrapper"},[_c('label',[_vm._v("Occupation")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text"},model:{value:(_vm.form.background.fathers_occupation),callback:function ($$v) {_vm.$set(_vm.form.background, "fathers_occupation", $$v)},expression:"form.background.fathers_occupation"}})],1)])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mobile-no-padding",attrs:{"sm":"12","lg":"7"}},[_c('div',{staticClass:"input-wrapper"},[_c('label',[_vm._v("Mother's Name")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text"},model:{value:(_vm.form.background.mothers_name),callback:function ($$v) {_vm.$set(_vm.form.background, "mothers_name", $$v)},expression:"form.background.mothers_name"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"sm":"12","lg":"5"}},[_c('div',{staticClass:"input-wrapper"},[_c('label',[_vm._v("Occupation")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text"},model:{value:(_vm.form.background.mothers_occupation),callback:function ($$v) {_vm.$set(_vm.form.background, "mothers_occupation", $$v)},expression:"form.background.mothers_occupation"}})],1)])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mobile-no-padding",attrs:{"sm":"12","lg":"12"}},[_c('div',{staticClass:"input-wrapper"},[_c('label',[_vm._v("Permanent Address")]),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mobile-no-padding",attrs:{"sm":"12","md":"6","lg":"3"}},[_c('b-form-input',{attrs:{"type":"text","placeholder":"Country"},model:{value:(_vm.form.background.permanent_address.country),callback:function ($$v) {_vm.$set(_vm.form.background.permanent_address, "country", $$v)},expression:"form.background.permanent_address.country"}})],1),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"sm":"12","md":"6","lg":"3"}},[_c('b-form-input',{attrs:{"type":"text","placeholder":"State"},model:{value:(_vm.form.background.permanent_address.state),callback:function ($$v) {_vm.$set(_vm.form.background.permanent_address, "state", $$v)},expression:"form.background.permanent_address.state"}})],1),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"sm":"12","md":"6","lg":"3"}},[_c('b-form-input',{attrs:{"type":"text","placeholder":"City"},model:{value:(_vm.form.background.permanent_address.city),callback:function ($$v) {_vm.$set(_vm.form.background.permanent_address, "city", $$v)},expression:"form.background.permanent_address.city"}})],1),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"sm":"12","md":"6","lg":"3"}},[_c('b-form-input',{attrs:{"type":"number","placeholder":"Postal Code"},model:{value:(_vm.form.background.permanent_address.postal_code),callback:function ($$v) {_vm.$set(_vm.form.background.permanent_address, "postal_code", $$v)},expression:"form.background.permanent_address.postal_code"}})],1),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",staticStyle:{"margin-top":"10px"},attrs:{"sm":"12","md":"12","lg":"12"}},[_c('b-form-textarea',{attrs:{"rows":"5","placeholder":"Address Line"},model:{value:(_vm.form.background.permanent_address.address_line),callback:function ($$v) {_vm.$set(_vm.form.background.permanent_address, "address_line", $$v)},expression:"form.background.permanent_address.address_line"}})],1)],1)],1)])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mobile-no-padding",attrs:{"sm":"12","lg":"12"}},[_c('div',{staticClass:"input-wrapper"},[_c('label',[_vm._v("Mailing Address")]),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mobile-no-padding",attrs:{"sm":"12","md":"6","lg":"3"}},[_c('b-form-input',{attrs:{"type":"text","placeholder":"Country"},model:{value:(_vm.form.background.mailing_address.country),callback:function ($$v) {_vm.$set(_vm.form.background.mailing_address, "country", $$v)},expression:"form.background.mailing_address.country"}})],1),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"sm":"12","md":"6","lg":"3"}},[_c('b-form-input',{attrs:{"type":"text","placeholder":"State"},model:{value:(_vm.form.background.mailing_address.state),callback:function ($$v) {_vm.$set(_vm.form.background.mailing_address, "state", $$v)},expression:"form.background.mailing_address.state"}})],1),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"sm":"12","md":"6","lg":"3"}},[_c('b-form-input',{attrs:{"type":"text","placeholder":"City"},model:{value:(_vm.form.background.mailing_address.city),callback:function ($$v) {_vm.$set(_vm.form.background.mailing_address, "city", $$v)},expression:"form.background.mailing_address.city"}})],1),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"sm":"12","md":"6","lg":"3"}},[_c('b-form-input',{attrs:{"type":"number","placeholder":"Postal Code"},model:{value:(_vm.form.background.mailing_address.postal_code),callback:function ($$v) {_vm.$set(_vm.form.background.mailing_address, "postal_code", $$v)},expression:"form.background.mailing_address.postal_code"}})],1),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",staticStyle:{"margin-top":"10px"},attrs:{"sm":"12","md":"12","lg":"12"}},[_c('b-form-textarea',{attrs:{"rows":"5","placeholder":"Address Line"},model:{value:(_vm.form.background.mailing_address.address_line),callback:function ($$v) {_vm.$set(_vm.form.background.mailing_address, "address_line", $$v)},expression:"form.background.mailing_address.address_line"}})],1)],1)],1)])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mobile-no-padding",attrs:{"sm":"12","lg":"12"}},[_c('div',{staticClass:"input-wrapper"},[_c('label',[_vm._v("Primary Phone")]),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mobile-no-padding",attrs:{"sm":"12","md":"6","lg":"3"}},[_c('b-form-input',{attrs:{"type":"text","placeholder":"Phone Type"},model:{value:(_vm.form.background.primary_phone.phone_type),callback:function ($$v) {_vm.$set(_vm.form.background.primary_phone, "phone_type", $$v)},expression:"form.background.primary_phone.phone_type"}})],1),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"sm":"12","md":"6","lg":"3"}},[_c('b-form-input',{attrs:{"type":"text","placeholder":"Country Code"},model:{value:(_vm.form.background.primary_phone.country_code),callback:function ($$v) {_vm.$set(_vm.form.background.primary_phone, "country_code", $$v)},expression:"form.background.primary_phone.country_code"}})],1),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"sm":"12","md":"6","lg":"3"}},[_c('b-form-input',{attrs:{"type":"text","placeholder":"Phone No."},model:{value:(_vm.form.background.primary_phone.phone_no),callback:function ($$v) {_vm.$set(_vm.form.background.primary_phone, "phone_no", $$v)},expression:"form.background.primary_phone.phone_no"}})],1)],1)],1)])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mobile-no-padding",attrs:{"sm":"12","lg":"12"}},[_c('div',{staticClass:"input-wrapper"},[_c('label',[_vm._v("Alternate Phone")]),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mobile-no-padding",attrs:{"sm":"12","md":"6","lg":"3"}},[_c('b-form-input',{attrs:{"type":"text","placeholder":"Phone Type"},model:{value:(_vm.form.background.alternate_phone.phone_type),callback:function ($$v) {_vm.$set(_vm.form.background.alternate_phone, "phone_type", $$v)},expression:"form.background.alternate_phone.phone_type"}})],1),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"sm":"12","md":"6","lg":"3"}},[_c('b-form-input',{attrs:{"type":"text","placeholder":"Country Code"},model:{value:(_vm.form.background.alternate_phone.country_code),callback:function ($$v) {_vm.$set(_vm.form.background.alternate_phone, "country_code", $$v)},expression:"form.background.alternate_phone.country_code"}})],1),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"sm":"12","md":"6","lg":"3"}},[_c('b-form-input',{attrs:{"type":"text","placeholder":"Phone No."},model:{value:(_vm.form.background.alternate_phone.phone_no),callback:function ($$v) {_vm.$set(_vm.form.background.alternate_phone, "phone_no", $$v)},expression:"form.background.alternate_phone.phone_no"}})],1)],1)],1)])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mobile-no-padding",attrs:{"sm":"12","lg":"12"}},[_c('div',{staticClass:"input-wrapper"},[_c('label',[_vm._v("Languages Known")]),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"6","sm":"4","md":"6","lg":"3"}},[_c('b-form-input',{attrs:{"type":"text","placeholder":"Language"},model:{value:(_vm.form.background.languages_known[0].language),callback:function ($$v) {_vm.$set(_vm.form.background.languages_known[0], "language", $$v)},expression:"form.background.languages_known[0].language"}})],1),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"6","sm":"8","md":"6","lg":"3"}},[_c('b-form-input',{attrs:{"type":"text","placeholder":"Proficiency"},model:{value:(_vm.form.background.languages_known[0].proficiency),callback:function ($$v) {_vm.$set(_vm.form.background.languages_known[0], "proficiency", $$v)},expression:"form.background.languages_known[0].proficiency"}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"6","sm":"6","md":"6","lg":"3"}},[_c('b-form-input',{attrs:{"type":"text","placeholder":"Language"},model:{value:(_vm.form.background.languages_known[1].language),callback:function ($$v) {_vm.$set(_vm.form.background.languages_known[1], "language", $$v)},expression:"form.background.languages_known[1].language"}})],1),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"6","sm":"6","md":"6","lg":"3"}},[_c('b-form-input',{attrs:{"type":"text","placeholder":"Proficiency"},model:{value:(_vm.form.background.languages_known[1].proficiency),callback:function ($$v) {_vm.$set(_vm.form.background.languages_known[1], "proficiency", $$v)},expression:"form.background.languages_known[1].proficiency"}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"6","sm":"6","md":"6","lg":"3"}},[_c('b-form-input',{attrs:{"type":"text","placeholder":"Language"},model:{value:(_vm.form.background.languages_known[2].language),callback:function ($$v) {_vm.$set(_vm.form.background.languages_known[2], "language", $$v)},expression:"form.background.languages_known[2].language"}})],1),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"6","sm":"6","md":"6","lg":"3"}},[_c('b-form-input',{attrs:{"type":"text","placeholder":"Proficiency"},model:{value:(_vm.form.background.languages_known[2].proficiency),callback:function ($$v) {_vm.$set(_vm.form.background.languages_known[2], "proficiency", $$v)},expression:"form.background.languages_known[2].proficiency"}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"6","sm":"6","md":"6","lg":"3"}},[_c('b-form-input',{attrs:{"type":"text","placeholder":"Language"},model:{value:(_vm.form.background.languages_known[3].language),callback:function ($$v) {_vm.$set(_vm.form.background.languages_known[3], "language", $$v)},expression:"form.background.languages_known[3].language"}})],1),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"6","sm":"6","md":"6","lg":"3"}},[_c('b-form-input',{attrs:{"type":"text","placeholder":"Proficiency"},model:{value:(_vm.form.background.languages_known[3].proficiency),callback:function ($$v) {_vm.$set(_vm.form.background.languages_known[3], "proficiency", $$v)},expression:"form.background.languages_known[3].proficiency"}})],1)],1)],1)])],1)],1)],1)])]:_vm._e(),_vm._v(" "),(_vm.active_tab==1)?[_c('div',[_c('h4',{staticClass:"content-title"},[_vm._v(_vm._s(_vm.tabs[1]))]),_vm._v(" "),_c('div',{staticClass:"info_wrapper"},[_c('b-container',{attrs:{"fluid":""}},[_c('label',[_vm._v("Secondary School (High School)")]),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"8"}},[_c('div',{staticClass:"input-wrapper"},[_c('b-form-input',{attrs:{"type":"text","placeholder":"Secondary School Name"},model:{value:(_vm.form.academics.high_school.name),callback:function ($$v) {_vm.$set(_vm.form.academics.high_school, "name", $$v)},expression:"form.academics.high_school.name"}})],1)])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"8"}},[_c('div',{staticClass:"input-wrapper"},[_c('b-form-input',{attrs:{"type":"text","placeholder":"Address"},model:{value:(_vm.form.academics.high_school.address),callback:function ($$v) {_vm.$set(_vm.form.academics.high_school, "address", $$v)},expression:"form.academics.high_school.address"}})],1)])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"3"}},[_c('div',{staticClass:"input-wrapper"},[_c('b-form-input',{attrs:{"type":"number","placeholder":"Start Year"},model:{value:(_vm.form.academics.high_school.start_year),callback:function ($$v) {_vm.$set(_vm.form.academics.high_school, "start_year", $$v)},expression:"form.academics.high_school.start_year"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"3"}},[_c('div',{staticClass:"input-wrapper"},[_c('b-form-input',{attrs:{"type":"number","placeholder":"End Year"},model:{value:(_vm.form.academics.high_school.end_year),callback:function ($$v) {_vm.$set(_vm.form.academics.high_school, "end_year", $$v)},expression:"form.academics.high_school.end_year"}})],1)])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"3"}},[_c('div',{staticClass:"input-wrapper"},[_c('b-form-input',{attrs:{"type":"number","placeholder":"Max. Marks"},model:{value:(_vm.form.academics.high_school.max_marks),callback:function ($$v) {_vm.$set(_vm.form.academics.high_school, "max_marks", $$v)},expression:"form.academics.high_school.max_marks"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"3"}},[_c('div',{staticClass:"input-wrapper"},[_c('b-form-input',{attrs:{"type":"number","placeholder":"Marks Obtained"},model:{value:(_vm.form.academics.high_school.marks_obtained),callback:function ($$v) {_vm.$set(_vm.form.academics.high_school, "marks_obtained", $$v)},expression:"form.academics.high_school.marks_obtained"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"3"}},[_c('div',{staticClass:"input-wrapper"},[_c('b-form-input',{attrs:{"type":"number","placeholder":"Percentage"},model:{value:(_vm.form.academics.high_school.percentage),callback:function ($$v) {_vm.$set(_vm.form.academics.high_school, "percentage", $$v)},expression:"form.academics.high_school.percentage"}})],1)])],1)],1),_vm._v(" "),_c('label',[_vm._v("University/College Granting First (Bachelor's) Degree")]),_vm._v(" "),_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"8"}},[_c('div',{staticClass:"input-wrapper"},[_c('b-form-input',{attrs:{"type":"text","placeholder":"University/College Name"},model:{value:(_vm.form.academics.university.name),callback:function ($$v) {_vm.$set(_vm.form.academics.university, "name", $$v)},expression:"form.academics.university.name"}})],1)])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"8"}},[_c('div',{staticClass:"input-wrapper"},[_c('b-form-input',{attrs:{"type":"text","placeholder":"Address"},model:{value:(_vm.form.academics.university.address),callback:function ($$v) {_vm.$set(_vm.form.academics.university, "address", $$v)},expression:"form.academics.university.address"}})],1)])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"3"}},[_c('div',{staticClass:"input-wrapper"},[_c('b-form-input',{attrs:{"type":"number","placeholder":"Start Year"},model:{value:(_vm.form.academics.university.start_year),callback:function ($$v) {_vm.$set(_vm.form.academics.university, "start_year", $$v)},expression:"form.academics.university.start_year"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"3"}},[_c('div',{staticClass:"input-wrapper"},[_c('b-form-input',{attrs:{"type":"number","placeholder":"End Year"},model:{value:(_vm.form.academics.university.end_year),callback:function ($$v) {_vm.$set(_vm.form.academics.university, "end_year", $$v)},expression:"form.academics.university.end_year"}})],1)])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"3"}},[_c('div',{staticClass:"input-wrapper"},[_c('b-form-input',{attrs:{"type":"text","placeholder":"Stream"},model:{value:(_vm.form.academics.university.stream),callback:function ($$v) {_vm.$set(_vm.form.academics.university, "stream", $$v)},expression:"form.academics.university.stream"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"3"}},[_c('div',{staticClass:"input-wrapper"},[_c('b-form-input',{attrs:{"type":"text","placeholder":"Degree"},model:{value:(_vm.form.academics.university.degree),callback:function ($$v) {_vm.$set(_vm.form.academics.university, "degree", $$v)},expression:"form.academics.university.degree"}})],1)])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"3"}},[_c('div',{staticClass:"input-wrapper"},[_c('b-form-input',{attrs:{"type":"number","placeholder":"Max. Marks"},model:{value:(_vm.form.academics.university.max_marks),callback:function ($$v) {_vm.$set(_vm.form.academics.university, "max_marks", $$v)},expression:"form.academics.university.max_marks"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"3"}},[_c('div',{staticClass:"input-wrapper"},[_c('b-form-input',{attrs:{"type":"number","placeholder":"Marks Obtained"},model:{value:(_vm.form.academics.university.marks_obtained),callback:function ($$v) {_vm.$set(_vm.form.academics.university, "marks_obtained", $$v)},expression:"form.academics.university.marks_obtained"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"3"}},[_c('div',{staticClass:"input-wrapper"},[_c('b-form-input',{attrs:{"type":"number","placeholder":"Percentage"},model:{value:(_vm.form.academics.university.percentage),callback:function ($$v) {_vm.$set(_vm.form.academics.university, "percentage", $$v)},expression:"form.academics.university.percentage"}})],1)])],1),_vm._v(" "),_c('label',[_vm._v("GPA")]),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"3"}},[_c('div',{staticClass:"input-wrapper"},[_c('b-form-input',{attrs:{"type":"number","placeholder":"Scale"},model:{value:(_vm.form.academics.university.gpa.scale),callback:function ($$v) {_vm.$set(_vm.form.academics.university.gpa, "scale", $$v)},expression:"form.academics.university.gpa.scale"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"3"}},[_c('div',{staticClass:"input-wrapper"},[_c('b-form-input',{attrs:{"type":"number","placeholder":"Cumulative"},model:{value:(_vm.form.academics.university.gpa.cumulative),callback:function ($$v) {_vm.$set(_vm.form.academics.university.gpa, "cumulative", $$v)},expression:"form.academics.university.gpa.cumulative"}})],1)])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"3"}},[_c('div',{staticClass:"input-wrapper"},[_c('b-form-input',{attrs:{"type":"number","placeholder":"First Year"},model:{value:(_vm.form.academics.university.gpa.first_year),callback:function ($$v) {_vm.$set(_vm.form.academics.university.gpa, "first_year", $$v)},expression:"form.academics.university.gpa.first_year"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"3"}},[_c('div',{staticClass:"input-wrapper"},[_c('b-form-input',{attrs:{"type":"number","placeholder":"Second Year"},model:{value:(_vm.form.academics.university.gpa.second_year),callback:function ($$v) {_vm.$set(_vm.form.academics.university.gpa, "second_year", $$v)},expression:"form.academics.university.gpa.second_year"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"3"}},[_c('div',{staticClass:"input-wrapper"},[_c('b-form-input',{attrs:{"type":"number","placeholder":"Third Year"},model:{value:(_vm.form.academics.university.gpa.third_year),callback:function ($$v) {_vm.$set(_vm.form.academics.university.gpa, "third_year", $$v)},expression:"form.academics.university.gpa.third_year"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"3"}},[_c('div',{staticClass:"input-wrapper"},[_c('b-form-input',{attrs:{"type":"number","placeholder":"Fourth Year"},model:{value:(_vm.form.academics.university.gpa.fourth_year),callback:function ($$v) {_vm.$set(_vm.form.academics.university.gpa, "fourth_year", $$v)},expression:"form.academics.university.gpa.fourth_year"}})],1)])],1),_vm._v(" "),_c('label',[_vm._v("Professional Certification/Course")]),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"8"}},[_c('div',{staticClass:"input-wrapper"},[_c('b-form-input',{attrs:{"type":"text","placeholder":"Institute Name"},model:{value:(_vm.form.academics.professional_certification.institute_name),callback:function ($$v) {_vm.$set(_vm.form.academics.professional_certification, "institute_name", $$v)},expression:"form.academics.professional_certification.institute_name"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"8"}},[_c('div',{staticClass:"input-wrapper"},[_c('b-form-input',{attrs:{"type":"text","placeholder":"Institute Address"},model:{value:(_vm.form.academics.professional_certification.institute_address),callback:function ($$v) {_vm.$set(_vm.form.academics.professional_certification, "institute_address", $$v)},expression:"form.academics.professional_certification.institute_address"}})],1)])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"3"}},[_c('div',{staticClass:"input-wrapper"},[_c('b-form-input',{attrs:{"type":"number","placeholder":"Start Year"},model:{value:(_vm.form.academics.professional_certification.start_year),callback:function ($$v) {_vm.$set(_vm.form.academics.professional_certification, "start_year", $$v)},expression:"form.academics.professional_certification.start_year"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"3"}},[_c('div',{staticClass:"input-wrapper"},[_c('b-form-input',{attrs:{"type":"number","placeholder":"End Year"},model:{value:(_vm.form.academics.professional_certification.end_year),callback:function ($$v) {_vm.$set(_vm.form.academics.professional_certification, "end_year", $$v)},expression:"form.academics.professional_certification.end_year"}})],1)])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"3"}},[_c('div',{staticClass:"input-wrapper"},[_c('b-form-input',{attrs:{"type":"text","placeholder":"Stream"},model:{value:(_vm.form.academics.professional_certification.stream),callback:function ($$v) {_vm.$set(_vm.form.academics.professional_certification, "stream", $$v)},expression:"form.academics.professional_certification.stream"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"3"}},[_c('div',{staticClass:"input-wrapper"},[_c('b-form-input',{attrs:{"type":"text","placeholder":"Degree"},model:{value:(_vm.form.academics.professional_certification.degree),callback:function ($$v) {_vm.$set(_vm.form.academics.professional_certification, "degree", $$v)},expression:"form.academics.professional_certification.degree"}})],1)])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"3"}},[_c('div',{staticClass:"input-wrapper"},[_c('b-form-input',{attrs:{"type":"number","placeholder":"Level/Paper (Last Pass)"},model:{value:(_vm.form.academics.professional_certification.level),callback:function ($$v) {_vm.$set(_vm.form.academics.professional_certification, "level", $$v)},expression:"form.academics.professional_certification.level"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"3"}},[_c('div',{staticClass:"input-wrapper"},[_c('b-form-input',{attrs:{"type":"number","placeholder":"Max. Marks"},model:{value:(_vm.form.academics.professional_certification.max_marks),callback:function ($$v) {_vm.$set(_vm.form.academics.professional_certification, "max_marks", $$v)},expression:"form.academics.professional_certification.max_marks"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"3"}},[_c('div',{staticClass:"input-wrapper"},[_c('b-form-input',{attrs:{"type":"number","placeholder":"Marks Obtained"},model:{value:(_vm.form.academics.professional_certification.marks_obtained),callback:function ($$v) {_vm.$set(_vm.form.academics.professional_certification, "marks_obtained", $$v)},expression:"form.academics.professional_certification.marks_obtained"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"3"}},[_c('div',{staticClass:"input-wrapper"},[_c('b-form-input',{attrs:{"type":"number","placeholder":"Percentage"},model:{value:(_vm.form.academics.professional_certification.percentage),callback:function ($$v) {_vm.$set(_vm.form.academics.professional_certification, "percentage", $$v)},expression:"form.academics.professional_certification.percentage"}})],1)])],1),_vm._v(" "),_c('label',[_vm._v("Test Scores")]),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"8"}},[_c('div',{staticClass:"input-wrapper"},[_c('b-form-input',{attrs:{"type":"text","placeholder":"Name of Entrance Exam"},model:{value:(_vm.form.academics.test_scores.name),callback:function ($$v) {_vm.$set(_vm.form.academics.test_scores, "name", $$v)},expression:"form.academics.test_scores.name"}})],1)])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"3"}},[_c('div',{staticClass:"input-wrapper"},[_c('b-form-input',{attrs:{"type":"number","placeholder":"Quant"},model:{value:(_vm.form.academics.test_scores.quant),callback:function ($$v) {_vm.$set(_vm.form.academics.test_scores, "quant", $$v)},expression:"form.academics.test_scores.quant"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"3"}},[_c('div',{staticClass:"input-wrapper"},[_c('b-form-input',{attrs:{"type":"number","placeholder":"Verbal"},model:{value:(_vm.form.academics.test_scores.verbal),callback:function ($$v) {_vm.$set(_vm.form.academics.test_scores, "verbal", $$v)},expression:"form.academics.test_scores.verbal"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"3"}},[_c('div',{staticClass:"input-wrapper"},[_c('b-form-input',{attrs:{"type":"number","placeholder":"Logic"},model:{value:(_vm.form.academics.test_scores.logic),callback:function ($$v) {_vm.$set(_vm.form.academics.test_scores, "logic", $$v)},expression:"form.academics.test_scores.logic"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"3"}},[_c('div',{staticClass:"input-wrapper"},[_c('b-form-input',{attrs:{"type":"number","placeholder":"DI"},model:{value:(_vm.form.academics.test_scores.di),callback:function ($$v) {_vm.$set(_vm.form.academics.test_scores, "di", $$v)},expression:"form.academics.test_scores.di"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"3"}},[_c('div',{staticClass:"input-wrapper"},[_c('b-form-input',{attrs:{"type":"number","placeholder":"Other"},model:{value:(_vm.form.academics.test_scores.other),callback:function ($$v) {_vm.$set(_vm.form.academics.test_scores, "other", $$v)},expression:"form.academics.test_scores.other"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"3"}},[_c('div',{staticClass:"input-wrapper"},[_c('b-form-input',{attrs:{"type":"number","placeholder":"Total"},model:{value:(_vm.form.academics.test_scores.total),callback:function ($$v) {_vm.$set(_vm.form.academics.test_scores, "total", $$v)},expression:"form.academics.test_scores.total"}})],1)])],1)],1)],1)])]:_vm._e(),_vm._v(" "),(_vm.active_tab==2)?[_c('div',[_c('h4',{staticClass:"content-title"},[_vm._v(_vm._s(_vm.tabs[2]))]),_vm._v(" "),_c('div',{staticClass:"info_wrapper"},[_c('label',[_vm._v("Current Work Experience")]),_vm._v(" "),_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"8"}},[_c('b-form-input',{attrs:{"type":"text","placeholder":"Name of the Organization/Employer"},model:{value:(_vm.form.work_experience.current.name_of_organization),callback:function ($$v) {_vm.$set(_vm.form.work_experience.current, "name_of_organization", $$v)},expression:"form.work_experience.current.name_of_organization"}})],1),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"8"}},[_c('b-form-input',{attrs:{"type":"text","placeholder":"Industry"},model:{value:(_vm.form.work_experience.current.industry),callback:function ($$v) {_vm.$set(_vm.form.work_experience.current, "industry", $$v)},expression:"form.work_experience.current.industry"}})],1),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"8"}},[_c('b-form-input',{attrs:{"type":"text","placeholder":"Address"},model:{value:(_vm.form.work_experience.current.address),callback:function ($$v) {_vm.$set(_vm.form.work_experience.current, "address", $$v)},expression:"form.work_experience.current.address"}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"3"}},[_c('div',{staticClass:"input-wrapper"},[_c('b-form-input',{attrs:{"type":"number","placeholder":"Start Year"},model:{value:(_vm.form.work_experience.current.start_year),callback:function ($$v) {_vm.$set(_vm.form.work_experience.current, "start_year", $$v)},expression:"form.work_experience.current.start_year"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"3"}},[_c('div',{staticClass:"input-wrapper"},[_c('b-form-input',{attrs:{"type":"number","placeholder":"End Year"},model:{value:(_vm.form.work_experience.current.end_year),callback:function ($$v) {_vm.$set(_vm.form.work_experience.current, "end_year", $$v)},expression:"form.work_experience.current.end_year"}})],1)])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"3"}},[_c('div',{staticClass:"input-wrapper"},[_c('b-form-input',{attrs:{"type":"text","placeholder":"Designation"},model:{value:(_vm.form.work_experience.current.designation),callback:function ($$v) {_vm.$set(_vm.form.work_experience.current, "designation", $$v)},expression:"form.work_experience.current.designation"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"6"}},[_c('div',{staticClass:"input-wrapper"},[_c('b-form-input',{attrs:{"type":"text","placeholder":"Function"},model:{value:(_vm.form.work_experience.current.function),callback:function ($$v) {_vm.$set(_vm.form.work_experience.current, "function", $$v)},expression:"form.work_experience.current.function"}})],1)])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"3"}},[_c('div',{staticClass:"input-wrapper"},[_c('label',[_vm._v("Full time/ Part time")]),_vm._v(" "),_c('b-form-select',{attrs:{"placeholder":"Full time/ Part time"},model:{value:(_vm.form.work_experience.current.full_time),callback:function ($$v) {_vm.$set(_vm.form.work_experience.current, "full_time", $$v)},expression:"form.work_experience.current.full_time"}},[_c('option',{attrs:{"value":"full_time","selected":""}},[_vm._v("Full Time")]),_vm._v(" "),_c('option',{attrs:{"value":"part_time"}},[_vm._v("Part Time")])])],1)])],1)],1),_vm._v(" "),_c('label',[_vm._v("Past Work Experience")]),_vm._v(" "),_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"8"}},[_c('b-form-input',{attrs:{"type":"text","placeholder":"Name of the Organization/Employer"},model:{value:(_vm.form.work_experience.past.name_of_organization),callback:function ($$v) {_vm.$set(_vm.form.work_experience.past, "name_of_organization", $$v)},expression:"form.work_experience.past.name_of_organization"}})],1),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"8"}},[_c('b-form-input',{attrs:{"type":"text","placeholder":"Industry"},model:{value:(_vm.form.work_experience.past.industry),callback:function ($$v) {_vm.$set(_vm.form.work_experience.past, "industry", $$v)},expression:"form.work_experience.past.industry"}})],1),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"8"}},[_c('b-form-input',{attrs:{"type":"text","placeholder":"Address"},model:{value:(_vm.form.work_experience.past.address),callback:function ($$v) {_vm.$set(_vm.form.work_experience.past, "address", $$v)},expression:"form.work_experience.past.address"}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"3"}},[_c('div',{staticClass:"input-wrapper"},[_c('b-form-input',{attrs:{"type":"number","placeholder":"Start Year"},model:{value:(_vm.form.work_experience.past.start_year),callback:function ($$v) {_vm.$set(_vm.form.work_experience.past, "start_year", $$v)},expression:"form.work_experience.past.start_year"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"3"}},[_c('div',{staticClass:"input-wrapper"},[_c('b-form-input',{attrs:{"type":"number","placeholder":"End Year"},model:{value:(_vm.form.work_experience.past.end_year),callback:function ($$v) {_vm.$set(_vm.form.work_experience.past, "end_year", $$v)},expression:"form.work_experience.past.end_year"}})],1)])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"3"}},[_c('div',{staticClass:"input-wrapper"},[_c('b-form-input',{attrs:{"type":"text","placeholder":"Designation"},model:{value:(_vm.form.work_experience.past.designation),callback:function ($$v) {_vm.$set(_vm.form.work_experience.past, "designation", $$v)},expression:"form.work_experience.past.designation"}})],1)]),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"6"}},[_c('div',{staticClass:"input-wrapper"},[_c('b-form-input',{attrs:{"type":"text","placeholder":"Function"},model:{value:(_vm.form.work_experience.past.function),callback:function ($$v) {_vm.$set(_vm.form.work_experience.past, "function", $$v)},expression:"form.work_experience.past.function"}})],1)])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"3"}},[_c('div',{staticClass:"input-wrapper"},[_c('label',[_vm._v("Full time/ Part time")]),_vm._v(" "),_c('b-form-select',{attrs:{"placeholder":"Full time/ Part time"},model:{value:(_vm.form.work_experience.past.full_time),callback:function ($$v) {_vm.$set(_vm.form.work_experience.past, "full_time", $$v)},expression:"form.work_experience.past.full_time"}},[_c('option',{attrs:{"value":"full_time","selected":""}},[_vm._v("Full Time")]),_vm._v(" "),_c('option',{attrs:{"value":"part_time"}},[_vm._v("Part Time")])])],1)])],1)],1)],1)])]:_vm._e(),_vm._v(" "),(_vm.active_tab==3)?[_c('div',[_c('h4',{staticClass:"content-title"},[_vm._v(_vm._s(_vm.tabs[3]))]),_vm._v(" "),_c('div',{staticClass:"info_wrapper"},[_c('label',[_vm._v("Activities/Interests")]),_vm._v(" "),_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"8"}},[_c('b-form-input',{attrs:{"type":"text","placeholder":"Name"},model:{value:(_vm.form.activities_interests.activities.name),callback:function ($$v) {_vm.$set(_vm.form.activities_interests.activities, "name", $$v)},expression:"form.activities_interests.activities.name"}})],1),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"8"}},[_c('b-form-input',{attrs:{"type":"text","placeholder":"When did you pursue this Activity/Interest"},model:{value:(_vm.form.activities_interests.activities.when_pursue),callback:function ($$v) {_vm.$set(_vm.form.activities_interests.activities, "when_pursue", $$v)},expression:"form.activities_interests.activities.when_pursue"}})],1),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"8"}},[_c('b-form-input',{attrs:{"type":"number","placeholder":"Number of members"},model:{value:(_vm.form.activities_interests.activities.number_of_members),callback:function ($$v) {_vm.$set(_vm.form.activities_interests.activities, "number_of_members", $$v)},expression:"form.activities_interests.activities.number_of_members"}})],1),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"8"}},[_c('b-form-input',{attrs:{"type":"text","placeholder":"How much time did you spend?"},model:{value:(_vm.form.activities_interests.activities.time_spent),callback:function ($$v) {_vm.$set(_vm.form.activities_interests.activities, "time_spent", $$v)},expression:"form.activities_interests.activities.time_spent"}})],1),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"8"}},[_c('b-form-input',{attrs:{"type":"text","placeholder":"What role(s) did you play?"},model:{value:(_vm.form.activities_interests.activities.role),callback:function ($$v) {_vm.$set(_vm.form.activities_interests.activities, "role", $$v)},expression:"form.activities_interests.activities.role"}})],1),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"8"}},[_c('b-form-textarea',{attrs:{"rows":"4","placeholder":"Description of activity/interest and your role, impact, or contribution"},model:{value:(_vm.form.activities_interests.activities.description),callback:function ($$v) {_vm.$set(_vm.form.activities_interests.activities, "description", $$v)},expression:"form.activities_interests.activities.description"}})],1)],1)],1),_vm._v(" "),_c('label',[_vm._v("Awards/Honors")]),_vm._v(" "),_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"8"}},[_c('b-form-input',{attrs:{"type":"text","placeholder":"Name"},model:{value:(_vm.form.activities_interests.awards.name),callback:function ($$v) {_vm.$set(_vm.form.activities_interests.awards, "name", $$v)},expression:"form.activities_interests.awards.name"}})],1),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"8"}},[_c('b-form-input',{attrs:{"type":"text","placeholder":"When did you get this award/honor?"},model:{value:(_vm.form.activities_interests.awards.when_awarded),callback:function ($$v) {_vm.$set(_vm.form.activities_interests.awards, "when_awarded", $$v)},expression:"form.activities_interests.awards.when_awarded"}})],1),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"8"}},[_c('b-form-input',{attrs:{"type":"text","placeholder":"Basis of selection"},model:{value:(_vm.form.activities_interests.awards.basis_of_selection),callback:function ($$v) {_vm.$set(_vm.form.activities_interests.awards, "basis_of_selection", $$v)},expression:"form.activities_interests.awards.basis_of_selection"}})],1),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"8"}},[_c('b-form-textarea',{attrs:{"placeholder":"Description","rows":"4"},model:{value:(_vm.form.activities_interests.awards.description),callback:function ($$v) {_vm.$set(_vm.form.activities_interests.awards, "description", $$v)},expression:"form.activities_interests.awards.description"}})],1)],1)],1)],1)])]:_vm._e(),_vm._v(" "),(_vm.active_tab==4)?[_c('div',[_c('h4',{staticClass:"content-title"},[_vm._v(_vm._s(_vm.tabs[4]))]),_vm._v(" "),_c('div',{staticClass:"info_wrapper"},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"8"}},[_c('label',[_vm._v("Name of the exam that you wish to appear for")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text"},model:{value:(_vm.form.guidance.name_of_the_exam_wish_to_appear),callback:function ($$v) {_vm.$set(_vm.form.guidance, "name_of_the_exam_wish_to_appear", $$v)},expression:"form.guidance.name_of_the_exam_wish_to_appear"}})],1),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"4"}},[_c('label',[_vm._v("Date")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date"},model:{value:(_vm.form.guidance.name_of_the_exam_wish_to_appear_date),callback:function ($$v) {_vm.$set(_vm.form.guidance, "name_of_the_exam_wish_to_appear_date", $$v)},expression:"form.guidance.name_of_the_exam_wish_to_appear_date"}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"8"}},[_c('label',[_vm._v("Name of the institute that you are targeting")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text"},model:{value:(_vm.form.guidance.name_of_the_institute_targeting),callback:function ($$v) {_vm.$set(_vm.form.guidance, "name_of_the_institute_targeting", $$v)},expression:"form.guidance.name_of_the_institute_targeting"}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"8"}},[_c('label',[_vm._v("Other entrance exam in mind")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text"},model:{value:(_vm.form.guidance.other_entrance_in_mind),callback:function ($$v) {_vm.$set(_vm.form.guidance, "other_entrance_in_mind", $$v)},expression:"form.guidance.other_entrance_in_mind"}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"8"}},[_c('label',[_vm._v("When would you like to be contacted")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text"},model:{value:(_vm.form.guidance.when_would_you_like_to_be_contacted),callback:function ($$v) {_vm.$set(_vm.form.guidance, "when_would_you_like_to_be_contacted", $$v)},expression:"form.guidance.when_would_you_like_to_be_contacted"}})],1),_vm._v(" "),_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"4"}},[_c('label',[_vm._v("Time")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"time"},model:{value:(_vm.form.guidance.when_would_you_like_to_be_contacted_time),callback:function ($$v) {_vm.$set(_vm.form.guidance, "when_would_you_like_to_be_contacted_time", $$v)},expression:"form.guidance.when_would_you_like_to_be_contacted_time"}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"8"}},[_c('label',[_vm._v("Would you like to receive email/notifications from the admin?")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text"},model:{value:(_vm.form.guidance.email_notifications),callback:function ($$v) {_vm.$set(_vm.form.guidance, "email_notifications", $$v)},expression:"form.guidance.email_notifications"}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"8"}},[_c('label',[_vm._v("Do you want the admin to formulate an appropriate study plan for you?")]),_vm._v(" "),_c('b-form-radio-group',{model:{value:(_vm.form.guidance.formulate_study_plan),callback:function ($$v) {_vm.$set(_vm.form.guidance, "formulate_study_plan", $$v)},expression:"form.guidance.formulate_study_plan"}},[_c('b-form-radio',{attrs:{"value":"Yes"}},[_vm._v("Yes")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"No"}},[_vm._v("No")])],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mobile-no-padding",attrs:{"cols":"12","lg":"8"}},[_c('label',[_vm._v("What are your expectations?")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text"},model:{value:(_vm.form.guidance.expectations),callback:function ($$v) {_vm.$set(_vm.form.guidance, "expectations", $$v)},expression:"form.guidance.expectations"}})],1)],1)],1)],1)])]:_vm._e(),_vm._v(" "),_c('b-button',{staticClass:"btn query-btn button-touchy",staticStyle:{"margin-top":"20px","margin-left":"0"},attrs:{"variant":"primary"},on:{"click":function($event){return _vm.next()}}},[_vm._v(_vm._s(_vm.cta_text))])],2)]:[_c('h5',[_vm._v("You need to Purchase a package to access Career Counselling:")]),_vm._v(" "),_c('b-link',{staticClass:"btn btn-primary",staticStyle:{"margin-top":"20px"},attrs:{"to":"/dashboard/packages"}},[_vm._v("Upgrade")])]],_vm._v(" "),_c('b-modal',{ref:"myModalRef",attrs:{"hide-footer":"","title":"Counselling Form"},model:{value:(_vm.show_modal),callback:function ($$v) {_vm.show_modal=$$v},expression:"show_modal"}},[_c('div',{staticClass:"d-block text-center"},[_c('p',[_vm._v("Thank you, we have received your form, our team will reach out to you shortly.")])])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1fK9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2V+a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UnitConvertor_vue__ = __webpack_require__("mf29");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fce336c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UnitConvertor_vue__ = __webpack_require__("UgKH");
function injectStyle (ssrContext) {
  __webpack_require__("DVkd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5fce336c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UnitConvertor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fce336c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UnitConvertor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3SGP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-tabs',{attrs:{"content-class":"mt-3"}},[_c('b-tab',{attrs:{"title":"Profile"}},[_c('h4',[_vm._v("Your Profile")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Your Full Name:")]),_vm._v(" "),_c('b-form-input',{attrs:{"id":"exampleInput1","type":"text","required":"","placeholder":"Your Full Name"},model:{value:(_vm.form.full_name),callback:function ($$v) {_vm.$set(_vm.form, "full_name", $$v)},expression:"form.full_name"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Your Birthday:")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date"},model:{value:(_vm.form.date_of_birth),callback:function ($$v) {_vm.$set(_vm.form, "date_of_birth", $$v)},expression:"form.date_of_birth"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Gender")]),_vm._v(" "),_c('b-form-select',{attrs:{"options":_vm.gender_options},model:{value:(_vm.form.gender),callback:function ($$v) {_vm.$set(_vm.form, "gender", $$v)},expression:"form.gender"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Email")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"email","disabled":""},model:{value:(_vm.user_info.email),callback:function ($$v) {_vm.$set(_vm.user_info, "email", $$v)},expression:"user_info.email"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Address:")]),_vm._v(" "),_c('b-form-textarea',{attrs:{"rows":3},model:{value:(_vm.form.address),callback:function ($$v) {_vm.$set(_vm.form, "address", $$v)},expression:"form.address"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Name of School/College that you are attending/have graduated from")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text"},model:{value:(_vm.form.college),callback:function ($$v) {_vm.$set(_vm.form, "college", $$v)},expression:"form.college"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Are you currently employed?")]),_vm._v(" "),_c('b-form-radio-group',{model:{value:(_vm.form.is_currently_working),callback:function ($$v) {_vm.$set(_vm.form, "is_currently_working", $$v)},expression:"form.is_currently_working"}},[_c('b-form-radio',{attrs:{"value":"Yes"}},[_vm._v("Yes")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"No"}},[_vm._v("No")])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.form.is_currently_working == 'Yes')?_c('div',[_c('p',[_vm._v("Organization Name")]),_vm._v(" "),_c('b-form-input',{model:{value:(_vm.form.organization),callback:function ($$v) {_vm.$set(_vm.form, "organization", $$v)},expression:"form.organization"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')],1):_vm._e(),_vm._v(" "),_c('p',[_vm._v("Name of the entrance exam you are appearing for:")]),_vm._v(" "),_c('b-form-input',{model:{value:(_vm.form.entrance_exam),callback:function ($$v) {_vm.$set(_vm.form, "entrance_exam", $$v)},expression:"form.entrance_exam"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Would you like to be contacted by the Admin?")]),_vm._v(" "),_c('b-form-radio-group',{model:{value:(_vm.form.contactable_by_admin),callback:function ($$v) {_vm.$set(_vm.form, "contactable_by_admin", $$v)},expression:"form.contactable_by_admin"}},[_c('b-form-radio',{attrs:{"value":"Yes"}},[_vm._v("Yes")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"No"}},[_vm._v("No")])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Would you like to receive notifications?")]),_vm._v(" "),_c('b-form-radio-group',{model:{value:(_vm.form.receive_notifications),callback:function ($$v) {_vm.$set(_vm.form, "receive_notifications", $$v)},expression:"form.receive_notifications"}},[_c('b-form-radio',{attrs:{"value":"Yes"}},[_vm._v("Yes")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"No"}},[_vm._v("No")])],1),_vm._v(" "),_c('b-button',{staticClass:"btn query-btn button-touchy",staticStyle:{"margin-top":"50px","margin-left":"0"},attrs:{"variant":"primary"},on:{"click":_vm.execute_save_profile}},[_vm._v("Save Profile")])],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Account Balance"}},[_c('h4',[_vm._v("Available Doubts: "+_vm._s(_vm.calculated_credits))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v("History:")]),_vm._v(" "),_vm._l((_vm.user_info.transactions),function(transaction,index){return _c('b-container',{key:transaction.id,staticClass:"solution-container",attrs:{"fluid":""}},[_c('b-link',{staticClass:"solution-link note"},[_c('b-row',[_c('b-col',{staticStyle:{"display":"flex","flex-direction":"column","justify-content":"center"},attrs:{"lg":"2"}},[_c('p',{staticClass:"date"},[_vm._v(_vm._s(_vm.get_human_date(transaction.created_at)))])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"4"}},[_c('p',[_vm._v(_vm._s(transaction.reference))])]),_vm._v(" "),_c('b-col',{staticClass:"sol-rating",attrs:{"lg":"5"}}),_vm._v(" "),_c('b-col',{attrs:{"lg":"1"}},[(transaction.debit  > 0)?_c('span',{staticClass:"doubt-description sol-view",staticStyle:{"color":"red"}},[_vm._v("-"+_vm._s(transaction.debit))]):_c('span',{staticClass:"doubt-description sol-view",staticStyle:{"color":"green"}},[_vm._v("+"+_vm._s(transaction.credit))])])],1)],1)],1)})],2),_vm._v(" "),_c('b-tab',{attrs:{"title":"Security"}},[_c('h4',[_vm._v("Update Password")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"password_wrapper"},[_c('p',[_vm._v("Current Password")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"password"},model:{value:(_vm.form_password.old_password),callback:function ($$v) {_vm.$set(_vm.form_password, "old_password", $$v)},expression:"form_password.old_password"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("New Password")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"password"},model:{value:(_vm.form_password.new_password),callback:function ($$v) {_vm.$set(_vm.form_password, "new_password", $$v)},expression:"form_password.new_password"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Repeat New Password")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"password"},model:{value:(_vm.form_password.new_password_repeat),callback:function ($$v) {_vm.$set(_vm.form_password, "new_password_repeat", $$v)},expression:"form_password.new_password_repeat"}})],1),_vm._v(" "),_c('b-button',{staticClass:"btn query-btn button-touchy",staticStyle:{"margin-top":"30px","margin-left":"0"},attrs:{"variant":"primary"},on:{"click":_vm.execute_save_password}},[_vm._v("Update Password")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4+Of":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DoubtView_vue__ = __webpack_require__("W/Ui");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e8cb309_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DoubtView_vue__ = __webpack_require__("4F4V");
function injectStyle (ssrContext) {
  __webpack_require__("uyGv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3e8cb309"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DoubtView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e8cb309_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DoubtView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "479u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4F4V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"doubtView"}},[_c('div',{staticClass:"solution-wrapper"},[(_vm.current_doubt.doubt_status=='completed')?_c('span',{staticClass:"green-bg solved"},[_vm._v("Solved ✓")]):_c('span',{staticClass:"yellow-bg unsolved"},[_vm._v("Pending!")]),_vm._v(" "),_c('h5',{staticStyle:{"margin-top":"10px"}},[_vm._v(_vm._s(_vm.current_doubt.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.current_doubt.description))]),_vm._v(" "),(_vm.current_doubt.attachment_filename != '' && _vm.current_doubt.attachment_filename != null)?_c('div',[_c('p',[_vm._v("Your attachment:")]),_vm._v(" "),(_vm.attachment_filename != '' && _vm.img_source== '')?_c('loader'):_vm._e(),_vm._v(" "),_c('img',{staticStyle:{"width":"100%","display":"block"},attrs:{"id":'doubt_image'+_vm.current_doubt.id,"src":_vm.img_source},on:{"click":function($event){return _vm.open_image('doubt_image'+_vm.current_doubt.id)}}})],1):_vm._e(),_vm._v(" "),_c('div',[(_vm.current_doubt.doubt_status=='completed')?_c('div',[_c('h4',{staticStyle:{"margin-top":"20px"}},[_vm._v("Solution:")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.solution.description))])]):_vm._e(),_vm._v(" "),(_vm.solution.attachment_filename != null && _vm.solution_img_source == '')?_c('loader'):_vm._e(),_vm._v(" "),(_vm.solution_img_source != '')?_c('div',[_c('img',{staticStyle:{"width":"100%","display":"block"},attrs:{"id":'solution_image'+_vm.current_doubt.id,"src":_vm.solution_img_source},on:{"click":function($event){return _vm.open_image('solution_image'+_vm.current_doubt.id)}}})]):_vm._e(),_vm._v(" "),_c('b-card',{attrs:{"title":"Rate the solution"}},[_c('star-rating',{attrs:{"star-size":"30"},model:{value:(_vm.solution_rating),callback:function ($$v) {_vm.solution_rating=$$v},expression:"solution_rating"}})],1),_vm._v(" "),(_vm.current_doubt.doubt_status=='completed')?_c('div',{staticStyle:{"margin-top":"20px","background-color":"white","padding":"20px"}},[_c('h2',[_vm._v("Your Note:")]),_vm._v(" "),_c('p',[_vm._v("You can view all your notes in the Notepad section.")]),_vm._v(" "),_c('b-form-textarea',{attrs:{"id":"textarea1","placeholder":"Type your note here","rows":3,"max-rows":6},model:{value:(_vm.current_doubt.note_text),callback:function ($$v) {_vm.$set(_vm.current_doubt, "note_text", $$v)},expression:"current_doubt.note_text"}}),_vm._v(" "),_c('b-button',{staticClass:"btn query-btn button-touchy",staticStyle:{"margin-top":"20px","margin-left":"0","max-width":"100px"},attrs:{"variant":"primary"},on:{"click":_vm.execute_save_note}},[_vm._v("Save")])],1):_vm._e()],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4MnO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calculator_vue__ = __webpack_require__("pMth");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a62452e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Calculator_vue__ = __webpack_require__("f+Zx");
function injectStyle (ssrContext) {
  __webpack_require__("Z4Nb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1a62452e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calculator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a62452e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Calculator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4Vb8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calculator-border"},[_c('div',{staticClass:"calculator-display"},[_c('div',{staticClass:"calculator-formula"},[_c('span',{staticClass:"formula"},[_vm._v("Formula: "+_vm._s(_vm.formula))])]),_vm._v(" "),_c('div',{staticClass:"calculator-result"},[_vm._v(_vm._s(_vm.result))])]),_vm._v(" "),_c('div',{staticClass:"calculator-items"},[_c('div',{staticClass:"calculator-row"},[_c('div',{staticClass:"calculator-item",on:{"click":function($event){return _vm.drop()}}},[_vm._v("←")]),_vm._v(" "),_c('div',{staticClass:"calculator-item",on:{"click":function($event){return _vm.cleanResult()}}},[_vm._v("CE")]),_vm._v(" "),_c('div',{staticClass:"calculator-item",on:{"click":function($event){return _vm.cleanAll()}}},[_vm._v("AC")]),_vm._v(" "),_c('div',{staticClass:"calculator-item",on:{"click":function($event){return _vm.operate('/')}}},[_vm._v("/")]),_vm._v(" "),_c('div',{staticClass:"calculator-item",on:{"click":function($event){return _vm.square()}}},[_vm._v("√")])]),_vm._v(" "),_c('div',{staticClass:"calculator-row"},[_c('div',{staticClass:"calculator-item",on:{"click":function($event){return _vm.operate(7)}}},[_vm._v("7")]),_vm._v(" "),_c('div',{staticClass:"calculator-item",on:{"click":function($event){return _vm.operate(8)}}},[_vm._v("8")]),_vm._v(" "),_c('div',{staticClass:"calculator-item",on:{"click":function($event){return _vm.operate(9)}}},[_vm._v("9")]),_vm._v(" "),_c('div',{staticClass:"calculator-item",on:{"click":function($event){return _vm.operate('*')}}},[_vm._v("*")]),_vm._v(" "),_c('div',{staticClass:"calculator-item",on:{"click":function($event){return _vm.operate('%')}}},[_vm._v("%")])]),_vm._v(" "),_c('div',{staticClass:"calculator-row"},[_c('div',{staticClass:"calculator-item",on:{"click":function($event){return _vm.operate(4)}}},[_vm._v("4")]),_vm._v(" "),_c('div',{staticClass:"calculator-item",on:{"click":function($event){return _vm.operate(5)}}},[_vm._v("5")]),_vm._v(" "),_c('div',{staticClass:"calculator-item",on:{"click":function($event){return _vm.operate(6)}}},[_vm._v("6")]),_vm._v(" "),_c('div',{staticClass:"calculator-item",on:{"click":function($event){return _vm.operate('-')}}},[_vm._v("-")]),_vm._v(" "),_c('div',{staticClass:"calculator-item",on:{"click":function($event){return _vm.devided()}}},[_vm._v("1/x")])]),_vm._v(" "),_c('div',{staticClass:"calculator-row"},[_c('div',{staticClass:"calculator-item",on:{"click":function($event){return _vm.operate(1)}}},[_vm._v("1")]),_vm._v(" "),_c('div',{staticClass:"calculator-item",on:{"click":function($event){return _vm.operate(2)}}},[_vm._v("2")]),_vm._v(" "),_c('div',{staticClass:"calculator-item",on:{"click":function($event){return _vm.operate(3)}}},[_vm._v("3")]),_vm._v(" "),_c('div',{staticClass:"calculator-item",on:{"click":function($event){return _vm.operate('+')}}},[_vm._v("+")]),_vm._v(" "),_c('div',{staticClass:"calculator-item",on:{"click":function($event){return _vm.toggle()}}},[_vm._v("±")])]),_vm._v(" "),_c('div',{staticClass:"calculator-row"},[_c('div',{staticClass:"calculator-item zero",on:{"click":function($event){return _vm.operate(0)}}},[_vm._v("0")]),_vm._v(" "),_c('div',{staticClass:"calculator-item",on:{"click":function($event){return _vm.operate('.')}}},[_vm._v(".")]),_vm._v(" "),_c('div',{staticClass:"calculator-item equal",on:{"click":function($event){return _vm.equal()}}},[_vm._v("=")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4slL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Support_vue__ = __webpack_require__("i7lk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d8d6f4d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Support_vue__ = __webpack_require__("O71a");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Support_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d8d6f4d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Support_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5MwV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"package-wrapper",attrs:{"id":"Packages"}},[_c('div',{staticClass:"add-query"},[_c('b-container',{staticClass:"package-container",attrs:{"fluid":""}},[(_vm.show_buy_package_screen)?_c('b-row',{attrs:{"id":"buy_package"}},[_c('b-col',{attrs:{"lg":"12"}},[_c('h4',[_vm._v("You have "+_vm._s(_vm.calculated_credits)+" Doubts Available!")])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"12"}},[_c('p',[_vm._v("You can choose one of the plans below to purchase:")])]),_vm._v(" "),_vm._l((_vm.packages),function(a_package,index){return _c('b-col',{key:a_package.id,attrs:{"lg":"4"}},[_c('div',{staticClass:"package-item"},[_c('h3',{staticClass:"package-head"},[_vm._v(_vm._s(a_package.name))]),_vm._v(" "),_c('b-row',[_c('b',[_vm._v("Doubts: ")]),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(a_package.credits))])]),_vm._v(" "),_c('b-row',[_c('p',{staticStyle:{"margin-top":"10px"}},[_vm._v(_vm._s(a_package.description))])]),_vm._v(" "),_c('b-button',{staticClass:"btn query-btn",attrs:{"to":"#","variant":"primary"},on:{"click":function($event){return _vm.buy_package(index)}}},[_vm._v("Buy for ₹"+_vm._s(a_package.cost))])],1)])})],2):_vm._e(),_vm._v(" "),(_vm.transaction_success)?_c('b-row',{attrs:{"id":"transaction_success"}},[_c('b-col',[_c('h4',[_vm._v("Transaction Successful! You have "+_vm._s(_vm.calculated_credits)+" Credits available.")]),_vm._v(" "),_c('p',[_vm._v("We have received your payment, and now you can ask your doubts at your ease!")]),_vm._v(" "),_c('p',[_vm._v("Here is a summary of your transaction:")]),_vm._v(" "),_c('table',[_c('tr',[_c('td',[_vm._v("Payment Id:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.transaction_summary.payment_id))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Package Name:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.selected_package.name))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Credits:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.selected_package.credits))])])]),_c('br'),_vm._v(" "),_c('p',[_vm._v("Thanks a lot, we are awaiting your doubts, Go ahead!")]),_vm._v(" "),_c('b-button',{staticClass:"btn btn-blue",attrs:{"to":"/dashboard/add-doubt"}},[_vm._v("Ask a Doubt")])],1)],1):_vm._e()],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "63kq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Forgot Password',
  data: function data() {
    return {
      msg: 'Welcome to QdsPro',
      form: {
        email: ''
      }
    };
  },

  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('submitted');

                _context.next = 3;
                return _this.$store.dispatch('send_password_reset_email', _this.form.email);

              case 3:
                result = _context.sent;


                console.log('got result', result);

                if (result.status != "success") {
                  _this.$toasted.show("Uh Oh, we could not send an email, please try again!");
                } else {
                  _this.$toasted.show('Password Reset Link is sent on your email!', { type: 'success' });
                  _this.$router.push('/login');
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  created: function created() {

    var user = this.$store.getters.user;

    if (user.is_logged_in) {
      this.$router.replace('/dashboard');
    }
  }
});

/***/ }),

/***/ "6QaE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StudyMaterial_vue__ = __webpack_require__("EN43");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22cae1bf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StudyMaterial_vue__ = __webpack_require__("uZJy");
function injectStyle (ssrContext) {
  __webpack_require__("TO+q")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-22cae1bf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StudyMaterial_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22cae1bf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StudyMaterial_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6stt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Account_vue__ = __webpack_require__("ZYdp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1daffc37_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Account_vue__ = __webpack_require__("3SGP");
function injectStyle (ssrContext) {
  __webpack_require__("hDuT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1daffc37"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Account_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1daffc37_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Account_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6vGk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('div',{attrs:{"id":"hero_content"}},[_c('img',{staticStyle:{"max-width":"330px"},attrs:{"src":__webpack_require__("7Ogj")}}),_vm._v(" "),_c('h3',[_vm._v("A platform for instant answers to your Quant, Verbal, Logic & DI questions")]),_vm._v(" "),_c('div',{staticClass:"cta"},[_c('b-button',{attrs:{"variant":"primary","size":"lg","to":"/login"}},[_vm._v("Login")]),_vm._v(" "),_c('b-button',{attrs:{"to":"/signup","size":"lg"}},[_vm._v("Sign Up")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7Ogj":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.36eb03b.png";

/***/ }),

/***/ "7TRK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__("CSaD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06839e4c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__("sdDm");
function injectStyle (ssrContext) {
  __webpack_require__("GZjq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-06839e4c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06839e4c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7l40":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"notepad"}},[_c('div',{attrs:{"id":"notepad_wrapper"}},[_c('h3',{staticStyle:{"margin-bottom":"30px"}},[_vm._v("Notepad")]),_vm._v(" "),(_vm.doubts_with_notes.length == 0)?_c('b-container',[_c('h5',[_vm._v("You have not added any notes!")]),_vm._v(" "),_c('p',[_vm._v("After your doubt is solved, you can add a note below the solution for future reference.")]),_vm._v(" "),_c('p',[_vm._v("To add a note, go to your Solutions and add a note there.")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.doubts_with_notes),function(doubt,index){return _c('b-container',{key:doubt.id,staticClass:"solution-container",attrs:{"fluid":""}},[_c('div',{staticClass:"material-section",on:{"click":function($event){return _vm.open_doubt(doubt.id)}}},[_c('span',{staticClass:"info"},[_vm._v("Added on Doubt "),_c('b-link',{staticClass:"proper_link",attrs:{"to":'/dashboard/doubts/'+doubt.id}},[_vm._v("("+_vm._s(doubt.title)+")")])],1),_vm._v(" "),_c('p',[_vm._v(_vm._s(doubt.note_text))])])])})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9M+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9jM+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"loader loader--style1",staticStyle:{"text-align":"center"},attrs:{"title":"Loading"}},[_c('svg',{attrs:{"version":"1.1","id":"loader-1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"40px","height":"40px","viewBox":"0 0 40 40","enable-background":"new 0 0 40 40","xml:space":"preserve"}},[_c('path',{attrs:{"opacity":"0.2","fill":"#000","d":"M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946\n\t    s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634\n\t    c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0\n\t    C22.32,8.481,24.301,9.057,26.013,10.047z"}},[_c('animateTransform',{attrs:{"attributeType":"xml","attributeName":"transform","type":"rotate","from":"0 20 20","to":"360 20 20","dur":"0.5s","repeatCount":"indefinite"}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AJ5p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StudyMaterialTag_vue__ = __webpack_require__("G1OM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68fbffd9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StudyMaterialTag_vue__ = __webpack_require__("acLP");
function injectStyle (ssrContext) {
  __webpack_require__("479u")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-68fbffd9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StudyMaterialTag_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68fbffd9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StudyMaterialTag_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BW7l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Bxt9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notepad_vue__ = __webpack_require__("QWSt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4135f38d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notepad_vue__ = __webpack_require__("7l40");
function injectStyle (ssrContext) {
  __webpack_require__("GzQ7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4135f38d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notepad_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4135f38d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notepad_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "C8U/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_my_dropdown__ = __webpack_require__("+vjp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Solutions',
  data: function data() {
    return {
      msg: 'Welcome to QdsPro',
      enable_filters: false
    };
  },

  computed: {
    user: function user() {
      return this.$store.getters.user;
    }
  },
  methods: {
    get_human_date: function get_human_date(d) {
      var mom = __WEBPACK_IMPORTED_MODULE_1_moment___default()(d);
      return mom.format('LL');
    }
  },
  selected: null,
  search: ''
});

/***/ }),

/***/ "C9s3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Share_vue__ = __webpack_require__("f5ne");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25c15f90_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Share_vue__ = __webpack_require__("dUGO");
function injectStyle (ssrContext) {
  __webpack_require__("sUdf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-25c15f90"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Share_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25c15f90_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Share_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CFTP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Utilities_vue__ = __webpack_require__("+Gld");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76cd3d54_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Utilities_vue__ = __webpack_require__("oNaf");
function injectStyle (ssrContext) {
  __webpack_require__("qbq7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-76cd3d54"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Utilities_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76cd3d54_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Utilities_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CSaD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_my_dropdown__ = __webpack_require__("+vjp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Loader_vue__ = __webpack_require__("wd27");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Dashboard",
  data: function data() {
    return {
      msg: "Welcome to QdsPro",
      visible: false,
      slide_open: false,
      main_nav_visibility: false,
      tour_visible: false
    };
  },

  computed: {
    user_info: function user_info() {
      return this.$store.getters.user;
    }
  },
  components: {
    dropdown: __WEBPACK_IMPORTED_MODULE_2_vue_my_dropdown__["a" /* default */],
    loader: __WEBPACK_IMPORTED_MODULE_3__Loader_vue__["a" /* default */]
  },
  created: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _ref.apply(this, arguments);
    }

    return created;
  }(),
  mounted: function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var user, action, action2, credits;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // keep main_nav open on desktop
              if (window.innerWidth > 1280) {
                this.main_nav_visibility = true;
              }

              user = this.$store.getters.user;

              if (user.is_logged_in) {
                _context2.next = 6;
                break;
              }

              this.$router.replace("/login");
              _context2.next = 11;
              break;

            case 6:
              _context2.next = 8;
              return this.$store.dispatch("fetch_me");

            case 8:
              action = _context2.sent;
              action2 = this.$store.dispatch("fetch_doubts");

              if (this.user_info.credits.credit != null) {
                credits = parseFloat(this.user_info.credits.credit) - parseFloat(this.user_info.credits.debit);

                console.log(credits);
                if (credits <= 0) {
                  this.$router.replace("/dashboard/packages");
                } else {
                  this.$router.replace("/dashboard/add-doubt");
                }
              } else {
                this.$router.replace("/dashboard/packages");
              }

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function mounted() {
      return _ref2.apply(this, arguments);
    }

    return mounted;
  }(),
  methods: {
    logout: function logout() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log("logging out");
                _context3.next = 3;
                return _this.$store.dispatch("logout");

              case 3:
                _this.$toasted.show("Logged out successfully!", { type: "success" });
                _this.$router.push("/login");

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this);
      }))();
    },
    open: function open() {
      this.slide_open = true;
    },
    close_main_nav: function close_main_nav() {
      this.main_nav_visibility = false;
    },
    goto: function goto(link) {
      if (window.innerWidth < 1280) this.main_nav_visibility = false;
      this.$router.push(link);
    },
    toggleTour: function toggleTour() {
      console.log('here tour');
      console.log(this.tour_visible);
      this.tour_visible = !this.tour_visible;
      console.log(this.tour_visible);
    }
  }
});

/***/ }),

/***/ "CTNq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"package-wrapper",attrs:{"id":"History"}},[_c('div',{staticClass:"add-query"},[_c('h2',[_vm._v("Your Packages")]),_vm._v(" "),_c('b-container',{staticClass:"package-container",attrs:{"fluid":""}},[_c('b-row',_vm._l((_vm.packages),function(student_package){return _c('b-col',{key:student_package.id,attrs:{"lg":"12"}},[_c('div',{staticClass:"package-item"},[_c('h3',{staticClass:"package-head"},[_vm._v(_vm._s(student_package.package_name))]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('b',[_vm._v("Doubts:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(student_package.credits))])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"12"}},[_c('b',[_vm._v("Cost:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(student_package.cost)+"/-")])])],1)],1)])}),1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DVkd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EN43":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'StudyMaterial',
	data: function data() {
		return {
			loading: true
		};
	},
	computed: {
		user: function user() {
			return this.$store.getters.user;
		},
		is_quant_accessible: function is_quant_accessible() {
			if (this.packages.length > 0) {
				return true;
			} else return false;
		},
		packages: function packages() {
			return this.$store.getters.user.packages;
		},
		status_1: function status_1() {
			if (this.is_quant_accessible) {
				return 'Access Material';
			} else if (this.loading) {
				return 'Checking...';
			} else {
				return 'Upgrade your Package';
			}
		},
		study_material_list: function study_material_list() {
			return this.$store.getters.get_study_material_list;
		}
	},
	mounted: function mounted() {
		var _this = this;

		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
			var action, action2;
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							_context.next = 2;
							return _this.$store.dispatch('fetch_user_packages');

						case 2:
							action = _context.sent;
							_context.next = 5;
							return _this.$store.dispatch('fetch_study_material_list');

						case 5:
							action2 = _context.sent;

							_this.loading = false;
							console.log('Study material launched');

						case 8:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, _this);
		}))();
	}
});

/***/ }),

/***/ "EaAK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "G1OM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);



//
//
//
//
//
//
//
//
//
//
//
//
//

var download = function download(data, strFileName, strMimeType) {
  var self = window,
      // this script is only for browsers anyway...
  defaultMime = "application/octet-stream",
      // this default mime also triggers iframe downloads
  mimeType = strMimeType || defaultMime,
      payload = data,
      url = !strFileName && !strMimeType && payload,
      anchor = document.createElement("a"),
      toString = function toString(a) {
    return String(a);
  },
      myBlob = self.Blob || self.MozBlob || self.WebKitBlob || toString,
      fileName = strFileName || "download",
      blob,
      reader;
  myBlob = myBlob.call ? myBlob.bind(self) : Blob;

  if (String(this) === "true") {
    //reverse arguments, allowing download.bind(true, "text/xml", "export.xml") to act as a callback
    payload = [payload, mimeType];
    mimeType = payload[0];
    payload = payload[1];
  }

  if (url && url.length < 2048) {
    // if no filename and no mime, assume a url was passed as the only argument
    fileName = url.split("/").pop().split("?")[0];
    anchor.href = url; // assign href prop to temp anchor
    if (anchor.href.indexOf(url) !== -1) {
      // if the browser determines that it's a potentially valid url path:
      var ajax = new XMLHttpRequest();
      ajax.open("GET", url, true);
      ajax.responseType = "blob";
      ajax.onload = function (e) {
        download(e.target.response, fileName, defaultMime);
      };
      setTimeout(function () {
        ajax.send();
      }, 0); // allows setting custom ajax headers using the return:
      return ajax;
    } // end if valid url?
  } // end if url?

  //go ahead and download dataURLs right away
  if (/^data:([\w+-]+\/[\w+.-]+)?[,;]/.test(payload)) {
    if (payload.length > 1024 * 1024 * 1.999 && myBlob !== toString) {
      payload = dataUrlToBlob(payload);
      mimeType = payload.type || defaultMime;
    } else {
      return navigator.msSaveBlob // IE10 can't do a[download], only Blobs:
      ? navigator.msSaveBlob(dataUrlToBlob(payload), fileName) : saver(payload); // everyone else can save dataURLs un-processed
    }
  } else {
    //not data url, is it a string with special needs?
    if (/([\x80-\xff])/.test(payload)) {
      var i = 0,
          tempUiArr = new Uint8Array(payload.length),
          mx = tempUiArr.length;
      for (i; i < mx; ++i) {
        tempUiArr[i] = payload.charCodeAt(i);
      }payload = new myBlob([tempUiArr], { type: mimeType });
    }
  }
  blob = payload instanceof myBlob ? payload : new myBlob([payload], { type: mimeType });

  function dataUrlToBlob(strUrl) {
    var parts = strUrl.split(/[:;,]/),
        type = parts[1],
        indexDecoder = strUrl.indexOf("charset") > 0 ? 3 : 2,
        decoder = parts[indexDecoder] == "base64" ? atob : decodeURIComponent,
        binData = decoder(parts.pop()),
        mx = binData.length,
        i = 0,
        uiArr = new Uint8Array(mx);

    for (i; i < mx; ++i) {
      uiArr[i] = binData.charCodeAt(i);
    }return new myBlob([uiArr], { type: type });
  }

  function saver(url, winMode) {
    if ("download" in anchor) {
      //html5 A[download]
      anchor.href = url;
      anchor.setAttribute("download", fileName);
      anchor.className = "download-js-link";
      anchor.innerHTML = "downloading...";
      anchor.style.display = "none";
      anchor.addEventListener("click", function (e) {
        e.stopPropagation();
        this.removeEventListener("click", arguments.callee);
      });
      document.body.appendChild(anchor);
      setTimeout(function () {
        anchor.click();
        document.body.removeChild(anchor);
        if (winMode === true) {
          setTimeout(function () {
            self.URL.revokeObjectURL(anchor.href);
          }, 250);
        }
      }, 66);
      return true;
    }

    // handle non-a[download] safari as best we can:
    if (/(Version)\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari\//.test(navigator.userAgent)) {
      if (/^data:/.test(url)) url = "data:" + url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
      if (!window.open(url)) {
        // popup blocked, offer direct download:
        if (confirm("Displaying New Document\n\nUse Save As... to download, then click back to return to this page.")) {
          location.href = url;
        }
      }
      return true;
    }

    //do iframe dataURL download (old ch+FF):
    var f = document.createElement("iframe");
    document.body.appendChild(f);

    if (!winMode && /^data:/.test(url)) {
      // force a mime that will download:
      url = "data:" + url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
    }
    f.src = url;
    setTimeout(function () {
      document.body.removeChild(f);
    }, 333);
  } //end saver

  if (navigator.msSaveBlob) {
    // IE10+ : (has Blob, but not a[download] or URL)
    return navigator.msSaveBlob(blob, fileName);
  }

  if (self.URL) {
    // simple fast and modern way using Blob and URL:
    saver(self.URL.createObjectURL(blob), true);
  } else {
    // handle non-Blob()+non-URL browsers:
    if (typeof blob === "string" || blob.constructor === toString) {
      try {
        return saver("data:" + mimeType + ";base64," + self.btoa(blob));
      } catch (y) {
        return saver("data:" + mimeType + "," + encodeURIComponent(blob));
      }
    }

    // Blob but not URL support:
    reader = new FileReader();
    reader.onload = function (e) {
      saver(this.result);
    };
    reader.readAsDataURL(blob);
  }
  return true;
}; /* end download() */

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "StudyMaterialTag",
  data: function data() {
    return {
      status: "Checking..."
    };
  },
  computed: {
    user: function user() {
      return this.$store.getters.user;
    },
    study_material_list: function study_material_list() {
      return this.$store.getters.get_study_material_list;
    },
    study_material: function study_material() {
      return _.filter(this.study_material_list, {
        tags: this.$route.params.tag.toLowerCase()
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    open: function open(id, title) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var material, href, download_action;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log("opening", id);

                _this2.$store.commit("setLoader", true);
                _context2.prev = 2;
                _context2.next = 5;
                return _this2.$store.dispatch("fetch_study_material_content", id);

              case 5:
                material = _context2.sent;


                console.log("Porta", window.porta);
                window.post_to_android(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ action: "open_pdf", data: material.attachment_data }));
                href = "data:application/pdf;base64," + material.attachment_data;

                window.location = href;

                download_action = download(href, title + ".pdf", "application/pdf");
                _context2.next = 16;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](2);

                console.log(_context2.t0);

              case 16:

                _this2.$store.commit("setLoader", false);

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[2, 13]]);
      }))();
    }
  }
});

/***/ }),

/***/ "GZjq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GzQ7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H4WX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Overview',
  data: function data() {
    return {
      msg: 'Welcome to QdsPro'
    };
  }
});

/***/ }),

/***/ "HHku":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"solutions"}},[_c('div',{staticClass:"solution-wrapper"},[_c('b-container',{staticClass:"solution-header",attrs:{"fluid":""}},[(_vm.enable_filters)?_c('b-row',[_c('b-col',{attrs:{"lg":"2"}},[_c('div',{staticClass:"sol-filter"},[_c('b-form-select',{model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_c('option',{domProps:{"value":_vm.selected}},[_vm._v("Tag Subject")]),_vm._v(" "),_c('option',{attrs:{"value":"a"}},[_vm._v("Option A")]),_vm._v(" "),_c('option',{attrs:{"value":"b","disabled":""}},[_vm._v("Option B (disabled)")]),_vm._v(" "),_c('optgroup',{attrs:{"label":"Grouped Options"}},[_c('option',{domProps:{"value":{'C':'3PO'}}},[_vm._v("Option  object value")]),_vm._v(" "),_c('option',{domProps:{"value":{'R':'2D2'}}},[_vm._v("Another option with object value")])])])],1)]),_vm._v(" "),_c('b-col',{attrs:{"lg":"2"}},[_c('div',{staticClass:"sol-filter"},[_c('b-form-select',{model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_c('option',{domProps:{"value":_vm.selected}},[_vm._v("Chapter")]),_vm._v(" "),_c('option',{attrs:{"value":"a"}},[_vm._v("A to Z")]),_vm._v(" "),_c('option',{attrs:{"value":"a"}},[_vm._v("Z to A")]),_vm._v(" "),_c('option',{attrs:{"value":"a"}},[_vm._v("Low Star")]),_vm._v(" "),_c('option',{attrs:{"value":"a"}},[_vm._v("High Star")])])],1)]),_vm._v(" "),_c('b-col',{attrs:{"lg":"2"}},[_c('div',{staticClass:"sol-filter"},[_c('b-form-select',{model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_c('option',{domProps:{"value":_vm.selected}},[_vm._v("Date")]),_vm._v(" "),_c('option',{attrs:{"value":"a"}},[_vm._v("Accending")]),_vm._v(" "),_c('option',{attrs:{"value":"a"}},[_vm._v("Decending")])])],1)]),_vm._v(" "),_c('b-col',{attrs:{"lg":"2"}}),_vm._v(" "),_c('b-col',{attrs:{"lg":"2"}},[_c('div',{staticClass:"sol-filter"},[_c('b-form-input',{attrs:{"id":"exampleInput1","type":"search","required":"","placeholder":"Query Name"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1)]),_vm._v(" "),_c('b-col',{attrs:{"lg":"2"}},[_c('div',{staticClass:"sol-filter"},[_c('b-button',{staticClass:"query-btn",attrs:{"type":"submit","variant":"primary"}},[_vm._v("Submit")])],1)])],1):_vm._e()],1),_vm._v(" "),_vm._l((_vm.user.doubts),function(doubt,index){return _c('b-container',{key:doubt.id,staticClass:"solution-container",attrs:{"fluid":""}},[_c('b-link',{staticClass:"solution-link note",class:{'qds-active-border':doubt.doubt_status=='completed', noteactive:doubt.doubt_status=='completed'},attrs:{"to":'/dashboard/doubts/'+doubt.id}},[_c('b-row',[_c('b-col',{staticStyle:{"display":"flex","flex-direction":"column","justify-content":"center"},attrs:{"lg":"2"}},[_c('p',{staticClass:"date"},[_vm._v(_vm._s(_vm.get_human_date(doubt.created_at)))])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"4"}},[_c('p',[_vm._v(_vm._s(doubt.title))]),_vm._v(" "),_c('p',{staticClass:"doubt-description"},[_c('span',{staticClass:"qds-dot qds-active"}),_vm._v(" "+_vm._s(doubt.description.slice(0,50))+"...")])]),_vm._v(" "),_c('b-col',{staticClass:"sol-rating",attrs:{"lg":"5"}}),_vm._v(" "),_c('b-col',{attrs:{"lg":"1"}},[(doubt.doubt_status=='completed')?_c('span',{staticClass:"doubt-description sol-view"},[_vm._v("Solved")]):_c('span',{staticClass:"doubt-description sol-view"},[_vm._v("Pending")])])],1)],1)],1)})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HaSq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_History_vue__ = __webpack_require__("hydq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e8ffd94_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_History_vue__ = __webpack_require__("gV9H");
function injectStyle (ssrContext) {
  __webpack_require__("tt9i")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3e8ffd94"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_History_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e8ffd94_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_History_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Hywn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"g-recaptcha",attrs:{"id":"g-recaptcha","data-sitekey":_vm.sitekey}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);







__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);

var axios_instance = __WEBPACK_IMPORTED_MODULE_5_axios___default.a.create({});

var localhost = false;

var api_endpoint = 'https://qds-api.aashay.cf';
var apiv1_endpoint = 'https://api.qdspro.com/v1';

if (localhost) apiv1_endpoint = 'http://localhost:3000/v1';

var store = new __WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */].Store({
	state: {
		user: {
			id: '',
			full_name: '',
			date_of_birth: '',
			gender: '',
			address: '',
			college: '',
			is_currently_working: '',
			organization: '',
			entrance_exam: '',
			contactable_by_admin: '',
			receive_notifications: '',
			email: '',
			is_logged_in: false,
			credits: {
				credit: 0,
				debit: 0
			},
			blocked: "no",
			user_type: '',
			signup_datetime: '',
			doubts: [],
			packages: [],
			chat_restore_id: '',
			referral_code: '',
			transactions: [],
			is_referral_code_used: ''
		},
		global_loader: false,
		packages: [],
		study_material_list: []
	},
	getters: {
		user: function user(state) {
			return state.user;
		},
		global_loader: function global_loader(state) {
			return state.global_loader;
		},
		get_packages: function get_packages(state) {
			return state.packages;
		},
		get_user_packages: function get_user_packages(state) {
			return state.user.packages;
		},
		get_study_material_list: function get_study_material_list(state) {
			return state.study_material_list;
		}
	},
	mutations: {
		setToken: function setToken(state, token) {
			localStorage.setItem('token', token);
			axios_instance.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			return true;
		},
		removeToken: function removeToken(state) {
			localStorage.removeItem('token');
		},
		setUser: function setUser(state, user) {
			for (var property in state.user) {

				if (user.hasOwnProperty(property)) {
					state.user[property] = user[property];
				}
			}
		},
		setPackages: function setPackages(state, data) {
			state.packages = data;
		},
		setUserPackages: function setUserPackages(state, data) {
			state.user.packages = data;
		},
		setLoader: function setLoader(state, loading) {
			state.global_loader = loading;

			if (loading) {
				store.commit('disableBodyOverflow');
			} else {
				store.commit('enableBodyOverflow');
			}
		},
		disableBodyOverflow: function disableBodyOverflow(state) {
			document.body.classList.add('no-overflow');
		},
		enableBodyOverflow: function enableBodyOverflow(state) {
			document.body.classList.remove('no-overflow');
		},
		setStudyMaterialList: function setStudyMaterialList(state, data) {
			state.study_material_list = data;
		},
		setUserTransactions: function setUserTransactions(state, data) {
			state.user.transactions = data;
		}
	},
	actions: {
		signup: function signup(context, data) {
			var _this = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
				var result2;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.prev = 0;
								_context.next = 3;
								return axios_instance.post(apiv1_endpoint + '/users', data);

							case 3:
								result2 = _context.sent;


								console.log(result2);

								return _context.abrupt('return', result2);

							case 8:
								_context.prev = 8;
								_context.t0 = _context['catch'](0);
								throw Error('You have entered incorrect OTP!');

							case 11:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this, [[0, 8]]);
			}))();
		},
		login: function login(context, data) {
			var _this2 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
				var result2, user;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								//required data params
								// email, password.

								console.log('trying to login');

								_context2.prev = 1;
								_context2.next = 4;
								return axios_instance.post(apiv1_endpoint + '/get-token', {
									user_id: data.email,
									password: data.password
								});

							case 4:
								result2 = _context2.sent;


								console.log(result2);

								//console.log(result);

								context.commit('setToken', result2.data.token);

								user = {
									is_logged_in: true
								};

								context.commit('setUser', user);

								return _context2.abrupt('return', {
									status: 'success'
								});

							case 12:
								_context2.prev = 12;
								_context2.t0 = _context2['catch'](1);

								console.log('got error', _context2.t0);
								return _context2.abrupt('return', {
									status: 'failure',
									error: 'You have entered incorrect credentials!'
								});

							case 16:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, _this2, [[1, 12]]);
			}))();
		},
		logout: function logout(context) {
			var _this3 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								_context3.next = 2;
								return context.commit('removeToken');

							case 2:
								context.commit('setUser', { is_logged_in: false });

							case 3:
							case 'end':
								return _context3.stop();
						}
					}
				}, _callee3, _this3);
			}))();
		},
		send_otp: function send_otp(context, data) {
			var _this4 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
				var result2;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
					while (1) {
						switch (_context4.prev = _context4.next) {
							case 0:
								_context4.prev = 0;
								_context4.next = 3;
								return axios_instance.post(apiv1_endpoint + '/send-otp', {
									email: data.email,
									captcha: data.captcha
								});

							case 3:
								result2 = _context4.sent;
								return _context4.abrupt('return', result2);

							case 7:
								_context4.prev = 7;
								_context4.t0 = _context4['catch'](0);
								throw Error('Otp sending failed, please try again!');

							case 10:
							case 'end':
								return _context4.stop();
						}
					}
				}, _callee4, _this4, [[0, 7]]);
			}))();
		},
		fetch_me: function fetch_me(context) {
			var _this5 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
				var result2;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
					while (1) {
						switch (_context5.prev = _context5.next) {
							case 0:
								_context5.prev = 0;
								_context5.next = 3;
								return axios_instance.get(apiv1_endpoint + '/me');

							case 3:
								result2 = _context5.sent;


								context.commit('setUser', result2.data[0]);

								_context5.next = 11;
								break;

							case 7:
								_context5.prev = 7;
								_context5.t0 = _context5['catch'](0);

								console.log(_context5.t0.toString());
								throw Error('Could not fetch user info');

							case 11:
							case 'end':
								return _context5.stop();
						}
					}
				}, _callee5, _this5, [[0, 7]]);
			}))();
		},
		fetch_user_transactions: function fetch_user_transactions(context) {
			var _this6 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
				var result;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
					while (1) {
						switch (_context6.prev = _context6.next) {
							case 0:
								_context6.prev = 0;
								_context6.next = 3;
								return axios_instance.get(apiv1_endpoint + '/me/transactions');

							case 3:
								result = _context6.sent;


								context.commit('setUserTransactions', result.data.data);

								_context6.next = 10;
								break;

							case 7:
								_context6.prev = 7;
								_context6.t0 = _context6['catch'](0);
								return _context6.abrupt('return', false);

							case 10:
							case 'end':
								return _context6.stop();
						}
					}
				}, _callee6, _this6, [[0, 7]]);
			}))();
		},
		fetch_packages: function fetch_packages(context) {
			var _this7 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
				var result2;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
					while (1) {
						switch (_context7.prev = _context7.next) {
							case 0:
								_context7.prev = 0;
								_context7.next = 3;
								return axios_instance.get(apiv1_endpoint + '/packages');

							case 3:
								result2 = _context7.sent;

								console.log('store', result2);
								context.commit('setPackages', result2.data.data);

								_context7.next = 12;
								break;

							case 8:
								_context7.prev = 8;
								_context7.t0 = _context7['catch'](0);

								console.log(_context7.t0.toString());
								throw Error('Could not fetch the packages!');

							case 12:
							case 'end':
								return _context7.stop();
						}
					}
				}, _callee7, _this7, [[0, 8]]);
			}))();
		},
		capture_payment: function capture_payment(context, data) {
			var _this8 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
				var result2;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
					while (1) {
						switch (_context8.prev = _context8.next) {
							case 0:
								_context8.prev = 0;
								_context8.next = 3;
								return axios_instance.post(apiv1_endpoint + '/capture-payment', data);

							case 3:
								result2 = _context8.sent;

								console.log('store', result2);
								return _context8.abrupt('return', result2);

							case 8:
								_context8.prev = 8;
								_context8.t0 = _context8['catch'](0);

								console.log(_context8.t0.toString());
								throw Error('Could not process your payment!');

							case 12:
							case 'end':
								return _context8.stop();
						}
					}
				}, _callee8, _this8, [[0, 8]]);
			}))();
		},
		send_password_reset_email: function send_password_reset_email(context, email) {
			var _this9 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
				var result2;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
					while (1) {
						switch (_context9.prev = _context9.next) {
							case 0:
								_context9.prev = 0;
								_context9.next = 3;
								return axios_instance.post(apiv1_endpoint + '/send-password-reset-email', { email: email });

							case 3:
								result2 = _context9.sent;
								return _context9.abrupt('return', {
									status: "success"
								});

							case 7:
								_context9.prev = 7;
								_context9.t0 = _context9['catch'](0);
								return _context9.abrupt('return', {
									status: "failure"
								});

							case 10:
							case 'end':
								return _context9.stop();
						}
					}
				}, _callee9, _this9, [[0, 7]]);
			}))();
		},
		fetch_doubts: function fetch_doubts(context) {
			var _this10 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
				var result2;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
					while (1) {
						switch (_context10.prev = _context10.next) {
							case 0:
								_context10.prev = 0;
								_context10.next = 3;
								return axios_instance.get(apiv1_endpoint + '/doubts');

							case 3:
								result2 = _context10.sent;


								context.commit('setUser', { doubts: result2.data.data });

								_context10.next = 11;
								break;

							case 7:
								_context10.prev = 7;
								_context10.t0 = _context10['catch'](0);

								console.log(_context10.t0.toString());
								throw Error('Could not fetch the packages!');

							case 11:
							case 'end':
								return _context10.stop();
						}
					}
				}, _callee10, _this10, [[0, 7]]);
			}))();
		},
		add_doubt: function add_doubt(context, data) {
			var _this11 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11() {
				var result2, fetch_doubts, fetch_me;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
					while (1) {
						switch (_context11.prev = _context11.next) {
							case 0:
								_context11.prev = 0;

								console.log('at store', data);
								_context11.next = 4;
								return axios_instance.post(apiv1_endpoint + '/doubts', data);

							case 4:
								result2 = _context11.sent;
								_context11.next = 7;
								return context.dispatch('fetch_doubts');

							case 7:
								fetch_doubts = _context11.sent;
								fetch_me = context.dispatch('fetch_me');
								return _context11.abrupt('return', result2);

							case 12:
								_context11.prev = 12;
								_context11.t0 = _context11['catch'](0);

								console.log(_context11.t0.toString());
								throw Error('Could not add Doubt, please try again!');

							case 16:
							case 'end':
								return _context11.stop();
						}
					}
				}, _callee11, _this11, [[0, 12]]);
			}))();
		},
		fetch_doubt_attachment: function fetch_doubt_attachment(context, doubt_id) {
			var _this12 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12() {
				var result;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
					while (1) {
						switch (_context12.prev = _context12.next) {
							case 0:
								_context12.prev = 0;
								_context12.next = 3;
								return axios_instance.get(apiv1_endpoint + '/doubts/' + doubt_id + '/attachment');

							case 3:
								result = _context12.sent;
								return _context12.abrupt('return', result);

							case 7:
								_context12.prev = 7;
								_context12.t0 = _context12['catch'](0);

								console.log(_context12.t0.toString());
								throw Error('Could not fetch the attachment for doubt!');

							case 11:
							case 'end':
								return _context12.stop();
						}
					}
				}, _callee12, _this12, [[0, 7]]);
			}))();
		},
		fetch_doubt_solution: function fetch_doubt_solution(context, doubt_id) {
			var _this13 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13() {
				var result;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
					while (1) {
						switch (_context13.prev = _context13.next) {
							case 0:
								_context13.prev = 0;
								_context13.next = 3;
								return axios_instance.get(apiv1_endpoint + '/doubts/' + doubt_id + '/solution');

							case 3:
								result = _context13.sent;
								return _context13.abrupt('return', result);

							case 7:
								_context13.prev = 7;
								_context13.t0 = _context13['catch'](0);

								console.log(_context13.t0.toString());
								throw Error('Could not fetch the solution for doubt!');

							case 11:
							case 'end':
								return _context13.stop();
						}
					}
				}, _callee13, _this13, [[0, 7]]);
			}))();
		},
		fetch_doubt_solution_attachment: function fetch_doubt_solution_attachment(context, doubt_id) {
			var _this14 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14() {
				var result;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
					while (1) {
						switch (_context14.prev = _context14.next) {
							case 0:
								_context14.prev = 0;
								_context14.next = 3;
								return axios_instance.get(apiv1_endpoint + '/doubts/' + doubt_id + '/solution/attachment');

							case 3:
								result = _context14.sent;
								return _context14.abrupt('return', result);

							case 7:
								_context14.prev = 7;
								_context14.t0 = _context14['catch'](0);

								console.log(_context14.t0.toString());
								throw Error('Could not fetch the solution attachment!');

							case 11:
							case 'end':
								return _context14.stop();
						}
					}
				}, _callee14, _this14, [[0, 7]]);
			}))();
		},
		fetch_user_packages: function fetch_user_packages(context) {
			var _this15 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15() {
				var result;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
					while (1) {
						switch (_context15.prev = _context15.next) {
							case 0:
								_context15.prev = 0;
								_context15.next = 3;
								return axios_instance.get(apiv1_endpoint + '/me/packages');

							case 3:
								result = _context15.sent;


								context.commit('setUserPackages', result.data.data);
								_context15.next = 10;
								break;

							case 7:
								_context15.prev = 7;
								_context15.t0 = _context15['catch'](0);
								throw Error('Could not fetch your package history!');

							case 10:
							case 'end':
								return _context15.stop();
						}
					}
				}, _callee15, _this15, [[0, 7]]);
			}))();
		},
		fetch_study_material_list: function fetch_study_material_list(context) {
			var _this16 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee16() {
				var result;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
					while (1) {
						switch (_context16.prev = _context16.next) {
							case 0:
								_context16.prev = 0;
								_context16.next = 3;
								return axios_instance.get(apiv1_endpoint + '/study-material');

							case 3:
								result = _context16.sent;


								context.commit('setStudyMaterialList', result.data.data);
								_context16.next = 10;
								break;

							case 7:
								_context16.prev = 7;
								_context16.t0 = _context16['catch'](0);
								throw Error('Could not fetch study material');

							case 10:
							case 'end':
								return _context16.stop();
						}
					}
				}, _callee16, _this16, [[0, 7]]);
			}))();
		},
		fetch_study_material_content: function fetch_study_material_content(context, id) {
			var _this17 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee17() {
				var result;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
					while (1) {
						switch (_context17.prev = _context17.next) {
							case 0:
								_context17.prev = 0;
								_context17.next = 3;
								return axios_instance.get(apiv1_endpoint + '/study-material/' + id);

							case 3:
								result = _context17.sent;
								return _context17.abrupt('return', result.data.data);

							case 7:
								_context17.prev = 7;
								_context17.t0 = _context17['catch'](0);
								throw Error('Could not fetch study material');

							case 10:
							case 'end':
								return _context17.stop();
						}
					}
				}, _callee17, _this17, [[0, 7]]);
			}))();
		},
		save_doubt_note: function save_doubt_note(context, data) {
			var _this18 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee18() {
				var result;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
					while (1) {
						switch (_context18.prev = _context18.next) {
							case 0:
								_context18.prev = 0;
								_context18.next = 3;
								return axios_instance.put(apiv1_endpoint + '/doubts/' + data.doubt_id + '/note', data);

							case 3:
								result = _context18.sent;
								return _context18.abrupt('return', result);

							case 7:
								_context18.prev = 7;
								_context18.t0 = _context18['catch'](0);

								console.log(_context18.t0.toString());
								throw Error('Could not fetch the attachment for doubt!');

							case 11:
							case 'end':
								return _context18.stop();
						}
					}
				}, _callee18, _this18, [[0, 7]]);
			}))();
		},
		set_chat_restore_id: function set_chat_restore_id(context, restore_id) {
			var _this19 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee19() {
				var result;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19) {
					while (1) {
						switch (_context19.prev = _context19.next) {
							case 0:
								_context19.prev = 0;

								console.log('saving', restore_id);
								_context19.next = 4;
								return axios_instance.post(apiv1_endpoint + '/me/set_chat_restore_id', { restore_id: restore_id });

							case 4:
								result = _context19.sent;
								return _context19.abrupt('return', result);

							case 8:
								_context19.prev = 8;
								_context19.t0 = _context19['catch'](0);

								console.log(_context19.t0.toString());
								throw Error('Could not save chat restore id');

							case 12:
							case 'end':
								return _context19.stop();
						}
					}
				}, _callee19, _this19, [[0, 8]]);
			}))();
		},
		save_profile: function save_profile(context, data) {
			var _this20 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee20() {
				var result;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20) {
					while (1) {
						switch (_context20.prev = _context20.next) {
							case 0:
								_context20.prev = 0;
								_context20.next = 3;
								return axios_instance.put(apiv1_endpoint + '/users', data);

							case 3:
								result = _context20.sent;
								return _context20.abrupt('return', result);

							case 7:
								_context20.prev = 7;
								_context20.t0 = _context20['catch'](0);

								console.log(_context20.t0.toString());
								throw Error('Could not save profile');

							case 11:
							case 'end':
								return _context20.stop();
						}
					}
				}, _callee20, _this20, [[0, 7]]);
			}))();
		},
		save_password: function save_password(context, data) {
			var _this21 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee21() {
				var result;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee21$(_context21) {
					while (1) {
						switch (_context21.prev = _context21.next) {
							case 0:
								_context21.prev = 0;
								_context21.next = 3;
								return axios_instance.post(apiv1_endpoint + '/update_password', data);

							case 3:
								result = _context21.sent;
								return _context21.abrupt('return', result);

							case 7:
								_context21.prev = 7;
								_context21.t0 = _context21['catch'](0);

								console.log(_context21.t0.toString());
								throw Error('Could not save password');

							case 11:
							case 'end':
								return _context21.stop();
						}
					}
				}, _callee21, _this21, [[0, 7]]);
			}))();
		},
		save_counselling_form: function save_counselling_form(context, data) {
			var _this22 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee22() {
				var result;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee22$(_context22) {
					while (1) {
						switch (_context22.prev = _context22.next) {
							case 0:
								_context22.prev = 0;
								_context22.next = 3;
								return axios_instance.put(apiv1_endpoint + '/users/career-counselling', data);

							case 3:
								result = _context22.sent;
								return _context22.abrupt('return', result);

							case 7:
								_context22.prev = 7;
								_context22.t0 = _context22['catch'](0);

								console.log(_context22.t0.toString());
								throw Error('Could not save counselling form');

							case 11:
							case 'end':
								return _context22.stop();
						}
					}
				}, _callee22, _this22, [[0, 7]]);
			}))();
		},
		get_counselling_form: function get_counselling_form(context) {
			var _this23 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee23() {
				var result;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee23$(_context23) {
					while (1) {
						switch (_context23.prev = _context23.next) {
							case 0:
								_context23.prev = 0;
								_context23.next = 3;
								return axios_instance.get(apiv1_endpoint + '/me/career-counselling');

							case 3:
								result = _context23.sent;
								return _context23.abrupt('return', result.data);

							case 7:
								_context23.prev = 7;
								_context23.t0 = _context23['catch'](0);

								console.log(_context23.t0.toString());
								throw Error('Could not get counselling form');

							case 11:
							case 'end':
								return _context23.stop();
						}
					}
				}, _callee23, _this23, [[0, 7]]);
			}))();
		},
		verify_referral_code: function verify_referral_code(context, code) {
			var _this24 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee24() {
				var result;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee24$(_context24) {
					while (1) {
						switch (_context24.prev = _context24.next) {
							case 0:
								_context24.prev = 0;
								_context24.next = 3;
								return axios_instance.post(apiv1_endpoint + '/verify-referral-code', { referral_code: code });

							case 3:
								result = _context24.sent;
								return _context24.abrupt('return', result.data);

							case 7:
								_context24.prev = 7;
								_context24.t0 = _context24['catch'](0);
								return _context24.abrupt('return', false);

							case 10:
							case 'end':
								return _context24.stop();
						}
					}
				}, _callee24, _this24, [[0, 7]]);
			}))();
		},
		apply_referral_code: function apply_referral_code(context, code) {
			var _this25 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee25() {
				var result;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee25$(_context25) {
					while (1) {
						switch (_context25.prev = _context25.next) {
							case 0:
								_context25.prev = 0;
								_context25.next = 3;
								return axios_instance.post(apiv1_endpoint + '/apply-referral-code', { referral_code: code });

							case 3:
								result = _context25.sent;
								return _context25.abrupt('return', true);

							case 7:
								_context25.prev = 7;
								_context25.t0 = _context25['catch'](0);
								return _context25.abrupt('return', false);

							case 10:
							case 'end':
								return _context25.stop();
						}
					}
				}, _callee25, _this25, [[0, 7]]);
			}))();
		},
		rate_solution: function rate_solution(context, data) {
			var _this26 = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee26() {
				var result;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee26$(_context26) {
					while (1) {
						switch (_context26.prev = _context26.next) {
							case 0:
								_context26.prev = 0;
								_context26.next = 3;
								return axios_instance.put(apiv1_endpoint + '/doubts/' + data.doubt_id + '/solution/rating', data);

							case 3:
								result = _context26.sent;
								return _context26.abrupt('return', result.data);

							case 7:
								_context26.prev = 7;
								_context26.t0 = _context26['catch'](0);
								return _context26.abrupt('return', false);

							case 10:
							case 'end':
								return _context26.stop();
						}
					}
				}, _callee26, _this26, [[0, 7]]);
			}))();
		}
	}
});

/***/ }),

/***/ "Im3m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component-wrapper",attrs:{"id":"AddDoubt"}},[_c('div',{staticClass:"add-query"},[_c('h4',[_vm._v("Have a doubt?")]),_vm._v(" "),_c('div',{attrs:{"id":"the_form"}},[_c('b-form',{on:{"submit":_vm.onSubmit}},[_c('b-form-group',{attrs:{"id":"exampleInputGroup1","label":"","label-for":"exampleInput1","description":""}},[_c('b-form-input',{attrs:{"id":"exampleInput1","type":"text","required":"","placeholder":"Doubt Title"},model:{value:(_vm.form.title),callback:function ($$v) {_vm.$set(_vm.form, "title", $$v)},expression:"form.title"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"id":"exampleInputGroup2","label":"","label-for":"exampleInput2","description":""}},[_c('b-form-select',{model:{value:(_vm.form.tags),callback:function ($$v) {_vm.$set(_vm.form, "tags", $$v)},expression:"form.tags"}},_vm._l((_vm.doubt_tags),function(tag){return _c('option',{domProps:{"value":tag}},[_vm._v(_vm._s(tag)+"\n          ")])}),0)],1),_vm._v(" "),_c('b-form-group',{attrs:{"id":"exampleInputGroup3","label":"","label-for":"exampleInput3","description":""}},[_c('b-form-textarea',{attrs:{"id":"textarea1","placeholder":"Type your doubt here and/or simply take a photo","rows":3,"max-rows":6},model:{value:(_vm.form.description),callback:function ($$v) {_vm.$set(_vm.form, "description", $$v)},expression:"form.description"}})],1),_vm._v(" "),_c('div',[_c('b-container',{staticClass:"shadow-1"},[_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{staticClass:"action",staticStyle:{"padding-left":"0"},attrs:{"sm":"12"}},[_c('b-dropdown',{attrs:{"variant":"link","no-caret":""}},[_c('template',{slot:"button-content"},[_c('img',{attrs:{"src":"/static/symbol.png"}}),_vm._v(" "),_c('a',{staticClass:"add-symbol",staticStyle:{"font-size":"1rem"},attrs:{"href":"#","id":"add-symbol"}},[_vm._v("Add Symbols")])]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#"}},[_c('li',{staticClass:"symbol-item"},[_c('a',{staticClass:"logic-symbol",attrs:{"href":"#"},on:{"click":function($event){return _vm.addSymbol('∆')}}},[_vm._v("∆")])]),_vm._v(" "),_c('li',{staticClass:"symbol-item"},[_c('a',{staticClass:"logic-symbol",attrs:{"href":"#"},on:{"click":function($event){return _vm.addSymbol('∏')}}},[_vm._v("∏")])]),_vm._v(" "),_c('li',{staticClass:"symbol-item"},[_c('a',{staticClass:"logic-symbol",attrs:{"href":"#"},on:{"click":function($event){return _vm.addSymbol('∑')}}},[_vm._v("∑")])]),_vm._v(" "),_c('li',{staticClass:"symbol-item"},[_c('a',{staticClass:"logic-symbol",attrs:{"href":"#"},on:{"click":function($event){return _vm.addSymbol('Ω')}}},[_vm._v("Ω")])]),_vm._v(" "),_c('li',{staticClass:"symbol-item"},[_c('a',{staticClass:"logic-symbol",attrs:{"href":"#"},on:{"click":function($event){return _vm.addSymbol('∂')}}},[_vm._v("∂")])]),_vm._v(" "),_c('li',{staticClass:"symbol-item"},[_c('a',{staticClass:"logic-symbol",attrs:{"href":"#"},on:{"click":function($event){return _vm.addSymbol('μ')}}},[_vm._v("μ")])]),_vm._v(" "),_c('li',{staticClass:"symbol-item"},[_c('a',{staticClass:"logic-symbol",attrs:{"href":"#"},on:{"click":function($event){return _vm.addSymbol('∫')}}},[_vm._v("∫")])]),_vm._v(" "),_c('li',{staticClass:"symbol-item"},[_c('a',{staticClass:"logic-symbol",attrs:{"href":"#"},on:{"click":function($event){return _vm.addSymbol('π')}}},[_vm._v("π")])]),_vm._v(" "),_c('li',{staticClass:"symbol-item"},[_c('a',{staticClass:"logic-symbol",attrs:{"href":"#"},on:{"click":function($event){return _vm.addSymbol('∞')}}},[_vm._v("∞")])]),_vm._v(" "),_c('li',{staticClass:"symbol-item"},[_c('a',{staticClass:"logic-symbol",attrs:{"href":"#"},on:{"click":function($event){return _vm.addSymbol('≈')}}},[_vm._v("≈")])]),_vm._v(" "),_c('li',{staticClass:"symbol-item"},[_c('a',{staticClass:"logic-symbol",attrs:{"href":"#"},on:{"click":function($event){return _vm.addSymbol('≠')}}},[_vm._v("≠")])]),_vm._v(" "),_c('li',{staticClass:"symbol-item"},[_c('a',{staticClass:"logic-symbol",attrs:{"href":"#"},on:{"click":function($event){return _vm.addSymbol('÷')}}},[_vm._v("÷")])]),_vm._v(" "),_c('li',{staticClass:"symbol-item"},[_c('a',{staticClass:"logic-symbol",attrs:{"href":"#"},on:{"click":function($event){return _vm.addSymbol('−')}}},[_vm._v("−")])]),_vm._v(" "),_c('li',{staticClass:"symbol-item"},[_c('a',{staticClass:"logic-symbol",attrs:{"href":"#"},on:{"click":function($event){return _vm.addSymbol('√')}}},[_vm._v("√")])]),_vm._v(" "),_c('li',{staticClass:"symbol-item"},[_c('a',{staticClass:"logic-symbol",attrs:{"href":"#"},on:{"click":function($event){return _vm.addSymbol('+')}}},[_vm._v("+")])])])],2)],1),_vm._v(" "),_c('b-col',{staticStyle:{"padding-left":"0","padding-right":"0"},attrs:{"sm":"12"}},[_c('br'),_vm._v(" "),_c('b-form-file',{attrs:{"state":Boolean(_vm.upload),"placeholder":"Take a Photo"},model:{value:(_vm.upload),callback:function ($$v) {_vm.upload=$$v},expression:"upload"}}),_vm._v(" "),_c('b-button',{staticClass:"btn query-btn button-touchy",staticStyle:{"margin-top":"20px","margin-left":"0"},attrs:{"variant":"primary"},on:{"click":_vm.execute_add_doubt}},[_vm._v("Submit")])],1)],1)],1)],1)],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JKmw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"package-wrapper",attrs:{"id":"History"}},[(_vm.show_buy_package_screen)?_c('div',{staticClass:"add-query"},[_c('h2',[_vm._v(_vm._s(_vm.current_package.name))]),_vm._v(" "),_c('b-container',{staticClass:"package-container",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b',[_vm._v("Doubts:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.current_package.credits))]),_vm._v(" "),_c('b',[_vm._v("Cost:")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.current_package.cost)+"/-")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('b',[_vm._v("Add on:")]),_vm._v(" "),_c('p',[_vm._v("- Tables upto 250")]),_vm._v(" "),_c('p',[_vm._v("- Squares upto 1000")]),_vm._v(" "),_c('p',[_vm._v("- Cubes upto 250")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b',[_vm._v("Description")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.current_package.description))]),_vm._v(" "),_c('b-button',{staticClass:"btn query-btn",attrs:{"to":"#","variant":"primary"},on:{"click":function($event){return _vm.buy_package(_vm.current_package.id)}}},[_vm._v("Buy for ₹"+_vm._s(_vm.current_package.cost))])],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.transaction_success)?_c('b-row',{attrs:{"id":"transaction_success"}},[_c('b-col',[_c('h4',[_vm._v("Transaction Successful! You have "+_vm._s(_vm.calculated_credits)+" Credits available.")]),_vm._v(" "),_c('p',[_vm._v("We have received your payment, and now you can ask your doubts at your ease!")]),_vm._v(" "),_c('p',[_vm._v("Here is a summary of your transaction:")]),_vm._v(" "),_c('table',[_c('tr',[_c('td',[_vm._v("Payment Id:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.transaction_summary.payment_id))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Package Name:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.current_package.name))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Credits:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.current_package.credits))])])]),_c('br'),_vm._v(" "),_c('p',[_vm._v("Thanks a lot, we are awaiting your doubts, Go ahead!")]),_vm._v(" "),_c('b-button',{staticClass:"btn btn-blue",attrs:{"to":"/dashboard/add-doubt"}},[_vm._v("Ask a Doubt")])],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "K3HG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overview_vue__ = __webpack_require__("H4WX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a14d106_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Overview_vue__ = __webpack_require__("rAXC");
function injectStyle (ssrContext) {
  __webpack_require__("+FQu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7a14d106"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a14d106_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Overview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75d4aa80_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("cZyn");
function injectStyle (ssrContext) {
  __webpack_require__("EaAK")
  __webpack_require__("OGT9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75d4aa80_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MfOH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Loader__ = __webpack_require__("wd27");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "CareerCounselling",
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_2__Loader__["a" /* default */]
  },
  data: function data() {
    return {
      show_modal: false,
      loading: true,
      tabs: ["Background", "Academics", "Work Experience", "Activities/Interests", "Guidance"],
      completed_tabs: [],
      active_tab: 0,
      form: {
        background: {
          fathers_name: '',
          fathers_occupation: '',
          mothers_name: '',
          mothers_occupation: '',
          permanent_address: {
            country: '',
            state: '',
            city: '',
            postal_code: '',
            address_line: ''
          },
          mailing_address: {
            country: '',
            state: '',
            city: '',
            postal_code: '',
            address_line: ''
          },
          primary_phone: {
            phone_type: '',
            country_code: '',
            phone_no: ''
          },
          alternate_phone: {
            phone_type: '',
            country_code: '',
            phone_no: ''
          },
          languages_known: [{
            language: '',
            proficiency: ''
          }, {
            language: '',
            proficiency: ''
          }, {
            language: '',
            proficiency: ''
          }, {
            language: '',
            proficiency: ''
          }]
        },
        academics: {
          high_school: {
            name: '',
            address: '',
            start_year: '',
            end_year: '',
            max_marks: '',
            marks_obtained: '',
            percentage: ''
          },
          university: {
            name: '',
            address: '',
            start_year: '',
            end_year: '',
            stream: '',
            degree: '',
            max_marks: '',
            marks_obtained: '',
            percentage: '',
            gpa: {
              scale: '',
              cumulative: '',
              first_year: '',
              second_year: '',
              third_year: '',
              fourth_year: ''
            }
          },
          professional_certification: {
            institute_name: '',
            institute_address: '',
            start_year: '',
            end_year: '',
            stream: '',
            degree: '',
            level: '',
            max_marks: '',
            marks_obtained: '',
            percentage: ''
          },
          test_scores: {
            name: '',
            quant: '',
            verbal: '',
            logic: '',
            di: '',
            other: '',
            total: ''
          }

        },
        work_experience: {
          current: {
            name_of_organization: '',
            industry: '',
            address: '',
            start_year: '',
            end_year: '',
            designation: '',
            function: '',
            full_time: ''
          },
          past: {
            name_of_organization: '',
            industry: '',
            address: '',
            start_year: '',
            end_year: '',
            designation: '',
            function: '',
            full_time: ''
          }
        },
        activities_interests: {
          activities: {
            name: '',
            when_pursue: '',
            number_of_members: '',
            time_spent: '',
            role: '',
            description: ''
          },
          awards: {
            name: '',
            when_awarded: '',
            basis_of_selection: '',
            description: ''
          }
        },
        guidance: {
          name_of_the_exam_wish_to_appear: '',
          name_of_the_exam_wish_to_appear_date: '',
          name_of_the_institute_targeting: '',
          other_entrance_in_mind: '',
          when_would_you_like_to_be_contacted: '',
          when_would_you_like_to_be_contacted_time: '',
          email_notifications: '',
          formulate_study_plan: '',
          expectations: ''
        }
      }
    };
  },
  computed: {
    cta_text: function cta_text() {
      if (this.active_tab == this.tabs.length - 1) {
        return "Finish";
      } else {
        return "Save and Continue";
      }
    },
    is_counselling_accessible: function is_counselling_accessible() {
      if (this.packages.length > 0) {
        return true;
      } else return false;
    },
    packages: function packages() {
      return this.$store.getters.user.packages;
    },
    user_info: function user_info() {
      return this.$store.getters.user;
    },
    user_birth_date: function user_birth_date() {
      if (this.user_info.date_of_birth != null && this.user_info.date_of_birth != "") {
        return __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.user_info.date_of_birth).format("YYYY-MM-DD");
      } else {
        return "";
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var action, action2;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$store.dispatch("fetch_user_packages");

            case 2:
              action = _context.sent;

              console.log('getting counselling');

              if (!_this.is_counselling_accessible) {
                _context.next = 9;
                break;
              }

              _context.next = 7;
              return _this.$store.dispatch("get_counselling_form");

            case 7:
              action2 = _context.sent;

              _this.form = action2.data;

            case 9:

              _this.loading = false;

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    setActiveTab: function setActiveTab(index) {
      this.active_tab = index;
    },
    next: function next() {
      // save the state of the form

      var action = this.$store.dispatch("save_counselling_form", this.form);

      if (this.active_tab < 4) {
        this.completed_tabs.push(this.active_tab);
        this.active_tab = this.active_tab + 1;
      } else {
        this.show_modal = true;
      }
    }
  }
});

/***/ }),

/***/ "N1kN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__ = __webpack_require__("Tqaz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__theme_scss__ = __webpack_require__("Viya");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__theme_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__theme_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_min_css__ = __webpack_require__("qb6w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__("9M+g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fortawesome_fontawesome_svg_core__ = __webpack_require__("C/JF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__ = __webpack_require__("fhbW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fortawesome_free_regular_svg_icons__ = __webpack_require__("Yu89");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fortawesome_vue_fontawesome__ = __webpack_require__("1e6/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_toasted__ = __webpack_require__("IZMb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_toasted___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_toasted__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_carousel__ = __webpack_require__("/kJX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_carousel__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.































__WEBPACK_IMPORTED_MODULE_7__fortawesome_fontawesome_svg_core__["a" /* library */].add(__WEBPACK_IMPORTED_MODULE_9__fortawesome_free_regular_svg_icons__["a" /* faTimesCircle */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["a" /* faInfoCircle */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["b" /* faCoffee */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["c" /* faAngleDown */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["d" /* faAngleUp */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["e" /* faQuestionCircle */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["f" /* faBook */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["g" /* faAt */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["h" /* faStickyNote */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["i" /* faGraduationCap */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["j" /* faCalculator */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["k" /* faRupeeSign */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["l" /* faStar */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["m" /* faShareAlt */], __WEBPACK_IMPORTED_MODULE_9__fortawesome_free_regular_svg_icons__["b" /* faBell */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["n" /* faHome */], __WEBPACK_IMPORTED_MODULE_8__fortawesome_free_solid_svg_icons__["o" /* faBars */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('font-awesome-icon', __WEBPACK_IMPORTED_MODULE_10__fortawesome_vue_fontawesome__["a" /* FontAwesomeIcon */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_vue_carousel___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vuex__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_vue_toasted___default.a, {
  duration: 5000,
  theme: 'bubble'
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_12__store__["a" /* store */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */] }
});

/***/ }),

/***/ "NU23":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'QDSCard'
});

/***/ }),

/***/ "NqPW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "O0lw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "O6IL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var countries_list = [{ ccode: "IN", value: "91", name: "India", mcode: "+91" }, { ccode: "US", value: "1", name: "USA", mcode: "+1" }, { ccode: "GB", value: "44", name: "UK", mcode: "+44" }, { ccode: "DZ", value: "213", name: "Algeria", mcode: "+213" }, { ccode: "AD", value: "376", name: "Andorra", mcode: "+376" }, { ccode: "AO", value: "244", name: "Angola", mcode: "+244" }, { ccode: "AI", value: "1264", name: "Anguilla", mcode: "+1264" }, { ccode: "AG", value: "1268", name: "Antigua & Barbuda", mcode: "+1268" }, { ccode: "AR", value: "54", name: "Argentina", mcode: "+54" }, { ccode: "AM", value: "374", name: "Armenia", mcode: "+374" }, { ccode: "AW", value: "297", name: "Aruba", mcode: "+297" }, { ccode: "AU", value: "61", name: "Australia", mcode: "+61" }, { ccode: "AT", value: "43", name: "Austria", mcode: "+43" }, { ccode: "AZ", value: "994", name: "Azerbaijan", mcode: "+994" }, { ccode: "BS", value: "1242", name: "Bahamas", mcode: "+1242" }, { ccode: "BH", value: "973", name: "Bahrain", mcode: "+973" }, { ccode: "BD", value: "880", name: "Bangladesh", mcode: "+880" }, { ccode: "BB", value: "1246", name: "Barbados", mcode: "+1246" }, { ccode: "BY", value: "375", name: "Belarus", mcode: "+375" }, { ccode: "BE", value: "32", name: "Belgium", mcode: "+32" }, { ccode: "BZ", value: "501", name: "Belize", mcode: "+501" }, { ccode: "BJ", value: "229", name: "Benin", mcode: "+229" }, { ccode: "BM", value: "1441", name: "Bermuda", mcode: "+1441" }, { ccode: "BT", value: "975", name: "Bhutan", mcode: "+975" }, { ccode: "BO", value: "591", name: "Bolivia", mcode: "+591" }, { ccode: "BA", value: "387", name: "Bosnia Herzegovina", mcode: "+387" }, { ccode: "BW", value: "267", name: "Botswana", mcode: "+267" }, { ccode: "BR", value: "55", name: "Brazil", mcode: "+55" }, { ccode: "BN", value: "673", name: "Brunei", mcode: "+673" }, { ccode: "BG", value: "359", name: "Bulgaria", mcode: "+359" }, { ccode: "BF", value: "226", name: "Burkina Faso", mcode: "+226" }, { ccode: "BI", value: "257", name: "Burundi", mcode: "+257" }, { ccode: "KH", value: "855", name: "Cambodia", mcode: "+855" }, { ccode: "CM", value: "237", name: "Cameroon", mcode: "+237" }, { ccode: "CA", value: "1", name: "Canada", mcode: "+1" }, { ccode: "CV", value: "238", name: "Cape Verde Islands", mcode: "+238" }, { ccode: "KY", value: "1345", name: "Cayman Islands", mcode: "+1345" }, { ccode: "CF", value: "236", name: "Central African Republic", mcode: "+236" }, { ccode: "CL", value: "56", name: "Chile", mcode: "+56" }, { ccode: "CN", value: "86", name: "China", mcode: "+86" }, { ccode: "CO", value: "57", name: "Colombia", mcode: "+57" }, { ccode: "KM", value: "269", name: "Comoros", mcode: "+269" }, { ccode: "CG", value: "242", name: "Congo", mcode: "+242" }, { ccode: "CK", value: "682", name: "Cook Islands", mcode: "+682" }, { ccode: "CR", value: "506", name: "Costa Rica", mcode: "+506" }, { ccode: "HR", value: "385", name: "Croatia", mcode: "+385" }, { ccode: "CU", value: "53", name: "Cuba", mcode: "+53" }, { ccode: "CY", value: "90", name: "Cyprus - North", mcode: "+90" }, { ccode: "CY", value: "357", name: "Cyprus - South", mcode: "+357" }, { ccode: "CZ", value: "420", name: "Czech Republic", mcode: "+420" }, { ccode: "DK", value: "45", name: "Denmark", mcode: "+45" }, { ccode: "DJ", value: "253", name: "Djibouti", mcode: "+253" }, { ccode: "DM", value: "1809", name: "Dominica", mcode: "+1809" }, { ccode: "DO", value: "1809", name: "Dominican Republic", mcode: "+1809" }, { ccode: "EC", value: "593", name: "Ecuador", mcode: "+593" }, { ccode: "EG", value: "20", name: "Egypt", mcode: "+20" }, { ccode: "SV", value: "503", name: "El Salvador", mcode: "+503" }, { ccode: "GQ", value: "240", name: "Equatorial Guinea", mcode: "+240" }, { ccode: "ER", value: "291", name: "Eritrea", mcode: "+291" }, { ccode: "EE", value: "372", name: "Estonia", mcode: "+372" }, { ccode: "ET", value: "251", name: "Ethiopia", mcode: "+251" }, { ccode: "FK", value: "500", name: "Falkland Islands", mcode: "+500" }, { ccode: "FO", value: "298", name: "Faroe Islands", mcode: "+298" }, { ccode: "FJ", value: "679", name: "Fiji", mcode: "+679" }, { ccode: "FI", value: "358", name: "Finland", mcode: "+358" }, { ccode: "FR", value: "33", name: "France", mcode: "+33" }, { ccode: "GF", value: "594", name: "French Guiana", mcode: "+594" }, { ccode: "PF", value: "689", name: "French Polynesia", mcode: "+689" }, { ccode: "GA", value: "241", name: "Gabon", mcode: "+241" }, { ccode: "GM", value: "220", name: "Gambia", mcode: "+220" }, { ccode: "GE", value: "7880", name: "Georgia", mcode: "+7880" }, { ccode: "DE", value: "49", name: "Germany", mcode: "+49" }, { ccode: "GH", value: "233", name: "Ghana", mcode: "+233" }, { ccode: "GI", value: "350", name: "Gibraltar", mcode: "+350" }, { ccode: "GR", value: "30", name: "Greece", mcode: "+30" }, { ccode: "GL", value: "299", name: "Greenland", mcode: "+299" }, { ccode: "GD", value: "1473", name: "Grenada", mcode: "+1473" }, { ccode: "GP", value: "590", name: "Guadeloupe", mcode: "+590" }, { ccode: "GU", value: "671", name: "Guam", mcode: "+671" }, { ccode: "GT", value: "502", name: "Guatemala", mcode: "+502" }, { ccode: "GN", value: "224", name: "Guinea", mcode: "+224" }, { ccode: "GW", value: "245", name: "Guinea - Bissau", mcode: "+245" }, { ccode: "GY", value: "592", name: "Guyana", mcode: "+592" }, { ccode: "HT", value: "509", name: "Haiti", mcode: "+509" }, { ccode: "HN", value: "504", name: "Honduras", mcode: "+504" }, { ccode: "HK", value: "852", name: "Hong Kong", mcode: "+852" }, { ccode: "HU", value: "36", name: "Hungary", mcode: "+36" }, { ccode: "IS", value: "354", name: "Iceland", mcode: "+354" }, { ccode: "ID", value: "62", name: "Indonesia", mcode: "+62" }, { ccode: "IQ", value: "964", name: "Iraq", mcode: "+964" }, { ccode: "IR", value: "98", name: "Iran", mcode: "+98" }, { ccode: "IE", value: "353", name: "Ireland", mcode: "+353" }, { ccode: "IL", value: "972", name: "Israel", mcode: "+972" }, { ccode: "IT", value: "39", name: "Italy", mcode: "+39" }, { ccode: "JM", value: "1876", name: "Jamaica", mcode: "+1876" }, { ccode: "JP", value: "81", name: "Japan", mcode: "+81" }, { ccode: "JO", value: "962", name: "Jordan", mcode: "+962" }, { ccode: "KZ", value: "7", name: "Kazakhstan", mcode: "+7" }, { ccode: "KE", value: "254", name: "Kenya", mcode: "+254" }, { ccode: "KI", value: "686", name: "Kiribati", mcode: "+686" }, { ccode: "KP", value: "850", name: "Korea - North", mcode: "+850" }, { ccode: "KR", value: "82", name: "Korea - South", mcode: "+82" }, { ccode: "KW", value: "965", name: "Kuwait", mcode: "+965" }, { ccode: "KG", value: "996", name: "Kyrgyzstan", mcode: "+996" }, { ccode: "LA", value: "856", name: "Laos", mcode: "+856" }, { ccode: "LV", value: "371", name: "Latvia", mcode: "+371" }, { ccode: "LB", value: "961", name: "Lebanon", mcode: "+961" }, { ccode: "LS", value: "266", name: "Lesotho", mcode: "+266" }, { ccode: "LR", value: "231", name: "Liberia", mcode: "+231" }, { ccode: "LY", value: "218", name: "Libya", mcode: "+218" }, { ccode: "LI", value: "417", name: "Liechtenstein", mcode: "+417" }, { ccode: "LT", value: "370", name: "Lithuania", mcode: "+370" }, { ccode: "LU", value: "352", name: "Luxembourg", mcode: "+352" }, { ccode: "MO", value: "853", name: "Macao", mcode: "+853" }, { ccode: "MK", value: "389", name: "Macedonia", mcode: "+389" }, { ccode: "MG", value: "261", name: "Madagascar", mcode: "+261" }, { ccode: "MW", value: "265", name: "Malawi", mcode: "+265" }, { ccode: "MY", value: "60", name: "Malaysia", mcode: "+60" }, { ccode: "MV", value: "960", name: "Maldives", mcode: "+960" }, { ccode: "ML", value: "223", name: "Mali", mcode: "+223" }, { ccode: "MT", value: "356", name: "Malta", mcode: "+356" }, { ccode: "MH", value: "692", name: "Marshall Islands", mcode: "+692" }, { ccode: "MQ", value: "596", name: "Martinique", mcode: "+596" }, { ccode: "MR", value: "222", name: "Mauritania", mcode: "+222" }, { ccode: "YT", value: "269", name: "Mayotte", mcode: "+269" }, { ccode: "MX", value: "52", name: "Mexico", mcode: "+52" }, { ccode: "FM", value: "691", name: "Micronesia", mcode: "+691" }, { ccode: "MD", value: "373", name: "Moldova", mcode: "+373" }, { ccode: "MC", value: "377", name: "Monaco", mcode: "+377" }, { ccode: "MN", value: "976", name: "Mongolia", mcode: "+976" }, { ccode: "MS", value: "1664", name: "Montserrat", mcode: "+1664" }, { ccode: "MA", value: "212", name: "Morocco", mcode: "+212" }, { ccode: "MZ", value: "258", name: "Mozambique", mcode: "+258" }, { ccode: "MN", value: "95", name: "Myanmar", mcode: "+95" }, { ccode: "NA", value: "264", name: "Namibia", mcode: "+264" }, { ccode: "NR", value: "674", name: "Nauru", mcode: "+674" }, { ccode: "NP", value: "977", name: "Nepal", mcode: "+977" }, { ccode: "NL", value: "31", name: "Netherlands", mcode: "+31" }, { ccode: "NC", value: "687", name: "New Caledonia", mcode: "+687" }, { ccode: "NZ", value: "64", name: "New Zealand", mcode: "+64" }, { ccode: "NI", value: "505", name: "Nicaragua", mcode: "+505" }, { ccode: "NE", value: "227", name: "Niger", mcode: "+227" }, { ccode: "NG", value: "234", name: "Nigeria", mcode: "+234" }, { ccode: "NU", value: "683", name: "Niue", mcode: "+683" }, { ccode: "NF", value: "672", name: "Norfolk Islands", mcode: "+672" }, { ccode: "NP", value: "670", name: "Northern Marianas", mcode: "+670" }, { ccode: "NO", value: "47", name: "Norway", mcode: "+47" }, { ccode: "OM", value: "968", name: "Oman", mcode: "+968" }, { ccode: "PK", value: "92", name: "Pakistan", mcode: "+92" }, { ccode: "PW", value: "680", name: "Palau", mcode: "+680" }, { ccode: "PA", value: "507", name: "Panama", mcode: "+507" }, { ccode: "PG", value: "675", name: "Papua New Guinea", mcode: "+675" }, { ccode: "PY", value: "595", name: "Paraguay", mcode: "+595" }, { ccode: "PE", value: "51", name: "Peru", mcode: "+51" }, { ccode: "PH", value: "63", name: "Philippines", mcode: "+63" }, { ccode: "PL", value: "48", name: "Poland", mcode: "+48" }, { ccode: "PT", value: "351", name: "Portugal", mcode: "+351" }, { ccode: "PR", value: "1787", name: "Puerto Rico", mcode: "+1787" }, { ccode: "QA", value: "974", name: "Qatar", mcode: "+974" }, { ccode: "RE", value: "262", name: "Reunion", mcode: "+262" }, { ccode: "RO", value: "40", name: "Romania", mcode: "+40" }, { ccode: "RU", value: "7", name: "Russia", mcode: "+7" }, { ccode: "RW", value: "250", name: "Rwanda", mcode: "+250" }, { ccode: "SM", value: "378", name: "San Marino", mcode: "+378" }, { ccode: "ST", value: "239", name: "Sao Tome & Principe", mcode: "+239" }, { ccode: "SA", value: "966", name: "Saudi Arabia", mcode: "+966" }, { ccode: "SN", value: "221", name: "Senegal", mcode: "+221" }, { ccode: "CS", value: "381", name: "Serbia", mcode: "+381" }, { ccode: "SC", value: "248", name: "Seychelles", mcode: "+248" }, { ccode: "SL", value: "232", name: "Sierra Leone", mcode: "+232" }, { ccode: "SG", value: "65", name: "Singapore", mcode: "+65" }, { ccode: "SK", value: "421", name: "Slovak Republic", mcode: "+421" }, { ccode: "SI", value: "386", name: "Slovenia", mcode: "+386" }, { ccode: "SB", value: "677", name: "Solomon Islands", mcode: "+677" }, { ccode: "SO", value: "252", name: "Somalia", mcode: "+252" }, { ccode: "ZA", value: "27", name: "South Africa", mcode: "+27" }, { ccode: "ES", value: "34", name: "Spain", mcode: "+34" }, { ccode: "LK", value: "94", name: "Sri Lanka", mcode: "+94" }, { ccode: "SH", value: "290", name: "St. Helena", mcode: "+290" }, { ccode: "KN", value: "1869", name: "St. Kitts", mcode: "+1869" }, { ccode: "SC", value: "1758", name: "St. Lucia", mcode: "+1758" }, { ccode: "SR", value: "597", name: "Suriname", mcode: "+597" }, { ccode: "SD", value: "249", name: "Sudan", mcode: "+249" }, { ccode: "SZ", value: "268", name: "Swaziland", mcode: "+268" }, { ccode: "SE", value: "46", name: "Sweden", mcode: "+46" }, { ccode: "CH", value: "41", name: "Switzerland", mcode: "+41" }, { ccode: "SY", value: "963", name: "Syria", mcode: "+963" }, { ccode: "TW", value: "886", name: "Taiwan", mcode: "+886" }, { ccode: "TJ", value: "992", name: "Tajikistan", mcode: "+992" }, { ccode: "TH", value: "66", name: "Thailand", mcode: "+66" }, { ccode: "TG", value: "228", name: "Togo", mcode: "+228" }, { ccode: "TO", value: "676", name: "Tonga", mcode: "+676" }, { ccode: "TT", value: "1868", name: "Trinidad & Tobago", mcode: "+1868" }, { ccode: "TN", value: "216", name: "Tunisia", mcode: "+216" }, { ccode: "TR", value: "90", name: "Turkey", mcode: "+90" }, { ccode: "TM", value: "993", name: "Turkmenistan", mcode: "+993" }, { ccode: "TC", value: "1649", name: "Turks & Caicos Islands", mcode: "+1649" }, { ccode: "TV", value: "688", name: "Tuvalu", mcode: "+688" }, { ccode: "UG", value: "256", name: "Uganda", mcode: "+256" }, { ccode: "UA", value: "380", name: "Ukraine", mcode: "+380" }, { ccode: "AE", value: "971", name: "United Arab Emirates", mcode: "+971" }, { ccode: "UY", value: "598", name: "Uruguay", mcode: "+598" }, { ccode: "UZ", value: "998", name: "Uzbekistan", mcode: "+998" }, { ccode: "VU", value: "678", name: "Vanuatu", mcode: "+678" }, { ccode: "VA", value: "379", name: "Vatican City", mcode: "+379" }, { ccode: "VE", value: "58", name: "Venezuela", mcode: "+58" }, { ccode: "VN", value: "84", name: "Vietnam", mcode: "+84" }, { ccode: "VG", value: "1", name: "Virgin Islands - British", mcode: "+1" }, { ccode: "VI", value: "1", name: "Virgin Islands - US", mcode: "+1" }, { ccode: "WF", value: "681", name: "Wallis & Futuna", mcode: "+681" }, { ccode: "YE", value: "969", name: "Yemen North", mcode: "+969" }, { ccode: "YE", value: "967", name: "Yemen South", mcode: "+967" }, { ccode: "ZM", value: "260", name: "Zambia", mcode: "+260" }, { ccode: "ZW", value: "263", name: "Zimbabwe", mcode: "+263" }];

var countries = countries_list.map(function (c) {
  return { value: c.value, text: c.mcode + " " + c.name };
});

/* harmony default export */ __webpack_exports__["a"] = ({
  countries: countries
});

/***/ }),

/***/ "O71a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"support"}},[_c('h3',[_vm._v("QDS Live Support")]),_vm._v(" "),_c('p',[_vm._v("Hi! Are you facing an issue? Do you need platform related support? Or do you want a feature to be added to QDS Pro?")]),_vm._v(" "),_c('p',[_vm._v("Feel free to message us and we will get back to you instantly. Our Team is available to help you at all times.")]),_vm._v(" "),(_vm.loading)?_c('div',[_c('p',[_vm._v("Please wait while we load the Support System...")]),_vm._v(" "),(_vm.loading)?_c('loader'):_vm._e()],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OBXJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Recaptcha_vue__ = __webpack_require__("ag1D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Utils_Validator_js__ = __webpack_require__("Vob/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Utils_Validator_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Utils_Validator_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Constants_js__ = __webpack_require__("O6IL");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var validation = [{
  key: "full_name",
  error_message: "Please enter your full name",
  validator: __WEBPACK_IMPORTED_MODULE_5__Utils_Validator_js___default.a.required
}, {
  key: "email",
  error_message: "Please enter your Email",
  validator: __WEBPACK_IMPORTED_MODULE_5__Utils_Validator_js___default.a.required
}, {
  key: "mobile",
  error_message: "Please enter your Mobile number",
  validator: __WEBPACK_IMPORTED_MODULE_5__Utils_Validator_js___default.a.required
}, {
  key: "mobile",
  error_message: "Please enter a valid Mobile Number",
  validator: __WEBPACK_IMPORTED_MODULE_5__Utils_Validator_js___default.a.valid_mobile
}, {
  key: "password",
  error_message: "Please enter your password",
  validator: __WEBPACK_IMPORTED_MODULE_5__Utils_Validator_js___default.a.required
}];

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Signup',
  components: {
    recaptcha: __WEBPACK_IMPORTED_MODULE_4__Recaptcha_vue__["a" /* default */]
  },
  data: function data() {
    return {
      msg: 'Welcome to QdsPro',
      form: {
        email: '',
        password: '',
        full_name: '',
        country_code: '91',
        mobile: '',
        otp: '',
        otp_id: '',
        referral_code: ''
      },
      alert: {
        message: '',
        type: '',
        show: false
      },
      keep_recaptcha: true,
      show_step_1: true,
      show_step_2: false
    };
  },

  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data, result;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = {
                  email: _this.form.email

                };
                _context.next = 3;
                return _this.$store.dispatch('send-otp', data);

              case 3:
                result = _context.sent;


                if (result.status != "success") {

                  _this.$toasted.show(result.error, { type: 'error' });
                } else {

                  //this.$router.push('/dashboard');  
                }

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    executeRecaptcha: function executeRecaptcha() {
      this.$refs.recaptcha.execute();
    },
    send_otp: function send_otp(response) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var form_valid, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _ref, _ref2, index, field, key, valid, is_referral_code_valid, data, result;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                form_valid = true;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 4;
                _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(validation.entries());

              case 6:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context2.next = 20;
                  break;
                }

                _ref = _step.value;
                _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2);
                index = _ref2[0];
                field = _ref2[1];
                key = field.key;
                valid = field.validator(_this2.form[key]);

                if (valid) {
                  _context2.next = 17;
                  break;
                }

                _this2.$toasted.show(field.error_message, { type: 'error' });
                form_valid = false;
                return _context2.abrupt('break', 20);

              case 17:
                _iteratorNormalCompletion = true;
                _context2.next = 6;
                break;

              case 20:
                _context2.next = 26;
                break;

              case 22:
                _context2.prev = 22;
                _context2.t0 = _context2['catch'](4);
                _didIteratorError = true;
                _iteratorError = _context2.t0;

              case 26:
                _context2.prev = 26;
                _context2.prev = 27;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 29:
                _context2.prev = 29;

                if (!_didIteratorError) {
                  _context2.next = 32;
                  break;
                }

                throw _iteratorError;

              case 32:
                return _context2.finish(29);

              case 33:
                return _context2.finish(26);

              case 34:
                if (form_valid) {
                  _context2.next = 36;
                  break;
                }

                return _context2.abrupt('return');

              case 36:

                _this2.$store.commit('setLoader', true);
                _context2.next = 39;
                return _this2.verify_referral_code();

              case 39:
                is_referral_code_valid = _context2.sent;

                if (is_referral_code_valid) {
                  _context2.next = 44;
                  break;
                }

                _this2.$store.commit('setLoader', false);
                _this2.$toasted.show('Referral Code is invalid!', { type: 'error' });
                return _context2.abrupt('return');

              case 44:
                data = {
                  email: _this2.form.email,
                  captcha: response
                };


                _this2.$store.commit('setLoader', true);
                _context2.prev = 46;
                _context2.next = 49;
                return _this2.$store.dispatch('send_otp', data);

              case 49:
                result = _context2.sent;

                _this2.form.otp_id = result.data.id[0];

                _this2.$store.commit('setLoader', false);
                _this2.show_step_1 = false;
                _this2.show_step_2 = true;
                _context2.next = 60;
                break;

              case 56:
                _context2.prev = 56;
                _context2.t1 = _context2['catch'](46);

                _this2.$toasted.show(_context2.t1.toString(), { type: 'error' });
                _this2.$store.commit('setLoader', false);

              case 60:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[4, 22, 26, 34], [27,, 29, 33], [46, 56]]);
      }))();
    },
    verify_referral_code: function verify_referral_code() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var verify;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                if (!(_this3.form.referral_code == '')) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt('return', true);

              case 3:
                _context3.next = 5;
                return _this3.$store.dispatch('verify_referral_code', _this3.form.referral_code);

              case 5:
                verify = _context3.sent;

                if (!(verify.status == "success")) {
                  _context3.next = 10;
                  break;
                }

                return _context3.abrupt('return', true);

              case 10:
                return _context3.abrupt('return', false);

              case 11:
                _context3.next = 16;
                break;

              case 13:
                _context3.prev = 13;
                _context3.t0 = _context3['catch'](0);
                return _context3.abrupt('return', false);

              case 16:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 13]]);
      }))();
    },
    executeSignUp: function executeSignUp() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var result, user;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.$store.commit('setLoader', true);

                _context4.prev = 1;
                _context4.next = 4;
                return _this4.$store.dispatch('signup', _this4.form);

              case 4:
                result = _context4.sent;

                console.log(result);

                _this4.$store.commit('setToken', result.data.token);

                user = {
                  is_logged_in: true
                };


                _this4.$store.commit('setUser', user);
                _this4.$store.commit('setLoader', false);

                _this4.$router.push('/dashboard');
                _context4.next = 17;
                break;

              case 13:
                _context4.prev = 13;
                _context4.t0 = _context4['catch'](1);

                _this4.$store.commit('setLoader', false);
                _this4.$toasted.show(_context4.t0.toString(), { type: 'error' });

              case 17:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[1, 13]]);
      }))();
    }
  },
  computed: {
    country_code_options: function country_code_options() {
      return __WEBPACK_IMPORTED_MODULE_6__Constants_js__["a" /* default */].countries;
    }
  }
});

/***/ }),

/***/ "OGT9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OLgf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CareerCounselling_vue__ = __webpack_require__("MfOH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e6329624_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CareerCounselling_vue__ = __webpack_require__("1UYJ");
function injectStyle (ssrContext) {
  __webpack_require__("gdfi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CareerCounselling_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e6329624_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CareerCounselling_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QLKv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForgotPassword_vue__ = __webpack_require__("63kq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a980eabc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgotPassword_vue__ = __webpack_require__("nuHT");
function injectStyle (ssrContext) {
  __webpack_require__("NqPW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a980eabc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForgotPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a980eabc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgotPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QQ9q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Packages',
  data: function data() {
    return {
      msg: 'Welcome to QdsPro',
      form: {
        qtitle: '',
        selected: null,
        doubt: ''
      },
      show_buy_package_screen: true, //show buy_package screen by default
      selected_package: {},
      buy_package_id: '',
      transaction_success: false, // show transaction success screen
      transaction_summary: {
        payment_id: '',
        transaction: ''
      }
    };
  },

  computed: {
    packages: function packages() {
      return this.$store.getters.get_packages;
    },
    user_info: function user_info() {
      return this.$store.getters.user;
    },
    calculated_credits: function calculated_credits() {
      if (this.user_info.credits.credit != null) {
        if (this.user_info.credits.debit != null) {
          return parseFloat(this.user_info.credits.credit) - parseFloat(this.user_info.credits.debit);
        } else return parseFloat(this.user_info.credits.credit);
      } else {
        return 0;
      }
    }
  },
  created: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var action;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.$store.commit('setLoader', true);
              _context.prev = 1;
              _context.next = 4;
              return this.$store.dispatch('fetch_packages');

            case 4:
              action = _context.sent;

              this.$store.commit('setLoader', false);
              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context['catch'](1);

              this.$toasted.show('There was an error, please refresh!', { type: 'success' });

            case 11:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this, [[1, 8]]);
    }));

    function created() {
      return _ref.apply(this, arguments);
    }

    return created;
  }(),
  methods: {
    onSubmit: function onSubmit() {
      console.log('submitted');
      this.$router.push('/dashboard');
    },
    capture_payment: function capture_payment(razorpay_response) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var razorpay_payment_id, result, result2;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                razorpay_payment_id = razorpay_response.razorpay_payment_id;
                _context2.prev = 1;

                _this.$store.commit('setLoader', true);
                _context2.next = 5;
                return _this.$store.dispatch('capture_payment', { razorpay_payment_id: razorpay_payment_id, package_id: _this.buy_package_id });

              case 5:
                result = _context2.sent;


                _this.transaction_summary = result.data.data;

                _context2.next = 9;
                return _this.$store.dispatch('fetch_me');

              case 9:
                result2 = _context2.sent;


                _this.show_buy_package_screen = false;
                _this.transaction_success = true;

                _this.$store.commit('setLoader', false);

                _context2.next = 18;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2['catch'](1);

                _this.$toasted.show("We had a problem processing your transaction, please try again!");

              case 18:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this, [[1, 15]]);
      }))();
    },
    buy_package: function buy_package(package_index) {
      console.log(package_index);
      this.selected_package = this.packages[package_index];
      this.buy_package_id = this.selected_package.id;
      var rzp_options = {
        key: "rzp_live_oZ13b2cVYTIpGt",
        amount: this.selected_package.cost * 100,
        name: "QdsPro",
        description: "Buy Package " + this.selected_package.name,
        handler: this.capture_payment,
        theme: {
          color: "#77bf43"
        }
      };

      var rzp1 = new Razorpay(rzp_options);
      rzp1.open();
    }
  }
});

/***/ }),

/***/ "QWSt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Notepad',
  data: function data() {
    return {
      msg: 'Welcome to QdsPro',
      enable_filters: false
    };
  },

  computed: {
    user: function user() {
      return this.$store.getters.user;
    },
    doubts_with_notes: function doubts_with_notes() {
      var filtered = [];

      filtered = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(this.user.doubts, function (o) {
        if (o.hasOwnProperty('note_text')) {
          return true;
        }
      });

      return filtered;
    }

  },
  methods: {
    get_human_date: function get_human_date(d) {
      var mom = moment(d);
      return mom.format('LL');
    },
    open_doubt: function open_doubt(id) {
      this.$router.push('/dashboard/doubts/' + id);
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var action2;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$store.dispatch('fetch_doubts');

            case 2:
              action2 = _context.sent;

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),

/***/ "TKgh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello bg-light",attrs:{"id":"signup"}},[_c('div',{attrs:{"id":"signup_wrapper"}},[_c('b-container',{staticClass:"margin-auto rounded",attrs:{"id":"hero"}},[_c('b-row',[_c('b-col',{staticClass:"hide-on-mobile"},[_c('div',{staticClass:"qds-logo",attrs:{"id":"art"}},[_c('a',{staticStyle:{"display":"block","text-align":"center","width":"100%"},attrs:{"href":"#"}},[_c('img',{staticClass:"img-fluid",staticStyle:{"width":"100%","max-width":"300px","margin":"auto","display":"block"},attrs:{"src":"static/logo.png"}})])])]),_vm._v(" "),_c('b-col',{staticClass:"bg-green ctl center"},[_c('div',{attrs:{"id":"the_form"}},[(_vm.show_step_1)?_c('div',{attrs:{"id":"step_1"}},[_c('h1',{staticStyle:{"margin-bottom":"1.7rem"}},[_vm._v("Sign Up")]),_vm._v(" "),_c('b-form',{on:{"submit":_vm.onSubmit}},[_c('b-form-group',{attrs:{"id":"exampleInputGroup1","label":"","label-for":"exampleInput1","description":""}},[_c('b-form-input',{attrs:{"id":"exampleInput1","type":"text","required":"","placeholder":"Your Full Name"},model:{value:(_vm.form.full_name),callback:function ($$v) {_vm.$set(_vm.form, "full_name", $$v)},expression:"form.full_name"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"id":"exampleInputGroup2","label":"","label-for":"exampleInput2","description":""}},[_c('b-form-input',{attrs:{"id":"exampleInput2","type":"email","required":"","placeholder":"Enter email"},model:{value:(_vm.form.email),callback:function ($$v) {_vm.$set(_vm.form, "email", $$v)},expression:"form.email"}})],1),_vm._v(" "),_c('div',{staticClass:"mobile_form_wrapper"},[_c('b-form-group',{attrs:{"label":"","label-for":"exampleInput2","description":""}},[_c('b-form-select',{staticClass:"country_code_picker",attrs:{"options":_vm.country_code_options},model:{value:(_vm.form.country_code),callback:function ($$v) {_vm.$set(_vm.form, "country_code", $$v)},expression:"form.country_code"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"mobile_number_input_group",attrs:{"label":"","description":""}},[_c('b-form-input',{attrs:{"type":"tel","required":"","placeholder":"Mobile"},model:{value:(_vm.form.mobile),callback:function ($$v) {_vm.$set(_vm.form, "mobile", $$v)},expression:"form.mobile"}})],1)],1),_vm._v(" "),_c('b-form-group',{attrs:{"id":"exampleInputGroup3","label":"","label-for":"exampleInput3","description":""}},[_c('b-form-input',{attrs:{"id":"exampleInput3","type":"password","required":"","placeholder":"Password"},model:{value:(_vm.form.password),callback:function ($$v) {_vm.$set(_vm.form, "password", $$v)},expression:"form.password"}})],1),_vm._v(" "),_c('p',[_vm._v("Have a referral code? (optional)")]),_vm._v(" "),_c('b-form-group',{attrs:{"id":"exampleInputGroup3","label":"","label-for":"exampleInput3","description":""}},[_c('b-form-input',{attrs:{"id":"exampleInput3","type":"text","placeholder":"Referral Code"},model:{value:(_vm.form.referral_code),callback:function ($$v) {_vm.$set(_vm.form, "referral_code", $$v)},expression:"form.referral_code"}})],1),_vm._v(" "),_c('p',{staticClass:"terms"},[_vm._v("By clicking on Sign up, you agree to our "),_c('a',{staticClass:"blue-link",attrs:{"href":"//www.qdspro.com/terms.html"}},[_vm._v("Terms")]),_vm._v(" and "),_c('a',{staticClass:"blue-link",attrs:{"href":"//www.qdspro.com/privacy.html"}},[_vm._v("Privacy Policy")])]),(_vm.keep_recaptcha)?_c('div',[_c('recaptcha',{ref:"recaptcha",on:{"verify":_vm.send_otp}})],1):_vm._e(),_vm._v(" "),_c('b-button',{staticClass:"btn-blue",attrs:{"id":"btn-sign-up","size":"lg","variant":"primary"},on:{"click":_vm.send_otp}},[_vm._v("Sign Up")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('b-link',{staticClass:"blue-link",attrs:{"to":"/login"}},[_vm._v("Already have an account? Log in")])],1)],1):_vm._e(),_vm._v(" "),(_vm.show_step_2)?_c('div',{attrs:{"id":"step_2"}},[_c('b-form',[_c('h1',{staticStyle:{"margin-bottom":"2rem"}},[_vm._v("Enter Otp")]),_vm._v(" "),_c('p',[_vm._v("Your email should receive a 6 digit otp, please input it below to continue.")]),_vm._v(" "),_c('b-form-group',{attrs:{"id":"exampleInputGroup1","label":"","label-for":"otpInput","description":""}},[_c('b-form-input',{attrs:{"id":"otpInput","type":"number","required":"","placeholder":"123456"},model:{value:(_vm.form.otp),callback:function ($$v) {_vm.$set(_vm.form, "otp", $$v)},expression:"form.otp"}})],1),_vm._v(" "),_c('b-button',{staticClass:"btn-blue",attrs:{"id":"btn-verify-otp","size":"lg","variant":"primary"},on:{"click":_vm.executeSignUp}},[_vm._v("Verify")])],1)],1):_vm._e()])])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TO+q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U3c0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UVF8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UgKH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"unit_convertor"}},[_c('h3',[_vm._v("Unit Convertor")]),_vm._v(" "),_c('b-form-select',{model:{value:(_vm.area),callback:function ($$v) {_vm.area=$$v},expression:"area"}},_vm._l((_vm.areas),function(area){return _c('option',{domProps:{"value":area}},[_vm._v(_vm._s(_vm.capitalize(area))+"\n          ")])}),0),_vm._v(" "),_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"material-section"},[_c('div',{staticClass:"entry"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.convertFrom),expression:"convertFrom"}],staticClass:"value",attrs:{"placeholder":"From","type":"text","min":"0","step":"0.01"},domProps:{"value":(_vm.convertFrom)},on:{"input":function($event){if($event.target.composing){ return; }_vm.convertFrom=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"selections"},[_c('b-form-select',{model:{value:(_vm.selected_possibility),callback:function ($$v) {_vm.selected_possibility=$$v},expression:"selected_possibility"}},_vm._l((_vm.possibilities),function(poss){return _c('option',{domProps:{"value":poss}},[_vm._v(_vm._s(poss)+"\n\t\t\t          ")])}),0)],1)]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"material-section"},[_c('div',{staticClass:"entry"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.convertTo),expression:"convertTo"}],staticClass:"value",attrs:{"disabled":"","placeholder":"To","type":"text","min":"0","step":"0.01"},domProps:{"value":(_vm.convertTo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.convertTo=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"selections"},[_c('b-form-select',{model:{value:(_vm.selected_possibility2),callback:function ($$v) {_vm.selected_possibility2=$$v},expression:"selected_possibility2"}},_vm._l((_vm.possibilities),function(poss){return _c('option',{domProps:{"value":poss}},[_vm._v(_vm._s(poss)+"\n\t\t\t          ")])}),0)],1)])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"middle"},[_c('span',[_vm._v("=")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VDl6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Viya":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Vob/":
/***/ (function(module, exports) {

exports.required = function (val) {
  if (val === "" || val === null) return false;
  return true;
};

exports.valid_mobile = function (val) {
  if (val.length > 3 && val.length < 16) return true;else return false;
};

/***/ }),

/***/ "W/Ui":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_my_dropdown__ = __webpack_require__("+vjp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating__ = __webpack_require__("X+2x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_star_rating__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Loader_vue__ = __webpack_require__("wd27");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_viewerjs__ = __webpack_require__("IinW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_viewerjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_viewerjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_viewerjs_dist_viewer_css__ = __webpack_require__("N1kN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_viewerjs_dist_viewer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_viewerjs_dist_viewer_css__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var viewer = null;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DoubtView',
  components: {
    loader: __WEBPACK_IMPORTED_MODULE_6__Loader_vue__["a" /* default */],
    StarRating: __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default.a
  },
  data: function data() {
    return {
      msg: 'Welcome to QdsPro',
      the_doubt: {
        title: '',
        description: '',
        created_at: '',
        doubt_status: '',
        solution: null,
        attachment_filename: ''
      },
      img_source: '',
      solution: {},
      solution_img_source: '',
      solution_rating: ''
    };
  },

  mounted: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (this.current_doubt.attachment_filename != null) {
                this.get_attachment();
              }

              if (this.current_doubt.doubt_status == 'completed') {
                this.get_solution();
                this.get_solution_attachment();
              }

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _ref.apply(this, arguments);
    }

    return mounted;
  }(),
  destroyed: function destroyed() {
    viewer.hide();
    console.log('closed');
  },
  computed: {
    user: function user() {
      return this.$store.getters.user;
    },
    current_doubt: function current_doubt() {
      var doubt_id = this.$route.params.id;
      //return this.$route.params.id;
      return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(this.user.doubts, { 'id': Number(doubt_id) });
    }
  },
  methods: {
    open_image: function open_image(id) {
      console.log(id);
      viewer = new __WEBPACK_IMPORTED_MODULE_7_viewerjs___default.a(document.getElementById(id), {
        ready: function ready() {
          viewer.show();
        },
        viewed: function viewed() {
          //viewer.zoomTo(1);
        },

        navbar: false,
        title: false,
        toolbar: {
          zoomIn: false,
          zoomOut: false,
          oneToOne: false,
          reset: false,
          play: false,
          next: false,
          flipHorizontal: false,
          flipVertical: false,
          rotateLeft: true,
          rotateRight: true
        }
      });

      viewer.show();
    },
    get_human_date: function get_human_date(d) {
      var mom = __WEBPACK_IMPORTED_MODULE_4_moment___default()(d);
      return mom.format('LL');
    },
    get_attachment: function get_attachment() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var action, attachment, source;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this.$store.dispatch('fetch_doubt_attachment', _this.current_doubt.id);

              case 2:
                action = _context2.sent;


                //var attachment = action.data;

                attachment = action.data.data;
                source = 'data:' + attachment.attachment_type + ';base64,' + attachment.attachment_data;


                _this.img_source = source;

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    },
    get_solution: function get_solution() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var action;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this2.$store.dispatch('fetch_doubt_solution', _this2.current_doubt.id);

              case 2:
                action = _context3.sent;


                _this2.solution = action.data.data[0];
                _this2.solution_rating = _this2.solution.rating;

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },
    get_solution_attachment: function get_solution_attachment() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var action, attachment, source;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return _this3.$store.dispatch('fetch_doubt_solution_attachment', _this3.current_doubt.id);

              case 3:
                action = _context4.sent;
                attachment = action.data.data;
                source = 'data:' + attachment.attachment_type + ';base64,' + attachment.attachment_data;


                _this3.solution_img_source = source;

                _context4.next = 12;
                break;

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4['catch'](0);

                console.log(_context4.t0.toString());

              case 12:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this3, [[0, 9]]);
      }))();
    },
    execute_save_note: function execute_save_note() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var data, action;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                data = {
                  doubt_id: _this4.current_doubt.id,
                  text: _this4.current_doubt.note_text
                };
                _context5.next = 3;
                return _this4.$store.dispatch('save_doubt_note', data);

              case 3:
                action = _context5.sent;

                _this4.$toasted.show('Note Saved!', { type: 'success' });

              case 5:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this4);
      }))();
    }
  },
  watch: {
    $route: function $route(to, from) {
      this.get_attachment();
      this.get_solution();
    },

    solution_rating: function solution_rating(to, from) {
      if (this.solution.rating == this.solution_rating) {
        return;
      } else {
        this.$store.dispatch('rate_solution', { doubt_id: this.current_doubt.id, rating: this.solution_rating });
        this.$toasted.show("Thanks 👍", { type: 'success' });
      }
    }
  }
});

/***/ }),

/***/ "YEjl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YGOY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello bg-light",attrs:{"id":"login"}},[_c('div',{attrs:{"id":"login_wrapper"}},[_c('b-container',{staticClass:"margin-auto rounded",attrs:{"id":"hero"}},[_c('b-row',[_c('b-col',{staticClass:"logo-col hero-col",attrs:{"sm":"12","lg":"6"}},[_c('div',{staticClass:"qds-logo",attrs:{"id":"art"}},[_c('a',{staticStyle:{"display":"block","text-align":"center","width":"100%"},attrs:{"href":"#"}},[_c('img',{staticClass:"img-fluid",staticStyle:{"width":"100%","max-width":"300px","margin":"auto","display":"block"},attrs:{"src":"static/logo.png"}})])])]),_vm._v(" "),_c('b-col',{staticClass:"bg-green ctl center hero-col",attrs:{"sm":"12","lg":"6"}},[_c('div',{attrs:{"id":"the_form"}},[_c('h1',{staticStyle:{"margin-bottom":"2rem"}},[_vm._v("Login")]),_vm._v(" "),_c('b-form',{on:{"submit":_vm.onSubmit}},[_c('b-form-group',{attrs:{"id":"exampleInputGroup1","label":"","label-for":"exampleInput1","description":""}},[_c('b-form-input',{attrs:{"id":"exampleInput1","type":"email","required":"","placeholder":"Enter email"},model:{value:(_vm.form.email),callback:function ($$v) {_vm.$set(_vm.form, "email", $$v)},expression:"form.email"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"id":"exampleInputGroup1","label":"","label-for":"exampleInput1","description":""}},[_c('b-form-input',{attrs:{"id":"exampleInput1","type":"password","required":"","placeholder":"Password"},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onSubmit($event)}},model:{value:(_vm.form.password),callback:function ($$v) {_vm.$set(_vm.form, "password", $$v)},expression:"form.password"}})],1),_vm._v(" "),_c('b-button',{staticClass:"btn-blue",attrs:{"size":"lg","variant":"primary"},on:{"click":_vm.onSubmit}},[_vm._v("Login")]),_c('br'),_c('br'),_vm._v(" "),_c('p',[_c('b-link',{staticClass:"blue-link",attrs:{"to":"/signup"}},[_vm._v("Or Sign up")])],1),_vm._v(" "),_c('p',[_c('b-link',{staticClass:"blue-link",attrs:{"to":"/forgotpassword"}},[_vm._v("Forgot your password?")])],1)],1)],1)])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__("qSdX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Signup__ = __webpack_require__("psOb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Login__ = __webpack_require__("xJsL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Dashboard_Dashboard__ = __webpack_require__("7TRK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Dashboard_DoubtView__ = __webpack_require__("4+Of");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Dashboard_Overview__ = __webpack_require__("K3HG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Dashboard_AddDoubt__ = __webpack_require__("pnwR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Dashboard_Solutions__ = __webpack_require__("Z2GM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Dashboard_History__ = __webpack_require__("HaSq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Dashboard_Packages__ = __webpack_require__("Z1Cw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Dashboard_PackagesHistory__ = __webpack_require__("wI5S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Dashboard_PackageView__ = __webpack_require__("0DkH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_ForgotPassword__ = __webpack_require__("QLKv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Dashboard_StudyMaterial__ = __webpack_require__("6QaE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Dashboard_StudyMaterialTag__ = __webpack_require__("AJ5p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Dashboard_Notepad__ = __webpack_require__("Bxt9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Dashboard_Utilities__ = __webpack_require__("CFTP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Dashboard_Calculator__ = __webpack_require__("4MnO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Dashboard_UnitConvertor__ = __webpack_require__("2V+a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Dashboard_Support__ = __webpack_require__("4slL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Dashboard_Account__ = __webpack_require__("6stt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Dashboard_CareerCounselling__ = __webpack_require__("OLgf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Dashboard_Share__ = __webpack_require__("C9s3");


























__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Hello',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Hello__["a" /* default */]
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Login__["a" /* default */]
  }, {
    path: '/forgotpassword',
    name: 'Forgot Password',
    component: __WEBPACK_IMPORTED_MODULE_14__components_ForgotPassword__["a" /* default */]
  }, {
    path: '/dashboard',
    name: 'Dashboard',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Dashboard_Dashboard__["a" /* default */],
    children: [{
      name: 'Account',
      path: 'account',
      component: __WEBPACK_IMPORTED_MODULE_22__components_Dashboard_Account__["a" /* default */]
    }, {
      name: 'CareerCounselling',
      path: 'career-counselling',
      component: __WEBPACK_IMPORTED_MODULE_23__components_Dashboard_CareerCounselling__["a" /* default */]
    }, {
      name: 'StudyMaterial',
      path: 'study-material',
      component: __WEBPACK_IMPORTED_MODULE_15__components_Dashboard_StudyMaterial__["a" /* default */]
    }, {
      name: 'StudyMaterialTag',
      path: 'study-material/:tag',
      component: __WEBPACK_IMPORTED_MODULE_16__components_Dashboard_StudyMaterialTag__["a" /* default */]
    }, {
      path: '',
      component: __WEBPACK_IMPORTED_MODULE_7__components_Dashboard_Overview__["a" /* default */]
    }, {
      path: 'add-doubt',
      component: __WEBPACK_IMPORTED_MODULE_8__components_Dashboard_AddDoubt__["a" /* default */]
    }, {
      path: 'solutions',
      component: __WEBPACK_IMPORTED_MODULE_9__components_Dashboard_Solutions__["a" /* default */]
    }, {
      path: 'history',
      component: __WEBPACK_IMPORTED_MODULE_10__components_Dashboard_History__["a" /* default */]
    }, {
      path: 'packages',
      component: __WEBPACK_IMPORTED_MODULE_11__components_Dashboard_Packages__["a" /* default */]
    }, {
      path: 'packages/:id',
      component: __WEBPACK_IMPORTED_MODULE_13__components_Dashboard_PackageView__["a" /* default */]
    }, {
      path: 'packages-history',
      component: __WEBPACK_IMPORTED_MODULE_12__components_Dashboard_PackagesHistory__["a" /* default */]
    }, {
      path: 'doubts/:id',
      component: __WEBPACK_IMPORTED_MODULE_6__components_Dashboard_DoubtView__["a" /* default */]
    }, {
      path: 'notepad',
      component: __WEBPACK_IMPORTED_MODULE_17__components_Dashboard_Notepad__["a" /* default */]
    }, {
      path: 'utilities',
      component: __WEBPACK_IMPORTED_MODULE_18__components_Dashboard_Utilities__["a" /* default */]
    }, {
      path: 'calculator',
      component: __WEBPACK_IMPORTED_MODULE_19__components_Dashboard_Calculator__["a" /* default */]
    }, {
      path: 'unit-convertor',
      component: __WEBPACK_IMPORTED_MODULE_20__components_Dashboard_UnitConvertor__["a" /* default */]
    }, {
      path: 'support',
      component: __WEBPACK_IMPORTED_MODULE_21__components_Dashboard_Support__["a" /* default */]
    }, {
      path: 'share',
      component: __WEBPACK_IMPORTED_MODULE_24__components_Dashboard_Share__["a" /* default */]
    }]
  }, {
    path: '/signup',
    name: 'Signup',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Signup__["a" /* default */]
  }]
}));

/***/ }),

/***/ "Z1Cw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Packages_vue__ = __webpack_require__("QQ9q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e524662_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Packages_vue__ = __webpack_require__("5MwV");
function injectStyle (ssrContext) {
  __webpack_require__("U3c0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6e524662"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Packages_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e524662_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Packages_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Z2GM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Solutions_vue__ = __webpack_require__("C8U/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_216e46dc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Solutions_vue__ = __webpack_require__("HHku");
function injectStyle (ssrContext) {
  __webpack_require__("1fK9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-216e46dc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Solutions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_216e46dc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Solutions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Z4Nb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZISC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__remove_polyfill__ = __webpack_require__("AR89");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__remove_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__remove_polyfill__);

//
//
//
//
//
//
//
//
//
//
//




/**
 * Get the dimensions of `$ele` ele.
 * @param {HTMLElement} $ele
 * @return {object} Object with `width` and `height` properties.
 */
function getSize($ele) {
  var $clone = $ele.cloneNode(true);
  var size = {};

  $clone.style.display = 'block';
  $clone.style.visibility = 'hidden';
  $clone.style.position = 'absolute';
  $ele.parentNode.insertBefore($clone, $ele);
  size.width = $clone.offsetWidth;
  size.height = $clone.offsetHeight;
  $clone.remove();

  return size;
}

/**
 * Set dropdown position.
 * @param {HTMLElement} $link - Html element will show the dropdown when it is pressed.
 * @param {HTMLElement} $dd - Dropdown html element.
 * @param {array} position - Dropdown position.
 */
function _setPosition($link, $dd, position, margin) {
  var refSize = getSize($link);
  var cornerPos = {};
  var outStyle = {};
  var origin = {};

  var _position = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(position, 4),
      p1 = _position[0],
      p2 = _position[1],
      p3 = _position[2],
      p4 = _position[3];

  var rect = $link.getBoundingClientRect();
  var refPos = { top: 0, left: 0 };
  var dpSize = getSize($dd);
  var parentPosition = document.defaultView.getComputedStyle($link.offsetParent).position;

  switch (parentPosition.toLowerCase()) {
    case 'fixed':
      refPos.left = rect.left - $link.offsetParent.offsetLeft;
      refPos.top = rect.top - $link.offsetParent.offsetTop;
      break;

    case 'absolute':
      var parentRect = $link.offsetParent.getBoundingClientRect();
      refPos.left = rect.left - parentRect.left;
      refPos.top = rect.top - parentRect.top;
      break;

    default:
      refPos.left = rect.left - $link.offsetParent.offsetLeft + window.pageXOffset;
      refPos.top = rect.top - $link.offsetParent.offsetTop + window.pageYOffset;
  }

  cornerPos.left = refPos.left;
  switch (p1) {
    case 'center':
      cornerPos.left += refSize.width / 2;
      break;

    case 'right':
      cornerPos.left += refSize.width;
      break;
  }

  cornerPos.top = refPos.top;
  switch (p2) {
    case 'center':
      cornerPos.top += refSize.height / 2;
      break;
    case 'bottom':
      cornerPos.top += refSize.height;
      break;
  }

  switch (p3) {
    case 'left':
      outStyle.left = Math.round(cornerPos.left);
      origin.left = 'left';
      break;

    case 'center':
      outStyle.left = Math.round(cornerPos.left - dpSize.width / 2);
      origin.left = 'center';
      break;

    default:
      outStyle.left = Math.round(cornerPos.left - dpSize.width);
      origin.left = 'right';
  }

  switch (p4) {
    case 'top':
      outStyle.top = Math.round(cornerPos.top);
      origin.top = 'top';
      break;

    case 'center':
      outStyle.top = Math.round(cornerPos.top - dpSize.height / 2);
      origin.top = 'center';
      break;

    default:
      outStyle.top = Math.round(cornerPos.top - dpSize.height);
      origin.top = 'bottom';
  }

  outStyle.left = outStyle.left + margin[0] + 'px';
  outStyle.top = outStyle.top + margin[1] + 'px';
  outStyle.transformOrigin = origin.left + ' ' + origin.top;
  outStyle.position = 'absolute';
  return outStyle;
}

var getWindow = function getWindow() {
  return window.document;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VueMyDropdown',

  data: function data() {
    return {
      ddStyle: {}
    };
  },


  props: {
    // Dropdown visibility.
    visible: {
      required: true,
      type: Boolean
    },

    // Dropdown position.
    position: {
      required: false,
      type: Array,
      default: function _default() {
        return ['right', 'top', 'left', 'top'];
      }
    },

    // Dropdown animation.
    animation: {
      required: false,
      type: String,
      default: 'ani-slide'
    }
  },

  methods: {
    open: function open() {
      var _this = this;

      this.setPosition();
      getWindow().addEventListener('resize', this.resizeEvent);
      setTimeout(function () {
        return getWindow().addEventListener('click', _this.clickOutEvent);
      }, 10);
    },
    close: function close() {
      getWindow().removeEventListener('resize', this.resizeEvent);
      getWindow().removeEventListener('click', this.clickOutEvent);
    },
    resizeEvent: function resizeEvent() {
      this.setPosition();
    },
    clickOutEvent: function clickOutEvent(evt) {
      var $dd = this.$el.children[1];
      if (evt.target !== $dd && !$dd.contains(evt.target)) {
        this.$emit('clickout', evt);
      }
    },
    setPosition: function setPosition() {
      var $link = this.$el.children[0];
      var $dd = this.$el.children[1];
      this.ddStyle = _setPosition($link, $dd, this.position, [0, 0]);
      this.$emit('positioned', this.ddStyle);
    }
  },

  watch: {
    visible: function visible(isVisible) {
      if (isVisible) {
        this.open();
      } else {
        this.close();
      }
    }
  },

  mounted: function mounted() {
    if (this.visible) {
      this.open();
    }
  },
  destroyed: function destroyed() {
    getWindow().removeEventListener('resize', this.resizeEvent);
    getWindow().removeEventListener('click', this.clickOutEvent);
  }
});

/***/ }),

/***/ "ZYdp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Account",
  data: function data() {
    return {
      gender_options: ["Male", "Female", "Others", "Prefer not to say"],
      form: {
        full_name: "",
        date_of_birth: "",
        gender: "",
        email: "",
        mobile: "",
        address: "",
        college: "",
        is_currently_working: "",
        organization: "",
        entrance_exam: "",
        contactable_by_admin: "",
        receive_notifications: ""
      },
      form_password: {
        old_password: "",
        new_password: "",
        new_password_repeat: ""
      }
    };
  },
  computed: {
    user_info: function user_info() {
      return this.$store.getters.user;
    },
    calculated_credits: function calculated_credits() {
      if (this.user_info.credits.credit != null) {
        if (this.user_info.credits.debit != null) {
          return parseFloat(this.user_info.credits.credit) - parseFloat(this.user_info.credits.debit);
        } else return parseFloat(this.user_info.credits.credit);
      } else {
        return 0;
      }
    }
  },
  mounted: function mounted() {
    this.$store.dispatch('fetch_user_transactions');
    this.form.full_name = this.user_info.full_name;
    if (this.user_info.date_of_birth != null && this.user_info.date_of_birth != "") {
      this.form.date_of_birth = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.user_info.date_of_birth).format("YYYY-MM-DD");
    }

    this.form.gender = this.user_info.gender;
    this.form.address = this.user_info.address;
    this.form.college = this.user_info.college;
    this.form.is_currently_working = this.user_info.is_currently_working;
    this.form.organization = this.user_info.organization;
    this.form.entrance_exam = this.user_info.entrance_exam;
    this.form.contactable_by_admin = this.user_info.contactable_by_admin;
    this.form.receive_notifications = this.user_info.receive_notifications;
  },

  methods: {
    execute_save_profile: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.$store.commit("setLoader", true);
                _context.next = 3;
                return this.$store.dispatch("save_profile", this.form);

              case 3:
                result = _context.sent;

                this.$toasted.show("Profile Saved", { type: "success" });
                this.$store.commit("setLoader", false);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function execute_save_profile() {
        return _ref.apply(this, arguments);
      }

      return execute_save_profile;
    }(),
    get_human_date: function get_human_date(d) {
      var mom = __WEBPACK_IMPORTED_MODULE_2_moment___default()(d);
      return mom.format('LL');
    },

    execute_save_password: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(this.form_password.new_password != this.form_password.new_password_repeat)) {
                  _context2.next = 3;
                  break;
                }

                this.$toasted.show("Please make sure that the Password and Repeat Password match", { type: "error" });
                return _context2.abrupt("return");

              case 3:

                this.$store.commit("setLoader", true);
                _context2.prev = 4;
                _context2.next = 7;
                return this.$store.dispatch("save_password", this.form_password);

              case 7:
                result = _context2.sent;

                this.$toasted.show("Password Updated", { type: "success" });
                _context2.next = 14;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](4);

                this.$toasted.show("Could not save password", { type: "error" });

              case 14:

                this.$store.commit("setLoader", false);

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 11]]);
      }));

      function execute_save_password() {
        return _ref2.apply(this, arguments);
      }

      return execute_save_password;
    }()
  }
});

/***/ }),

/***/ "acLP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"StudyMaterial"}},[_c('h3',[_vm._v(_vm._s(_vm.$route.params.tag)+" Material")]),_vm._v(" "),_c('div',{staticClass:"material-wrapper"},_vm._l((_vm.study_material),function(material){return _c('div',{key:material.key,staticClass:"material-section"},[_c('h5',[_vm._v(_vm._s(material.title))]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",staticStyle:{"margin-top":"20px"},on:{"click":function($event){return _vm.open(material.id, material.title)}}},[_vm._v("Open")])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ag1D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Recaptcha_vue__ = __webpack_require__("mzy0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e42a3da2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Recaptcha_vue__ = __webpack_require__("Hywn");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Recaptcha_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e42a3da2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Recaptcha_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "b+Dw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "PackageView",
  data: function data() {
    return {
      msg: "Welcome to QdsPro",
      form: {
        qtitle: "",
        selected: null,
        doubt: ""
      },
      show_buy_package_screen: true, //show buy_package screen by default
      selected_package: {},
      buy_package_id: '',
      transaction_success: false, // show transaction success screen
      transaction_summary: {
        payment_id: '',
        transaction: ''
      }
    };
  },
  mounted: function mounted() {
    this.$store.dispatch("fetch_packages");
  },

  methods: {
    onSubmit: function onSubmit() {
      console.log("submitted");
      this.$router.push("/dashboard");
    },
    capture_payment: function capture_payment(razorpay_response) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var razorpay_payment_id, result, result2;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                razorpay_payment_id = razorpay_response.razorpay_payment_id;
                _context.prev = 1;

                _this.$store.commit('setLoader', true);
                _context.next = 5;
                return _this.$store.dispatch('capture_payment', { razorpay_payment_id: razorpay_payment_id, package_id: _this.buy_package_id });

              case 5:
                result = _context.sent;


                _this.transaction_summary = result.data.data;

                _context.next = 9;
                return _this.$store.dispatch('fetch_me');

              case 9:
                result2 = _context.sent;


                _this.show_buy_package_screen = false;
                _this.transaction_success = true;

                _this.$store.commit('setLoader', false);

                _context.next = 18;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](1);

                _this.$toasted.show("We had a problem processing your transaction, please try again!");

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 15]]);
      }))();
    },
    buy_package: function buy_package(package_id) {
      this.buy_package_id = package_id;
      var rzp_options = {
        key: "rzp_live_oZ13b2cVYTIpGt",
        amount: this.current_package.cost * 100,
        name: "QdsPro",
        description: "Buy Package " + this.current_package.name,
        handler: this.capture_payment,
        theme: {
          color: "#77bf43"
        }
      };

      var rzp1 = new Razorpay(rzp_options);
      rzp1.open();
    }
  },
  computed: {
    packages: function packages() {
      return this.$store.getters.get_packages;
    },
    user_info: function user_info() {
      return this.$store.getters.user;
    },
    current_package: function current_package() {
      var package_id = this.$route.params.id;

      //return this.$route.params.id;
      return _.find(this.packages, { id: Number(package_id) });
    },
    calculated_credits: function calculated_credits() {
      if (this.user_info.credits.credit != null) {
        if (this.user_info.credits.debit != null) {
          return parseFloat(this.user_info.credits.credit) - parseFloat(this.user_info.credits.debit);
        } else return parseFloat(this.user_info.credits.credit);
      } else {
        return 0;
      }
    }
  }
});

/***/ }),

/***/ "cZyn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_vm._v(" "),(_vm.global_loader)?_c('div',{attrs:{"id":"global_loader"}},[_c('div',{staticClass:"loader loader--style1",staticStyle:{"text-align":"center"},attrs:{"title":"Loading"}},[_c('svg',{attrs:{"version":"1.1","id":"loader-1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"40px","height":"40px","viewBox":"0 0 40 40","enable-background":"new 0 0 40 40","xml:space":"preserve"}},[_c('path',{attrs:{"opacity":"0.2","fill":"#000","d":"M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946\n        s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634\n        c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0\n        C22.32,8.481,24.301,9.057,26.013,10.047z"}},[_c('animateTransform',{attrs:{"attributeType":"xml","attributeName":"transform","type":"rotate","from":"0 20 20","to":"360 20 20","dur":"0.5s","repeatCount":"indefinite"}})],1)]),_vm._v(" "),_c('p',[_vm._v("Please wait")])])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dUGO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('QDSCard',{staticClass:"text-center qds-share",on:{"click":_vm.copy_to_clipboard}},[_c('img',{staticClass:"refer-icon",attrs:{"src":"data:image/svg+xml;utf8;base64,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"}}),_vm._v(" "),_c('h3',[_vm._v("Refer your Friends!")]),_vm._v(" "),_c('p',[_vm._v("Get 2 doubts free for every friend that joins QDS Pro with your Referral Code:")]),_vm._v(" "),_c('h4',{on:{"click":_vm.copy_to_clipboard}},[_vm._v(_vm._s(_vm.referral_code))]),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('div',{staticClass:"actionable"},[_c('a',{attrs:{"href":_vm.sms_link}},[_c('img',{attrs:{"src":"data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMS4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQ3MyA0NzMiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDQ3MyA0NzM7IiB4bWw6c3BhY2U9InByZXNlcnZlIiB3aWR0aD0iNTEycHgiIGhlaWdodD0iNTEycHgiPgo8Zz4KCTxnPgoJCTxwYXRoIGQ9Ik00MDMuNTgxLDY5LjNjLTQ0LjctNDQuNy0xMDQtNjkuMy0xNjcuMi02OS4zcy0xMjIuNSwyNC42LTE2Ny4yLDY5LjNjLTg2LjQsODYuNC05Mi40LDIyNC43LTE0LjksMzE4ICAgIGMtNy42LDE1LjMtMTkuOCwzMy4xLTM3LjksNDJjLTguNyw0LjMtMTMuNiwxMy42LTEyLjEsMjMuMnM4LjksMTcuMSwxOC41LDE4LjZjNC41LDAuNywxMC45LDEuNCwxOC43LDEuNCAgICBjMjAuOSwwLDUxLjctNC45LDgzLjItMjcuNmMzNS4xLDE4LjksNzMuNSwyOC4xLDExMS42LDI4LjFjNjEuMiwwLDEyMS44LTIzLjcsMTY3LjQtNjkuM2M0NC43LTQ0LjcsNjkuMy0xMDQsNjkuMy0xNjcuMiAgICBTNDQ4LjI4MSwxMTQsNDAzLjU4MSw2OS4zeiBNMzg0LjQ4MSwzODQuNmMtNjcuNSw2Ny41LTE3Miw4MC45LTI1NC4yLDMyLjZjLTUuNC0zLjItMTIuMS0yLjItMTYuNCwyLjFjLTAuNCwwLjItMC44LDAuNS0xLjEsMC44ICAgIGMtMjcuMSwyMS01My43LDI1LjQtNzEuMywyNS40aC0wLjFjMjAuMy0xNC44LDMzLjEtMzYuOCw0MC42LTUzLjljMS4yLTIuOSwxLjQtNS45LDAuNy04LjdjLTAuMy0yLjctMS40LTUuNC0zLjMtNy42ICAgIGMtNzMuMi04Mi43LTY5LjQtMjA4LjcsOC44LTI4Ni45YzgxLjctODEuNywyMTQuNi04MS43LDI5Ni4yLDBDNDY2LjE4MSwxNzAuMSw0NjYuMTgxLDMwMi45LDM4NC40ODEsMzg0LjZ6IiBmaWxsPSIjMDAwMDAwIi8+CgkJPGNpcmNsZSBjeD0iMjM2LjM4MSIgY3k9IjIzNi41IiByPSIxNi42IiBmaWxsPSIjMDAwMDAwIi8+CgkJPGNpcmNsZSBjeD0iMzIxLjk4MSIgY3k9IjIzNi41IiByPSIxNi42IiBmaWxsPSIjMDAwMDAwIi8+CgkJPGNpcmNsZSBjeD0iMTUwLjc4MSIgY3k9IjIzNi41IiByPSIxNi42IiBmaWxsPSIjMDAwMDAwIi8+Cgk8L2c+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg=="}}),_vm._v("SMS\n          ")])]),_vm._v(" "),_c('div',{staticClass:"actionable"},[_c('a',{attrs:{"href":_vm.email_link}},[_c('img',{attrs:{"src":"data:image/svg+xml;utf8;base64,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"}}),_vm._v("Email")])]),_vm._v(" "),_c('div',{staticClass:"actionable"},[_c('a',{attrs:{"href":_vm.whatsapp_link}},[_c('img',{attrs:{"src":"data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjUxMnB4IiBoZWlnaHQ9IjUxMnB4IiB2aWV3Qm94PSIwIDAgOTAgOTAiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDkwIDkwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPHBhdGggaWQ9IldoYXRzQXBwIiBkPSJNOTAsNDMuODQxYzAsMjQuMjEzLTE5Ljc3OSw0My44NDEtNDQuMTgyLDQzLjg0MWMtNy43NDcsMC0xNS4wMjUtMS45OC0yMS4zNTctNS40NTVMMCw5MGw3Ljk3NS0yMy41MjIgICBjLTQuMDIzLTYuNjA2LTYuMzQtMTQuMzU0LTYuMzQtMjIuNjM3QzEuNjM1LDE5LjYyOCwyMS40MTYsMCw0NS44MTgsMEM3MC4yMjMsMCw5MCwxOS42MjgsOTAsNDMuODQxeiBNNDUuODE4LDYuOTgyICAgYy0yMC40ODQsMC0zNy4xNDYsMTYuNTM1LTM3LjE0NiwzNi44NTljMCw4LjA2NSwyLjYyOSwxNS41MzQsNy4wNzYsMjEuNjFMMTEuMTA3LDc5LjE0bDE0LjI3NS00LjUzNyAgIGM1Ljg2NSwzLjg1MSwxMi44OTEsNi4wOTcsMjAuNDM3LDYuMDk3YzIwLjQ4MSwwLDM3LjE0Ni0xNi41MzMsMzcuMTQ2LTM2Ljg1N1M2Ni4zMDEsNi45ODIsNDUuODE4LDYuOTgyeiBNNjguMTI5LDUzLjkzOCAgIGMtMC4yNzMtMC40NDctMC45OTQtMC43MTctMi4wNzYtMS4yNTRjLTEuMDg0LTAuNTM3LTYuNDEtMy4xMzgtNy40LTMuNDk1Yy0wLjk5My0wLjM1OC0xLjcxNy0wLjUzOC0yLjQzOCwwLjUzNyAgIGMtMC43MjEsMS4wNzYtMi43OTcsMy40OTUtMy40Myw0LjIxMmMtMC42MzIsMC43MTktMS4yNjMsMC44MDktMi4zNDcsMC4yNzFjLTEuMDgyLTAuNTM3LTQuNTcxLTEuNjczLTguNzA4LTUuMzMzICAgYy0zLjIxOS0yLjg0OC01LjM5My02LjM2NC02LjAyNS03LjQ0MWMtMC42MzEtMS4wNzUtMC4wNjYtMS42NTYsMC40NzUtMi4xOTFjMC40ODgtMC40ODIsMS4wODQtMS4yNTUsMS42MjUtMS44ODIgICBjMC41NDMtMC42MjgsMC43MjMtMS4wNzUsMS4wODItMS43OTNjMC4zNjMtMC43MTcsMC4xODItMS4zNDQtMC4wOS0xLjg4M2MtMC4yNy0wLjUzNy0yLjQzOC01LjgyNS0zLjM0LTcuOTc3ICAgYy0wLjkwMi0yLjE1LTEuODAzLTEuNzkyLTIuNDM2LTEuNzkyYy0wLjYzMSwwLTEuMzU0LTAuMDktMi4wNzYtMC4wOWMtMC43MjIsMC0xLjg5NiwwLjI2OS0yLjg4OSwxLjM0NCAgIGMtMC45OTIsMS4wNzYtMy43ODksMy42NzYtMy43ODksOC45NjNjMCw1LjI4OCwzLjg3OSwxMC4zOTcsNC40MjIsMTEuMTEzYzAuNTQxLDAuNzE2LDcuNDksMTEuOTIsMTguNSwxNi4yMjMgICBDNTguMiw2NS43NzEsNTguMiw2NC4zMzYsNjAuMTg2LDY0LjE1NmMxLjk4NC0wLjE3OSw2LjQwNi0yLjU5OSw3LjMxMi01LjEwN0M2OC4zOTgsNTYuNTM3LDY4LjM5OCw1NC4zODYsNjguMTI5LDUzLjkzOHoiIGZpbGw9IiMwMDAwMDAiLz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8L3N2Zz4K"}}),_vm._v("Whatsapp")])])]),_vm._v(" "),(_vm.eligible_for_adding_referral_code)?_c('div',{staticStyle:{"margin-top":"60px","background-color":"white","padding":"20px","text-align":"left"}},[_c('h4',{staticStyle:{"color":"black"}},[_vm._v("Got someone's Referral Code?")]),_vm._v(" "),_c('p',{staticStyle:{"color":"black"}},[_vm._v("If you have someone's referral code, apply it here and give them 2 doubts free!")]),_vm._v(" "),_c('b-form-input',{attrs:{"placeholder":"Referral Code"},model:{value:(_vm.add_referral_code),callback:function ($$v) {_vm.add_referral_code=$$v},expression:"add_referral_code"}}),_vm._v(" "),_c('b-button',{staticClass:"btn query-btn button-touchy",staticStyle:{"margin-top":"20px","margin-left":"0","max-width":"100px"},attrs:{"variant":"primary"},on:{"click":_vm.apply_referral_code}},[_vm._v("Apply")])],1):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eglt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AddDoubt',
  data: function data() {
    return {
      msg: 'Welcome to QdsPro',
      form: {
        title: '',
        tags: 'Quant',
        description: '',
        attachment: null
      },
      upload: null,
      doubt_tags: ['Quant', 'DI', 'Verbal', 'Logic', 'GK', 'IR', 'AWA', 'Others']
    };
  },

  methods: {
    capitalize: function capitalize(s) {
      return s.charAt(0).toUpperCase() + s.slice(1);
    },
    onSubmit: function onSubmit() {
      console.log('submitted');
      this.$router.push('/dashboard');
    },
    addSymbol: function addSymbol(symbol) {
      this.form.description += symbol;
    },
    upload_change: function upload_change(val) {
      console.log('upload:', val);
    },
    execute_add_doubt: function execute_add_doubt() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var FR, result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this.form.title == '')) {
                  _context2.next = 3;
                  break;
                }

                _this.$toasted.show('Please enter the doubt title', { type: 'error' });
                return _context2.abrupt('return');

              case 3:

                // if(this.form.description == '') {
                //   this.$toasted.show('Please enter the doubt description',{type:'error'});
                //   return;
                // } 

                _this.$store.commit('setLoader', true);
                console.log(_this.upload);

                if (!(_this.upload != null)) {
                  _context2.next = 11;
                  break;
                }

                FR = new FileReader();


                FR.onload = function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(ev) {
                    var result;
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            console.log('file read success');
                            _this.form.attachment = btoa(ev.target.result);
                            _this.form.attachment_type = _this.upload.type;
                            _context.prev = 3;
                            _context.next = 6;
                            return _this.$store.dispatch('add_doubt', _this.form);

                          case 6:
                            result = _context.sent;

                            _this.$toasted.show('Doubt Added!', { type: 'success' });
                            _this.$store.commit('setLoader', false);
                            _this.$router.push('/dashboard/solutions');
                            _context.next = 16;
                            break;

                          case 12:
                            _context.prev = 12;
                            _context.t0 = _context['catch'](3);

                            _this.$store.commit('setLoader', false);
                            _this.$toasted.show(_context.t0.toString(), { type: 'error' });

                          case 16:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this, [[3, 12]]);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }();

                FR.readAsBinaryString(_this.upload);

                _context2.next = 23;
                break;

              case 11:
                _context2.prev = 11;
                _context2.next = 14;
                return _this.$store.dispatch('add_doubt', _this.form);

              case 14:
                result = _context2.sent;

                _this.$toasted.show('Doubt Added!', { type: 'success' });
                _this.$store.commit('setLoader', false);
                _this.$router.push('/dashboard/solutions');
                _context2.next = 23;
                break;

              case 20:
                _context2.prev = 20;
                _context2.t0 = _context2['catch'](11);

                _this.$toasted.show(_context2.t0.toString(), { type: 'error' });

              case 23:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this, [[11, 20]]);
      }))();
    }
  }

});

/***/ }),

/***/ "f+Zx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Calculator"}},[_c('h3',[_vm._v("Calculator")]),_vm._v(" "),_c('div',{staticClass:"material-wrapper"},[_c('div',{staticClass:"material-section"},[_c('CalculatorComponent')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "f5ne":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Card__ = __webpack_require__("rhdv");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Share',
    data: function data() {
        return {
            add_referral_code: ''
        };
    },
    components: {
        QDSCard: __WEBPACK_IMPORTED_MODULE_2__Card__["a" /* default */]
    },
    methods: {
        copy_to_clipboard: function copy_to_clipboard() {},
        apply_referral_code: function apply_referral_code() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var result;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.$store.commit('setLoader', true);
                                _context.next = 3;
                                return _this.$store.dispatch('apply_referral_code', _this.add_referral_code);

                            case 3:
                                result = _context.sent;
                                _context.next = 6;
                                return _this.$store.dispatch('fetch_me');

                            case 6:
                                _this.$store.commit('setLoader', false);
                                if (result == true) {
                                    _this.$toasted.show('Added Referral Code!', { type: 'success' });
                                } else {
                                    _this.$toasted.show('There was an error, try again?', { type: 'error' });
                                }

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    },
    computed: {
        user_info: function user_info() {
            return this.$store.getters.user;
        },
        referral_code: function referral_code() {
            return this.user_info.referral_code;
        },
        sms_link: function sms_link() {
            return "sms:?&body=Join QDS Pro, online doubt solving platform for CAT/GRE/GMAT. Click here: https://qdspro.app.link/i1DL84MAOU and Use my referral link: " + this.referral_code;
        },
        email_link: function email_link() {
            return "mailto:?Subject=Join QDS Pro, online doubt solving platform for CAT/GRE/GMAT.&body=Hi, Signup for QDS Pro https://qdspro.app.link/i1DL84MAOU and Use my referral code: " + this.referral_code;
        },
        whatsapp_link: function whatsapp_link() {
            return "whatsapp://send?text=Join QDS Pro, online doubt solving platform for CAT/GRE/GMAT.&body=Hi, Signup for QDS Pro https://qdspro.app.link/i1DL84MAOU and Use my referral code: " + this.referral_code;
        },
        eligible_for_adding_referral_code: function eligible_for_adding_referral_code() {

            if (this.user_info.is_referral_code_used == 'no') {
                return true;
            } else return false;
        }
    }
});

/***/ }),

/***/ "gV9H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"package-wrapper",attrs:{"id":"History"}},[_c('div',{staticClass:"add-query"},[_c('h2',[_vm._v("Packages")]),_vm._v(" "),_c('b-container',{staticClass:"package-container",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('div',{staticClass:"package-item"},[_c('h3',{staticClass:"package-head"},[_vm._v("Newbie")]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('b',[_vm._v("Q:")]),_vm._v(" "),_c('span',[_vm._v("200")])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"12"}},[_c('b',[_vm._v("R:")]),_vm._v(" "),_c('span',[_vm._v("5000/-")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('b',[_vm._v("Add on:")]),_vm._v(" "),_c('p',[_vm._v("- Tables upto 250")]),_vm._v(" "),_c('p',[_vm._v("- Squares upto 250")]),_vm._v(" "),_c('p',[_vm._v("- Cubes upto 250")]),_vm._v(" "),_c('p',[_vm._v("- Unit Sheet")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('b',[_vm._v("Description")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\ntempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,\nquis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\nconsequat. Duis aute irure dolor in reprehenderit in voluptate velit esse\ncillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non\nproident, sunt in culpa qui officia deserunt mollit anim id est laborum.")])])],1),_vm._v(" "),_c('b-button',{staticClass:"query-btn",attrs:{"to":"#","variant":"primary"}},[_vm._v("Know More")])],1)])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gdfi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gii/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hDuT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hydq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'History',
  data: function data() {
    return {
      msg: 'Welcome to QdsPro',
      loader: true
    };
  },

  computed: {
    packages: function packages() {
      return this.$store.getters.user_packages;
    }
  },
  mounted: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var action;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.loader = true;
              _context.next = 3;
              return this.$store.dispatch('fetch_user_packages');

            case 3:
              action = _context.sent;

              this.loader = false;

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _ref.apply(this, arguments);
    }

    return mounted;
  }(),
  methods: {
    onSubmit: function onSubmit() {
      console.log('submitted');
      this.$router.push('/dashboard');
    }
  }
});

/***/ }),

/***/ "i7lk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Loader_vue__ = __webpack_require__("wd27");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Support',
	components: {
		Loader: __WEBPACK_IMPORTED_MODULE_0__Loader_vue__["a" /* default */]
	},
	data: function data() {
		return {
			loading: true
		};
	},
	computed: {
		me: function me() {
			return this.$store.getters.user;
		}
	},
	mounted: function mounted() {
		var _this = this;

		this.loading = true;

		zE('webWidget', 'identify', {
			name: this.me.full_name,
			email: this.me.email
		});

		var inter = setInterval(function () {
			if (typeof window.zE !== 'undefined') {
				_this.loading = false;
				zE('webWidget', 'show');
				zE('webWidget', 'open');
				clearInterval(inter);
			}
		}, 100);
	},
	beforeDestroy: function beforeDestroy() {
		zE('webWidget', 'hide');
		zE('webWidget', 'close');
	}
});

/***/ }),

/***/ "l90R":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mf29":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var convert = __webpack_require__("GXWi");

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'UnitConvertor',
	data: function data() {
		return {
			area: 'length',
			selected_possibility: '',
			selected_possibility2: '',
			convertFrom: 0
		};
	},
	mounted: function mounted() {
		console.log(convert(1).from('l').to('ml'));
	},

	computed: {
		areas: function areas() {
			return convert().measures();
		},
		possibilities: function possibilities() {
			return convert().possibilities(this.area);
		},
		convertTo: function convertTo() {
			var p = 0;
			if (this.selected_possibility != '' && this.selected_possibility2 != '') {
				p = convert(this.convertFrom).from(this.selected_possibility).to(this.selected_possibility2);
			}

			return p;
		}

	},
	methods: {
		capitalize: function capitalize(s) {
			return s.charAt(0).toUpperCase() + s.slice(1);
		}
	},
	watch: {
		area: function area() {

			this.selected_possibility = this.possibilities[0];
			this.selected_possibility2 = this.possibilities[1];
		}
	}

});

/***/ }),

/***/ "mzy0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Recaptcha',
  data: function data() {
    return {
      sitekey: '6LeJGnYUAAAAADDNXe64nH1zxbNJR3wOvb-AtWKd',
      sitekey_test: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
      widgetId: 0
    };
  },

  methods: {
    execute: function execute() {
      window.grecaptcha.execute(this.widgetId);
    },
    reset: function reset() {
      window.grecaptcha.reset(this.widgetId);
    },
    render: function render() {
      var _this = this;

      if (window.grecaptcha) {
        this.widgetId = window.grecaptcha.render('g-recaptcha', {
          sitekey: this.sitekey,
          size: 'invisible',
          // the callback executed when the user solve the recaptcha
          callback: function callback(response) {
            // emit an event called verify with the response as payload
            _this.$emit('verify', response);
            // reset the recaptcha widget so you can execute it again
            _this.reset();
          }
        });
      }
    }
  },
  mounted: function mounted() {
    // render the recaptcha widget when the component is mounted
    this.render();
  }
});

/***/ }),

/***/ "nKb+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  data: function data() {
    return {
      msg: 'Welcome to QdsPro',
      form: {
        email: '',
        password: ''
      }
    };
  },

  methods: {
    onEnter: function onEnter() {
      console.log('entered');
    },
    onSubmit: function onSubmit() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var credentials, result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('submitted');

                credentials = {
                  email: _this.form.email,
                  password: _this.form.password
                };
                _context.next = 4;
                return _this.$store.dispatch('login', credentials);

              case 4:
                result = _context.sent;


                console.log('got result', result);

                if (result.status != "success") {
                  _this.$toasted.show("Uh Oh, that's not right!");
                } else {
                  _this.$toasted.show('Login Successful', { type: 'success' });
                  _this.$router.push('/dashboard');
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    checkKey: function checkKey(e) {
      console.log('k', e);
    }
  },
  created: function created() {

    var user = this.$store.getters.user;

    if (user.is_logged_in) {
      this.$router.replace('/dashboard');
    }
  }
});

/***/ }),

/***/ "nuHT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello bg-light",attrs:{"id":"login"}},[_c('div',{attrs:{"id":"login_wrapper"}},[_c('b-container',{staticClass:"margin-auto rounded",attrs:{"id":"hero"}},[_c('b-row',[_c('b-col',{staticClass:"logo-col hero-col",attrs:{"sm":"12","lg":"6"}},[_c('div',{staticClass:"qds-logo",attrs:{"id":"art"}},[_c('a',{attrs:{"href":"#"}},[_c('img',{staticClass:"img-fluid",attrs:{"src":"static/logo.png"}})])])]),_vm._v(" "),_c('b-col',{staticClass:"bg-green ctl center hero-col",attrs:{"sm":"12","lg":"6"}},[_c('div',{attrs:{"id":"the_form"}},[_c('h1',{staticStyle:{"margin-bottom":"2rem"}},[_vm._v("Forgot Password?")]),_vm._v(" "),_c('p',[_vm._v("We will email you a link to reset your password.")]),_vm._v(" "),_c('b-form',{on:{"submit":_vm.onSubmit}},[_c('b-form-group',{attrs:{"id":"exampleInputGroup1","label":"","label-for":"exampleInput1","description":""}},[_c('b-form-input',{attrs:{"id":"exampleInput1","type":"email","required":"","placeholder":"Enter email"},model:{value:(_vm.form.email),callback:function ($$v) {_vm.$set(_vm.form, "email", $$v)},expression:"form.email"}})],1),_vm._v(" "),_c('b-button',{staticClass:"btn-blue",attrs:{"size":"lg","variant":"primary"},on:{"click":_vm.onSubmit}},[_vm._v("Send Reset Link")]),_c('br'),_c('br')],1)],1)])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oNaf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"utilities"}},[_c('div',{staticClass:"material-wrapper"},[_c('div',{staticClass:"material-section"},[_c('img',{staticStyle:{"display":"block","width":"64px"},attrs:{"src":"/static/calculator.png"}}),_vm._v(" "),_c('h5',[_vm._v("Calculator")]),_vm._v(" "),_c('p',[_vm._v("A Standard Calculator")]),_vm._v(" "),_c('b-link',{staticClass:"btn btn-primary",staticStyle:{"margin-top":"20px"},attrs:{"to":"/dashboard/calculator"}},[_vm._v("Open")])],1),_vm._v(" "),_c('div',{staticClass:"material-section"},[_c('img',{staticStyle:{"display":"block","width":"64px"},attrs:{"src":"/static/reload.png"}}),_vm._v(" "),_c('h5',[_vm._v("Unit Convertor")]),_vm._v(" "),_c('p',[_vm._v("Easily convert units from Area, Mass, Power, Force, etc.")]),_vm._v(" "),_c('b-link',{staticClass:"btn btn-primary",staticStyle:{"margin-top":"20px"},attrs:{"to":"/dashboard/unit-convertor"}},[_vm._v("Open")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pMZz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hello',
  data: function data() {
    return {
      msg: 'Welcome to QdsPro'
    };
  }
});

/***/ }),

/***/ "pMth":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CalculatorComponent_vue__ = __webpack_require__("10qD");


//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Calculator',
	data: function data() {
		return {
			status: 'Checking...'
		};
	},
	computed: {},
	mounted: function mounted() {
		var _this = this;

		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, _this);
		}))();
	},

	methods: {},
	components: {
		CalculatorComponent: __WEBPACK_IMPORTED_MODULE_2__CalculatorComponent_vue__["a" /* default */]
	}
});

/***/ }),

/***/ "pnwR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddDoubt_vue__ = __webpack_require__("eglt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10f75252_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddDoubt_vue__ = __webpack_require__("Im3m");
function injectStyle (ssrContext) {
  __webpack_require__("YEjl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-10f75252"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddDoubt_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10f75252_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddDoubt_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "psOb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signup_vue__ = __webpack_require__("OBXJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d4c9785_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signup_vue__ = __webpack_require__("TKgh");
function injectStyle (ssrContext) {
  __webpack_require__("uOpw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5d4c9785"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d4c9785_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qSdX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__ = __webpack_require__("pMZz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_524c8a34_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__ = __webpack_require__("6vGk");
function injectStyle (ssrContext) {
  __webpack_require__("sB3R")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-524c8a34"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_524c8a34_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qb6w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qbq7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rAXC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Overview"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rhdv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Card_vue__ = __webpack_require__("NU23");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d3361dd0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Card_vue__ = __webpack_require__("VDl6");
function injectStyle (ssrContext) {
  __webpack_require__("l90R")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d3361dd0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Card_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d3361dd0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sB3R":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sUdf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sdDm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Dashboard"}},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('transition',{attrs:{"name":"slide"}},[(_vm.main_nav_visibility)?_c('b-col',{staticClass:"bg-blue",attrs:{"id":"main_nav","sm":"12"}},[_c('div',{staticClass:"only-desktop"},[_c('img',{staticClass:"scale",staticStyle:{"display":"block","transform":"scale(0.8)"},attrs:{"src":"/static/logo.png"}})]),_vm._v(" "),_c('div',{staticClass:"only-mobile",attrs:{"id":"mobile_user_info"}},[_c('div',{staticClass:"close",on:{"click":function($event){_vm.main_nav_visibility=false}}},[_c('font-awesome-icon',{staticStyle:{"color":"white"},attrs:{"icon":['far', 'times-circle']}})],1),_vm._v(" "),_c('div',{staticClass:"user_pic"},[_c('img',{staticClass:"scale",attrs:{"src":"/static/re.png"}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center","justify-content":"center","flex-direction":"column"}},[_c('h3',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.user_info.full_name))]),_vm._v(" "),_c('div',{on:{"click":function($event){return _vm.goto('/dashboard/account')}}},[_c('b-link',{staticClass:"color-green",staticStyle:{"margin":"0 5px"},attrs:{"to":"/dashboard/account"}},[_vm._v("Your Account")])],1),_vm._v(" "),_c('b-link',{staticClass:"color-green",staticStyle:{"margin":"0 5px"},on:{"click":_vm.logout}},[_vm._v("Logout")])],1)]),_vm._v(" "),_c('b-container',{staticClass:"nav-main-link collapsible",attrs:{"fluid":""}},[_c('b-row',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse1",modifiers:{"collapse1":true}}],attrs:{"align-v":"center"}},[_c('b-col',{staticClass:"nav-icon",attrs:{"cols":"1"}},[_c('font-awesome-icon',{staticStyle:{"color":"white"},attrs:{"icon":"question-circle"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"9"}},[_c('h6',{staticClass:"collapsible-heading"},[_vm._v("Doubts")])]),_vm._v(" "),_c('b-col',{staticClass:"toggler",attrs:{"cols":"2"}},[_c('font-awesome-icon',{staticStyle:{"color":"white"},attrs:{"icon":"angle-up"}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-collapse',{staticClass:"mt-2",attrs:{"id":"collapse1"}},[_c('ul',{staticClass:"collapsible-ul"},[_c('li',[_c('div',{on:{"click":function($event){return _vm.goto('/dashboard/add-doubt')}}},[_c('b-link',{attrs:{"to":"/dashboard/add-doubt"}},[_vm._v("Add a doubt")])],1)]),_vm._v(" "),_c('li',[_c('div',{on:{"click":function($event){return _vm.goto('/dashboard/solutions')}}},[_c('b-link',{attrs:{"to":"/dashboard/solutions"}},[_vm._v("Solutions")])],1)])])])],1)],1)],1),_vm._v(" "),_c('b-container',{staticClass:"nav-main-link collapsible",attrs:{"fluid":""}},[_c('b-link',{staticClass:"row",attrs:{"align-v":"center"}},[_c('b-col',{staticClass:"nav-icon",attrs:{"cols":"1"}},[_c('font-awesome-icon',{staticStyle:{"color":"white"},attrs:{"icon":"book"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"9"}},[_c('div',{on:{"click":function($event){return _vm.goto('/dashboard/study-material')}}},[_c('b-link',{staticClass:"collapsible-heading",attrs:{"to":"/dashboard/study-material"}},[_vm._v("Study Material")])],1)]),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}})],1)],1),_vm._v(" "),_c('b-container',{staticClass:"nav-main-link collapsible",attrs:{"fluid":""}},[_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{staticClass:"nav-icon",attrs:{"cols":"1"}},[_c('font-awesome-icon',{staticStyle:{"color":"white"},attrs:{"icon":"sticky-note"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"9"}},[_c('div',{on:{"click":function($event){return _vm.goto('/dashboard/notepad')}}},[_c('b-link',{staticClass:"white-text",attrs:{"to":"/dashboard/notepad"}},[_vm._v("Notepad")])],1)]),_vm._v(" "),_c('b-col')],1)],1),_vm._v(" "),_c('b-container',{staticClass:"nav-main-link collapsible",attrs:{"fluid":""}},[_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{staticClass:"nav-icon",attrs:{"cols":"1"}},[_c('font-awesome-icon',{staticStyle:{"color":"white"},attrs:{"icon":"calculator"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"9"}},[_c('div',{on:{"click":function($event){return _vm.goto('/dashboard/utilities')}}},[_c('b-link',{staticClass:"white-text",attrs:{"to":"/dashboard/utilities"}},[_vm._v("Utilities")])],1)]),_vm._v(" "),_c('b-col')],1)],1),_vm._v(" "),_c('b-container',{staticClass:"nav-main-link collapsible",attrs:{"fluid":""}},[_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{staticClass:"nav-icon",attrs:{"cols":"1"}},[_c('font-awesome-icon',{staticStyle:{"color":"white"},attrs:{"icon":"at"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"9"}},[_c('div',{on:{"click":function($event){return _vm.goto('/dashboard/support')}}},[_c('b-link',{staticClass:"white-text",attrs:{"to":"/dashboard/support"}},[_vm._v("Live Support")])],1)]),_vm._v(" "),_c('b-col')],1)],1),_vm._v(" "),_c('b-container',{staticClass:"nav-main-link collapsible",attrs:{"fluid":""}},[_c('b-row',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse_packages",modifiers:{"collapse_packages":true}}],attrs:{"align-v":"center"}},[_c('b-col',{staticClass:"nav-icon",attrs:{"cols":"1"}},[_c('font-awesome-icon',{staticStyle:{"color":"white"},attrs:{"icon":"rupee-sign"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"9"}},[_c('h6',{staticClass:"collapsible-heading"},[_vm._v("Packages")])]),_vm._v(" "),_c('b-col',{staticClass:"toggler",attrs:{"cols":"2"}},[_c('font-awesome-icon',{staticStyle:{"color":"white"},attrs:{"icon":"angle-up"}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-collapse',{staticClass:"mt-2",attrs:{"id":"collapse_packages"}},[_c('ul',{staticClass:"collapsible-ul"},[_c('li',[_c('div',{on:{"click":function($event){return _vm.goto('/dashboard/packages')}}},[_c('b-link',{attrs:{"to":"/dashboard/packages"}},[_vm._v("Add new")])],1)]),_vm._v(" "),_c('li',[_c('div',{on:{"click":function($event){return _vm.goto('/dashboard/packages-history')}}},[_c('b-link',{attrs:{"to":"/dashboard/packages-history"}},[_vm._v("History")])],1)])])])],1)],1)],1),_vm._v(" "),_c('b-container',{staticClass:"nav-main-link collapsible",attrs:{"fluid":""}},[_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{staticClass:"nav-icon",attrs:{"cols":"1"}},[_c('font-awesome-icon',{staticStyle:{"color":"white"},attrs:{"icon":"graduation-cap"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"9"}},[_c('div',{on:{"click":function($event){return _vm.goto('/dashboard/career-counselling')}}},[_c('b-link',{staticClass:"white-text",attrs:{"to":"/dashboard/career-counselling"}},[_vm._v("Career Counselling")])],1)]),_vm._v(" "),_c('b-col')],1)],1),_vm._v(" "),_c('b-container',{staticClass:"nav-main-link collapsible",attrs:{"fluid":""}},[_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{staticClass:"nav-icon",attrs:{"cols":"1"}},[_c('font-awesome-icon',{staticStyle:{"color":"white"},attrs:{"icon":"share-alt"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"9"}},[_c('div',{on:{"click":function($event){return _vm.goto('/dashboard/share')}}},[_c('b-link',{staticClass:"white-text",attrs:{"to":"/dashboard/career-counselling"}},[_vm._v("Share")])],1)]),_vm._v(" "),_c('b-col')],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.tour_visible)?_c('div',{attrs:{"id":"welcome_tour"}},[_c('div',{staticClass:"pre-actions"},[_c('div',{staticClass:"close",on:{"click":function($event){return _vm.toggleTour()}}},[_c('font-awesome-icon',{staticStyle:{"color":"white"},attrs:{"icon":['far', 'times-circle']}})],1)]),_vm._v(" "),_c('div',{staticClass:"carousel-wrapper",staticStyle:{"margin-top":"60px","max-width":"800px","margin-left":"auto","margin-right":"auto"}},[_c('carousel',{attrs:{"perPage":"1","paginationActiveColor":"#77bf43","paginationSize":"8"}},[_c('slide',[_c('img',{staticStyle:{"height":"70vh","width":"auto","margin":"auto","display":"block"},attrs:{"src":"/static/welcometour/1.jpg"}})]),_vm._v(" "),_c('slide',[_c('img',{staticStyle:{"height":"70vh","width":"auto","margin":"auto","display":"block"},attrs:{"src":"/static/welcometour/2.jpg"}})]),_vm._v(" "),_c('slide',[_c('img',{staticStyle:{"height":"70vh","width":"auto","margin":"auto","display":"block"},attrs:{"src":"/static/welcometour/3.jpg"}})]),_vm._v(" "),_c('slide',[_c('img',{staticStyle:{"height":"70vh","width":"auto","margin":"auto","display":"block"},attrs:{"src":"/static/welcometour/4.jpg"}})])],1)],1)]):_vm._e()]),_vm._v(" "),_c('b-col',{attrs:{"id":"main_wrapper"}},[_c('div',{staticClass:"shadow-1",staticStyle:{"display":"flex"},attrs:{"id":"top_bar"}},[_c('font-awesome-icon',{staticClass:"icon",staticStyle:{"padding":"6px","display":"block","flex-basis":"13%","align-self":"center","height":"100%","max-width":"35px"},attrs:{"icon":"bars"},on:{"click":function($event){_vm.main_nav_visibility= !_vm.main_nav_visibility}}}),_vm._v(" "),_c('b-navbar',{staticStyle:{"flex-basis":"100%","padding-left":"0"},attrs:{"toggleable":"md"}},[_c('b-navbar-nav',{},[_c('img',{staticClass:"only-mobile",staticStyle:{"width":"80px","display":"block"},attrs:{"src":"/static/logo.png"}})]),_vm._v(" "),_c('b-navbar-nav',{staticClass:"ml-auto"},[_c('b-nav-item',{staticClass:"mobile-padding-10"},[_c('span',{staticStyle:{"display":"flex"},on:{"click":function($event){return _vm.toggleTour()}}},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":"info-circle"}})],1)]),_vm._v(" "),_c('b-nav-item',{staticClass:"mobile-padding-10"},[_c('b-dropdown',{staticClass:"top_bar_button",attrs:{"variant":"link","right":"","size":"lg","no-caret":""}},[_c('template',{slot:"button-content"},[_c('div',{staticClass:"icon-dropdown"},[_c('font-awesome-icon',{attrs:{"icon":['far', 'bell']}})],1)]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#","disabled":""}},[_vm._v("You have no notifications!")])],2)],1),_vm._v(" "),_c('b-nav-item',{staticClass:"only-desktop"},[_c('b-dropdown',{attrs:{"variant":"link","size":"lg","no-caret":""}},[_c('template',{staticClass:"top_bar_button",slot:"button-content"},[_c('div',{staticClass:"user_pic"},[_c('img',{staticClass:"scale",attrs:{"src":"/static/re.png"}})])]),_vm._v(" "),_c('b-dropdown-item',{staticClass:"color-green",attrs:{"to":"/dashboard/account"}},[_vm._v("Your Account")]),_vm._v(" "),_c('a',{staticClass:"normalish",on:{"click":_vm.logout}},[_vm._v("Logout")])],2)],1)],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"id":"main_content"}},[_c('router-view')],1),_vm._v(" "),_c('div',{attrs:{"id":"quick_toolbar"}},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"item",on:{"click":function($event){return _vm.goto('/dashboard/add-doubt')}}},[_c('b-link',{staticClass:"quick_toolbar_link",attrs:{"to":"/dashboard/add-doubt"}},[_c('font-awesome-icon',{attrs:{"icon":"question-circle"}}),_vm._v(" "),_c('p',[_vm._v("New Doubt")])],1)],1),_vm._v(" "),_c('div',{staticClass:"item",on:{"click":function($event){return _vm.goto('/dashboard/solutions')}}},[_c('b-link',{staticClass:"quick_toolbar_link",attrs:{"to":"/dashboard/solutions"}},[_c('span',{staticStyle:{"font-size":"1rem"}},[_vm._v("✓")]),_vm._v(" "),_c('p',[_vm._v("Solutions")])])],1),_vm._v(" "),_c('div',{staticClass:"item",on:{"click":function($event){return _vm.goto('/dashboard/study-material')}}},[_c('b-link',{staticClass:"quick_toolbar_link",attrs:{"to":"/dashboard/study-material"}},[_c('font-awesome-icon',{attrs:{"icon":"book"}}),_vm._v(" "),_c('p',[_vm._v("Study")])],1)],1),_vm._v(" "),_c('div',{staticClass:"item",on:{"click":function($event){return _vm.goto('/dashboard/notepad')}}},[_c('b-link',{staticClass:"quick_toolbar_link",attrs:{"to":"/dashboard/notepad"}},[_c('font-awesome-icon',{attrs:{"icon":"sticky-note"}}),_vm._v(" "),_c('p',[_vm._v("Notepad")])],1)],1)])])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tt9i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uExR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Loader'
});

/***/ }),

/***/ "uOpw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uZJy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"StudyMaterial"}},[_c('h3',[_vm._v("Study Material")]),_vm._v(" "),_c('div',{staticClass:"material-wrapper"},[_c('div',{staticClass:"material-section"},[_c('img',{staticStyle:{"display":"block","width":"64px"},attrs:{"src":"data:image/svg+xml;utf8;base64,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"}}),_vm._v(" "),_c('h5',[_vm._v("Quant Material")]),_vm._v(" "),_c('p',[_vm._v("Multiplication tables, squares, cubes.")]),_vm._v(" "),_c('b-link',{staticClass:"btn btn-primary",staticStyle:{"margin-top":"20px"},attrs:{"to":"/dashboard/study-material/Quant"}},[_vm._v("Access Material")])],1),_vm._v(" "),_c('div',{staticClass:"material-section"},[_c('img',{staticStyle:{"display":"block","width":"64px"},attrs:{"src":"data:image/svg+xml;utf8;base64,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"}}),_vm._v(" "),_c('h5',[_vm._v("Verbal Material")]),_vm._v(" "),_c('p',[_vm._v("Access Verbal Reasoning material")]),_vm._v(" "),_c('b-link',{staticClass:"btn btn-primary",staticStyle:{"margin-top":"20px"},attrs:{"to":"/dashboard/study-material/Verbal"}},[_vm._v("Access Material")])],1),_vm._v(" "),_c('div',{staticClass:"material-section"},[_c('img',{staticStyle:{"display":"block","width":"64px"},attrs:{"src":"data:image/svg+xml;utf8;base64,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"}}),_vm._v(" "),_c('h5',[_vm._v("DI Material")]),_vm._v(" "),_c('p',[_vm._v("Access Data, Graphs, Statistics related material")]),_vm._v(" "),_c('b-link',{staticClass:"btn btn-primary",staticStyle:{"margin-top":"20px"},attrs:{"disabled":"","to":"/dashboard/add-doubt"}},[_vm._v("Coming soon...")])],1),_vm._v(" "),_c('div',{staticClass:"material-section"},[_c('img',{staticStyle:{"display":"block","width":"64px"},attrs:{"src":"data:image/svg+xml;utf8;base64,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"}}),_vm._v(" "),_c('h5',[_vm._v("Logic Material")]),_vm._v(" "),_c('p',[_vm._v("Logic arguments, deductions, proofs.")]),_vm._v(" "),_c('b-link',{staticClass:"btn btn-primary",staticStyle:{"margin-top":"20px"},attrs:{"disabled":"","to":"/dashboard/add-doubt"}},[_vm._v("Coming soon...")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ume5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'History',
  data: function data() {
    return {
      msg: 'Welcome to QdsPro',
      loader: true
    };
  },

  computed: {
    packages: function packages() {
      return this.$store.getters.get_user_packages;
    }
  },
  mounted: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var action;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.loader = true;
              _context.next = 3;
              return this.$store.dispatch('fetch_user_packages');

            case 3:
              action = _context.sent;

              this.loader = false;

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _ref.apply(this, arguments);
    }

    return mounted;
  }(),
  methods: {
    onSubmit: function onSubmit() {
      console.log('submitted');
      this.$router.push('/dashboard');
    }
  }
});

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-SG": "oYA3",
	"./en-SG.js": "oYA3",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "uyGv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wI5S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PackagesHistory_vue__ = __webpack_require__("ume5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_716b4d8b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PackagesHistory_vue__ = __webpack_require__("CTNq");
function injectStyle (ssrContext) {
  __webpack_require__("zm8c")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-716b4d8b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PackagesHistory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_716b4d8b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PackagesHistory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wd27":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loader_vue__ = __webpack_require__("uExR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54077a43_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loader_vue__ = __webpack_require__("9jM+");
function injectStyle (ssrContext) {
  __webpack_require__("y2FH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-54077a43"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54077a43_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  computed: {
    global_loader: function global_loader() {
      return this.$store.getters.global_loader;
    }
  },
  created: function created() {
    var token = localStorage.getItem('token');
    if (token) {
      var user = {
        is_logged_in: true
      };
      console.log('user is logged in');
      this.$router.replace('/dashboard');
      this.$store.commit('setUser', user);
      this.$store.commit('setToken', token);
      zE('webWidget', 'hide');
    }
  }
});

/***/ }),

/***/ "xJsL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("nKb+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02e09c33_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("YGOY");
function injectStyle (ssrContext) {
  __webpack_require__("gii/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-02e09c33"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02e09c33_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "y2FH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zm8c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.81b36ed5a6ad5f2f154a.js